// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

html, body, #root {
  height: 100%;
  margin: 0;
  padding: 0;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: #1f2937;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Global smooth transitions - disabled for instant rendering */

/* No Assistant Message Styles */
.no-assistant-message {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.no-assistant-content {
  text-align: center;
  max-width: 500px;
  padding: 2rem;
  background: white;
  border-radius: 1rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.no-assistant-content h2 {
  color: #1f2937;
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.no-assistant-content p {
  color: #6b7280;
  margin-bottom: 0.5rem;
  line-height: 1.6;
}

.no-assistant-content p:last-child {
  margin-bottom: 0;
  font-style: italic;
  color: #4f46e5;
}

/* Override for specific elements that shouldn't have global transitions */
.message-text, .chat-input, input[type="text"], input[type="email"], input[type="password"], textarea {
  transition: border-color 0.3s, box-shadow 0.3s, background-color 0.3s;
}

/* App.css */
.login-container {
  display: flex;
  width: 100vw;       /* full width */
  height: 100vh;      /* full height */
  background: #f5f8fd;
  position: relative;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
}

.back-to-home-btn {
  position: absolute;
  top: 1rem;
  left: 1rem;
  background: #185adb !important;
  border: none !important;
  color: white !important;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  z-index: 1000;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 2px 8px rgba(24, 90, 219, 0.2);
}

.back-to-home-btn:hover {
  background: #1548b8 !important;
  color: white !important;
}

/* Simple centered login layout */
.login-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 450px;
  padding: 2rem;
}

.login-logo {
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
}

.login-logo .logo-img {
  max-height: 120px;
  width: auto;
  object-fit: contain;
}

.login-form-wrapper {
  width: 100%;
  background: #fff;
  padding: 2.5rem;
  border-radius: 1rem;
  box-shadow: 0 2px 24px rgba(24,90,219,0.08);
}

.login-form-wrapper h2 {
  margin-bottom: 24px;
  text-align: center;
  color: #1e293b;
  font-size: 1.75rem;
}

.login-form-wrapper input,
.login-form-wrapper form input {
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 16px;
  border: 1px solid #e3e8f0;
  border-radius: 8px;
  font-size: 1rem;
  box-sizing: border-box;
}

.login-form-wrapper input:focus {
  outline: none;
  border-color: #185adb;
  box-shadow: 0 0 0 3px rgba(24, 90, 219, 0.1);
}

.login-form-wrapper button[type="submit"],
.login-form-wrapper form button[type="submit"] {
  width: 100%;
  padding: 12px;
  background: #185adb;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;
  transition: background 0.2s;
}

.login-form-wrapper button[type="submit"]:hover:not(:disabled) {
  background: #1548b8;
}

.login-form-wrapper button[type="submit"]:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Keep old classes for backward compatibility but hide them */
.login-left {
  display: none;
}

.login-right {
  display: none;
}

.role-select {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.role-select button {
  border: 2px solid #e3e8f0;
  background: #f5f8fd;
  color: #185adb;
  border-radius: 10px;
  padding: 12px 18px;
  cursor: pointer;
  font-size: 1rem;
  min-width: 100px;
  transition: border 0.2s, background 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.role-select button.selected {
  border: 2px solid #185adb;
  background: #e3eefd;
  color: #185adb;
}

.role-select button.disabled {
  border: 2px solid #d1d5db;
  background: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}

.role-select button.disabled:hover {
  border: 2px solid #d1d5db;
  background: #f3f4f6;
  color: #9ca3af;
}

form {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
  margin-bottom: 16px;
}

.create-account-right form {
  margin-bottom: 24px;
}

input[type="email"], input[type="password"] {
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #e3e8f0;
  font-size: 1rem;
}

button[type="submit"] {
  background: #111827;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 8px;
  transition: all 0.15s ease;
}

button[type="submit"]:disabled {
  background: #a3bffa;
  cursor: not-allowed;
}

.oauth-divider {
  text-align: center;
  color: #888;
  margin: 16px 0 8px 0;
  width: 100%;
}

.oauth-btn {
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #e3e8f0;
  background: #fff;
  color: #222;
  font-size: 1rem;
  margin-bottom: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.2s, border 0.2s;
}

.oauth-btn.google {
  border-color: #ea4335;
  color: #ea4335;
}

.oauth-btn.google:hover {
  background: #ea4335;
  color: #1f2937;
}

.oauth-btn.microsoft {
  border-color: #4285f4;
  color: #4285f4;
}

.oauth-btn.microsoft:hover {
  background: #4285f4;
  color: #1f2937;
}

.signup-link {
  margin-top: 16px;
  color: #185adb;
}

.signup-link a {
  color: #185adb;
  text-decoration: underline;
  cursor: pointer;
}

@media (max-width: 900px) {
  .login-container {
    flex-direction: column;
    min-height: unset;
  }
  .login-left, .login-right {
    border-radius: 20px 20px 0 0;
    padding: 32px 16px;
    width: 100%;
  }
  .login-right {
    border-radius: 0 0 20px 20px;
  }
}

/* Import Inter font from Google Fonts */

/* Global font application */
*, *::before, *::after {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

/* Two-pane layout fix */
body, #root {
  height: 100vh;
  margin: 0;
  background: #f5f8fd;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Create Account Page Styles */
/* Centered Create Account layout (matching login page) */
.create-account-container {
  display: flex;
  width: 100vw;
  min-height: 100vh;
  height: auto;
  background: #f5f8fd;
  position: relative;
  box-sizing: border-box;
  justify-content: center;
  align-items: flex-start;
  padding: 1rem 0;
  overflow-y: auto;
}

.create-account-logo-top {
  position: absolute;
  top: 1.5rem;
  left: 2rem;
  z-index: 10;
  display: flex;
  align-items: center;
}

.create-account-logo-top .logo-img {
  max-height: 120px;
  width: auto;
  object-fit: contain;
}

.create-account-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 500px;
  padding: 2rem;
  margin-top: 2rem;
  overflow-y: visible;
}

/* Hide old logo inside content */
.create-account-logo {
  display: none;
}

.create-account-form-wrapper {
  width: 100%;
  background: #fff;
  padding: 2.5rem;
  border-radius: 1rem;
  box-shadow: 0 2px 24px rgba(24,90,219,0.08);
}

.create-account-form-wrapper h2 {
  margin-bottom: 8px;
  color: #185adb;
  text-align: center;
  font-size: 1.75rem;
}

/* Hide old left/right sections */
.create-account-left {
  display: none;
}

.create-account-right {
  display: none;
}

.create-account-form-wrapper .instruction-text {
  color: #666;
  margin-bottom: 24px;
  font-size: 0.9rem;
  text-align: center;
}

.form-group {
  margin-bottom: 16px;
  width: 100%;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #333;
}

.form-group input {
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #e3e8f0;
  font-size: 1rem;
  box-sizing: border-box;
}

.password-policy-box {
  background: #f0f8ff;
  border: 1px solid #185adb;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
}

.password-policy-box h4 {
  margin: 0 0 8px 0;
  color: #185adb;
  font-size: 0.8rem;
  font-weight: 600;
}

.password-policy-box ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.password-policy-box li {
  margin-bottom: 4px;
  font-size: 0.7rem;
  color: #666;
  position: relative;
  padding-left: 14px;
  line-height: 1.2;
}

.password-policy-box li:before {
  content: '•';
  position: absolute;
  left: 0;
  color: #999;
}

.password-policy-box li.valid {
  color: #059669;
}

.password-policy-box li.valid:before {
  content: '✓';
  color: #059669;
}

.password-policy-box li.invalid {
  color: #dc2626;
}

.password-policy-box li.invalid:before {
  content: '✗';
  color: #dc2626;
}

.error-message {
  color: #dc2626;
  font-size: 0.8rem;
  margin-top: 4px;
}

.button-group {
  display: flex;
  gap: 12px;
  margin-top: 16px;
  margin-bottom: 16px;
  width: 100%;
}

.button-group button {
  flex: 1 1;
  padding: 12px;
  border-radius: 8px;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}

.button-group button[type="submit"] {
  background: #185adb;
  color: #fff;
}

.button-group button[type="submit"]:disabled {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.cancel-btn {
  background: #6b7280 !important;
  color: #fff !important;
}

.login-link {
  margin-top: 16px;
  color: #185adb;
  text-align: center;
  width: 100%;
}

.login-link a {
  color: #185adb;
  text-decoration: underline;
  cursor: pointer;
}

/* Success Message Styles */
.success-message {
  text-align: center;
  padding: 20px 0;
  width: 100%;
}

.success-icon {
  font-size: 3rem;
  color: #059669;
  margin-bottom: 16px;
}

.success-message h2 {
  color: #059669;
  margin-bottom: 16px;
}

.success-message p {
  color: #666;
  margin-bottom: 12px;
  line-height: 1.5;
}

.email-notes {
  background: #f0f8ff;
  border: 1px solid #185adb;
  border-radius: 8px;
  padding: 16px;
  margin: 20px 0;
  text-align: left;
}

.email-notes p {
  margin-bottom: 8px;
  color: #185adb;
  font-weight: 600;
}

.email-notes ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.email-notes li {
  margin-bottom: 6px;
  font-size: 0.9rem;
  color: #666;
  position: relative;
  padding-left: 16px;
}

.email-notes li:before {
  content: '•';
  position: absolute;
  left: 0;
  color: #185adb;
}

.back-to-login-btn {
  background: #185adb;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 16px;
  transition: background 0.2s;
}

.back-to-login-btn:hover {
  background: #1e40af;
}

/* Dashboard Styles */
.dashboard-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: transparent;
}

.top-bar {
  background: #ffffff;
  border-bottom: 1px solid #f1f3f4;
  padding: 16px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
}

.top-bar-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* Mobile Menu Toggle - Hidden by default, shown on mobile */
.mobile-menu-toggle {
  display: none;
}

.logo {
  font-size: 24px;
  font-weight: 600;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  letter-spacing: -0.3px;
}

.dock-toggle-btn {
  background: #111827;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 160px;
  justify-content: center;
}

.dock-toggle-btn:hover {
  background: #1f2937;
}

.top-bar-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.subscription-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  color: #667eea;
  padding: 6px 14px;
  border-radius: 20px;
  border: 1.5px solid #667eea;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.subscription-badge:hover {
  background: rgba(102, 126, 234, 0.05);
  border-color: #764ba2;
  color: #764ba2;
}

.badge-icon {
  font-size: 1rem;
}

.badge-text {
  font-size: 0.875rem;
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  position: relative;
  z-index: 1001;
}

.user-profile:hover {
  background: #f3f4f6;
}

.user-avatar {
  font-size: 1.2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.user-name {
  font-weight: 500;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.dropdown-arrow {
  font-size: 0.8rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.user-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: #fff;
  border: 1px solid #e3e8f0;
  border-radius: 8px;
  padding: 8px 0;
  min-width: 120px;
  display: none;
  z-index: 1000;
}

.user-profile:hover .user-dropdown {
  display: block;
}

.user-dropdown button {
  width: 100%;
  padding: 8px 16px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  color: #333;
}

.user-dropdown button:hover {
  background: #f3f4f6;
}

.main-content {
  display: flex;
  flex: 1 1;
  overflow: hidden;
}

.sidebar {
  width: 280px;
  background: #ffffff;
  border-right: 1px solid #edeff1;
  padding: 8px 0;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}

.assistant-expand-btn {
  position: fixed;
  bottom: 24px;
  right: 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 16px;
  width: 64px;
  height: 64px;
  font-size: 28px;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1001;
  box-shadow: 0 6px 24px rgba(102, 126, 234, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(8px);
}

.assistant-expand-btn:hover {
  transform: scale(1.05) translateY(-2px);
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.5);
  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
}

/* Removed - button styling now handled inline in LegalAssistant component */

/* Removed the blue vertical line from sidebar */

/* PDF Merge Checkbox Styling */
.merge-checkbox-container {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.merge-checkbox-container:hover {
  background-color: rgba(24, 90, 219, 0.1);
}

.merge-checkbox {
  accent-color: #185adb !important;
  cursor: pointer !important;
  transform: scale(1.1);
  transition: transform 0.2s ease;
}

.merge-checkbox:hover {
  transform: scale(1.2);
}

.merge-hint {
  font-size: 10px;
  color: #6b7280;
  cursor: help;
  transition: color 0.2s ease;
}

.merge-checkbox-container:hover .merge-hint {
  color: #185adb;
}

/* Merge PDFs Button Styling */
.merge-pdfs-btn {
  background-color: #185adb !important;
  color: white !important;
  border: none !important;
  border-radius: 4px !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
  box-shadow: 0 2px 4px rgba(24, 90, 219, 0.2) !important;
}

.merge-pdfs-btn:hover {
  background-color: #1347b3 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 8px rgba(24, 90, 219, 0.3) !important;
}

.merge-pdfs-btn:active {
  transform: translateY(0) !important;
}

/* Delete Documents Button Styling */
.delete-documents-btn {
  background-color: #dc2626 !important;
  color: white !important;
  border: none !important;
  border-radius: 4px !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.2) !important;
}

.delete-documents-btn:hover {
  background-color: #b91c1c !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 8px rgba(220, 38, 38, 0.3) !important;
}

.delete-documents-btn:active {
  transform: translateY(0) !important;
}

.delete-documents-btn:disabled {
  background-color: #9ca3af !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
}

/* Delete Checkbox Styling */
.delete-checkbox-container {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.delete-checkbox-container:hover {
  background-color: rgba(220, 38, 38, 0.1);
}

.delete-checkbox {
  accent-color: #dc2626 !important;
  cursor: pointer !important;
  transform: scale(1.1);
  transition: transform 0.2s ease;
}

.delete-checkbox:hover {
  transform: scale(1.2);
}

.delete-hint {
  font-size: 10px;
  color: #6b7280;
  cursor: help;
  transition: color 0.2s ease;
}

.delete-checkbox-container:hover .delete-hint {
  color: #dc2626;
}

/* Download Documents Button Styling */
.download-documents-btn {
  background-color: #059669 !important;
  color: white !important;
  border: none !important;
  border-radius: 4px !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
  box-shadow: 0 2px 4px rgba(5, 150, 105, 0.2) !important;
}

.download-documents-btn:hover {
  background-color: #047857 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 8px rgba(5, 150, 105, 0.3) !important;
}

.download-documents-btn:active {
  transform: translateY(0) !important;
}

.download-documents-btn:disabled {
  background-color: #9ca3af !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
}

/* Download Checkbox Styling */
.download-checkbox-container {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.download-checkbox-container:hover {
  background-color: rgba(5, 150, 105, 0.1);
}

.download-checkbox {
  accent-color: #059669 !important;
  cursor: pointer !important;
  transform: scale(1.1);
  transition: transform 0.2s ease;
}

.download-checkbox:hover {
  transform: scale(1.2);
}

.download-hint {
  font-size: 10px;
  color: #6b7280;
  cursor: help;
  transition: color 0.2s ease;
}

.download-checkbox-container:hover .download-hint {
  color: #059669;
}

/* Bulk Delete Modal Styling */
.documents-to-delete {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 8px;
  margin: 12px 0;
  background-color: #f9fafb;
}

.document-to-delete {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-bottom: 1px solid #e5e7eb;
  background-color: #1f2937;
  border-radius: 4px;
  margin-bottom: 4px;
}

.document-to-delete:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.document-to-delete .document-icon {
  font-size: 16px;
  color: #6b7280;
}

.document-to-delete .document-info {
  flex: 1 1;
  min-width: 0;
}

.document-to-delete .document-info strong {
  display: block;
  font-size: 13px;
  color: #374151;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.document-to-delete .document-info small {
  display: block;
  font-size: 11px;
  color: #6b7280;
}

/* Simple Success Modal Styling */
.simple-success-modal {
  background: white;
  border-radius: 8px;
  padding: 20px;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease-out;
}

.simple-success-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.simple-success-icon {
  font-size: 32px;
  color: #10b981;
}

.simple-success-icon.error {
  color: #dc2626;
}

.simple-success-icon.download {
  color: #059669;
}

.simple-success-icon.downloading {
  color: #3b82f6;
}

.simple-success-message h4 {
  margin: 0;
  color: #374151;
  font-size: 16px;
  font-weight: 500;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.sidebar.collapsed {
  width: 60px;
  padding: 24px 0 24px 0;
  overflow: hidden;
}

.sidebar.collapsed .sidebar-toggle {
  left: 14px !important;
  background: #f8fafc !important;
}

.sidebar:not(.collapsed) .sidebar-toggle {
  position: absolute;
  top: 18px;
  right: 8px;
  left: auto !important;
  z-index: 10;
}

.sidebar-toggle {
  position: fixed;
  top: 80px;
  left: 260px;
  width: 32px;
  height: 32px;
  background: #f8fafc;
  color: #64748b;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  z-index: 103;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  transition: left 0.05s ease;
}

.sidebar-toggle:hover {
  background: #e2e8f0;
  color: #475569;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}

.sidebar-toggle:active {
  background: #cbd5e1;
}

.collapsed-nav {
  padding: 50px 8px 0 8px;
}

.collapsed-nav-section {
  margin-bottom: 24px;
}

.collapsed-nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: none;
  border: none;
  cursor: pointer;
  color: #878a8c;
  border-radius: 4px;
  margin: 2px auto;
  transition: all 0.15s ease;
  position: relative;
}

.collapsed-nav-item:hover {
  background: #f6f7f8;
  color: #1c1c1c;
}

.collapsed-nav-item.active {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);
  color: #667eea;
}

.collapsed-nav-item .nav-icon {
  font-size: 1rem;
}

.nav-section {
  margin-bottom: 24px;
}

.section-title {
  font-size: 0.75rem;
  font-weight: 700;
  color: #878a8c;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin: 16px 12px 8px 12px;
  padding: 0 40px 0 0;
  white-space: nowrap;
  width: 100%;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: calc(100% - 16px);
  margin: 1px 8px;
  padding: 10px 12px;
  background: none;
  border: none;
  cursor: pointer;
  color: #878a8c;
  text-align: left;
  transition: all 0.15s ease;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
}

.nav-item:hover {
  background: #f6f7f8;
  color: #1c1c1c;
}

.nav-item.active {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);
  color: #667eea;
  font-weight: 500;
}

.nav-item.disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
  position: relative;
}

.nav-item.disabled:hover {
  background: #f6f7f8;
  color: #878a8c;
}

.nav-blocked-indicator {
  font-size: 0.75rem;
  margin-left: auto;
  opacity: 0.7;
}

.collapsed-nav-item.disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.collapsed-nav-item.disabled:hover {
  background: #f6f7f8;
  color: #878a8c;
}

.nav-icon {
  font-size: 1rem;
  width: 20px;
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-label {
  font-weight: 400;
  font-size: 14px;
}

.content-area {
  flex: 1 1;
  padding: 24px 32px;
  overflow-y: auto;
  background: transparent;
  margin-top: 0;
}

.content-area.sidebar-collapsed {
  margin-left: 0;
  padding: 24px 32px;
}

.assistant-sidebar {
  position: fixed;
  top: 0;
  right: 0;
  width: auto;
  height: 100vh;
  background: transparent;
  border: none;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  box-shadow: none;
  padding: 0;
  margin: 0;
  transform: translateX(0);
  transition: transform 0.3s ease;
}

/* Case Dashboard Styles */
.case-dashboard h2 {
  margin-bottom: 24px;
  color: #333;
  font-size: 1.8rem;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.dashboard-container {
  margin-bottom: 32px;
}

.stats-bar {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)) !important;
  gap: 20px !important;
  margin-bottom: 32px !important;
  background: transparent !important;
  backdrop-filter: none !important;
  border-radius: 0 !important;
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  overflow: visible !important;
}



.stat-item:last-child {
  border-right: none !important;
}

.stat-item:hover {
  background: rgba(114, 137, 218, 0.08) !important;
}







.stat-item {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px;
  border-right: none;
}

.stat-item:last-child {
  border-right: none;
}

.stat-item:hover {
  background: rgba(114, 137, 218, 0.08);
}

.stat-card {
  background: linear-gradient(135deg, #ffffff 0%, #fefefe 100%);
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  border: 1px solid #f1f3f4;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.stat-icon {
  font-size: 1.8rem;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  border-radius: 8px;
  color: #667eea;
}

.stat-number {
  font-size: 1.8rem;
  font-weight: 600;
  color: #111827;
  line-height: 1;
}

.stat-label {
  color: #666;
  font-size: 0.9rem;
  margin-top: 4px;
}

.recent-cases {
  background: #fafafa;
  backdrop-filter: none;
  border-radius: 0 0 24px 24px;
  padding: 32px;
  border: none;
  border-top: none;
  box-shadow: none;
  margin-left: -32px;
  margin-right: -32px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-header h3 {
  margin: 0;
  color: #333;
  font-size: 1.3rem;
}

.search-bar {
  position: relative;
  display: flex;
  align-items: center;
}

.search-bar input {
  padding: 8px 12px 8px 36px;
  border: 1px solid #e3e8f0;
  border-radius: 8px;
  font-size: 0.9rem;
  width: 250px;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #666;
  font-size: 0.9rem;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.empty-icon {
  font-size: 4rem;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state h3 {
  margin: 0 0 8px 0;
  color: #333;
}

.empty-state p {
  margin: 0 0 24px 0;
}

.new-case-btn {
  background: #111827;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.new-case-btn:hover {
  background: #1f2937;
}

/* Dashboard action buttons styling */
.dashboard-action-btn {
  background: #f3f4f6 !important;
  color: #6b7280 !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 6px !important;
  padding: 8px 16px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  cursor: pointer !important;
  transition: all 0.15s ease !important;
}

.dashboard-action-btn:hover {
  background: #e5e7eb !important;
  color: #374151 !important;
  transform: translateY(-1px) !important;
}

.cases-table {
  overflow-x: visible;
  font-size: 0.8rem; /* Smaller font size for compact table */
  table-layout: fixed;
  border-radius: 16px;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.cases-table table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 16px;
  overflow: hidden;
}

.cases-table th {
  background: linear-gradient(135deg, rgba(114, 137, 218, 0.1) 0%, rgba(138, 109, 184, 0.1) 100%);
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  color: #667eea;
  border-bottom: 2px solid rgba(114, 137, 218, 0.2);
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.cases-table td {
  padding: 12px 8px;
  border-bottom: 1px solid rgba(114, 137, 218, 0.1);
  vertical-align: top;
  transition: background-color 0.15s ease;
  word-wrap: break-word;
  line-height: 1.4;
  white-space: normal;
}

/* Responsive column widths */
.cases-table th:nth-child(1), .cases-table td:nth-child(1) { width: 14%; } /* Case ID */
.cases-table th:nth-child(2), .cases-table td:nth-child(2) { width: 22%; } /* Client */
.cases-table th:nth-child(3), .cases-table td:nth-child(3) { width: 12%; } /* Type */
.cases-table th:nth-child(4), .cases-table td:nth-child(4) { width: 14%; } /* Status */
.cases-table th:nth-child(5), .cases-table td:nth-child(5) { width: 10%; } /* Priority */
.cases-table th:nth-child(6), .cases-table td:nth-child(6) { width: 12%; } /* Last Updated */
.cases-table th:nth-child(7), .cases-table td:nth-child(7) { width: 16%; } /* Actions */

/* Keep certain columns compact */
.cases-table td:nth-child(5), /* Priority */
.cases-table td:nth-child(6), /* Last Updated */
.cases-table td:nth-child(7) { /* Actions */
  white-space: nowrap;
}

.cases-table tbody tr:hover {
  background: linear-gradient(135deg, rgba(114, 137, 218, 0.05) 0%, rgba(138, 109, 184, 0.05) 100%);
}

.cases-table tbody tr:last-child td {
  border-bottom: none;
}

.action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  background: #f3f4f6;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 14px;
}

.action-btn:hover {
  background: #e5e7eb;
  color: #374151;
  transform: translateY(-1px);
}

.action-btn:active {
  transform: translateY(0);
}

.case-id-link {
  background: none;
  border: none;
  color: #7289da;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  padding: 4px 8px;
  font-size: inherit;
  border-radius: 4px;
  transition: all 0.15s ease;
}

.case-id-link:hover {
  color: #8a6db8;
  background: linear-gradient(135deg, rgba(114, 137, 218, 0.1) 0%, rgba(138, 109, 184, 0.1) 100%);
  text-decoration: none;
}

/* Client info styles moved to CaseDashboard.css to avoid conflicts */

.status-badge {
  padding: 3px 6px;
  border-radius: 10px;
  font-size: 0.75rem;
  font-weight: 500;
}

.status-pending-review {
  background: #fef3c7;
  color: #92400e;
}

.status-approved {
  background: #d1fae5;
  color: #065f46;
}

.status-rejected {
  background: #fee2e2;
  color: #991b1b;
}

/* Priority Badge Styles */
.priority-badge {
  padding: 3px 6px;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: capitalize;
}

.priority-low {
  background: #dbeafe;
  color: #1d4ed8;
}

.priority-medium {
  background: #fef3c7;
  color: #d97706;
}

.priority-high {
  background: #fed7d7;
  color: #dc2626;
}

.priority-urgent {
  background: #dc2626;
  color: #ffffff;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.action-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  font-size: 1rem;
}

/* Subtle delete button styling */
.action-btn:hover {
  background-color: #f3f4f6;
}

/* Delete button specific styling - subtle gray by default, red on hover */
.action-btn:last-child {
  color: #6b7280;
}

.action-btn:last-child:hover {
  color: #dc3545;
  background-color: #fef2f2;
}

.case-id-link {
  background: none;
  border: none;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  padding: 0;
  margin: 0;
  transition: color 0.2s ease;
}

.case-id-link:hover {
  color: #0056b3;
  text-decoration: none;
}

/* Legal Assistant Styles */
.legal-assistant {
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  border: 1px solid #e1e8ed;
  border-radius: 0; /* flush edges in split view */
  position: relative;
  transition: width 0.1s ease-out;
}

.assistant-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #1f2937;
  padding: 16px 20px;
  border-radius: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.assistant-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.panel-width-indicator {
  font-size: 12px;
  opacity: 0.7;
  font-weight: normal;
}

.minimize-btn {
  background: none;
  border: none;
  color: #1f2937;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.minimize-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #f8fafc;
}

.message {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.message.user {
  flex-direction: row-reverse;
}

.message-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}

.message.assistant .message-avatar {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #1f2937;
}

.message.user .message-avatar {
  background: #f3f4f6;
  color: #6b7280;
}

.message-content {
  background: #f9fafb;
  padding: 12px 16px;
  border-radius: 12px;
  max-width: 85%;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Removed conflicting user message styling - handled in LegalAssistant.css */

.message.isLoading .message-content {
  background: #f3f4f6;
  color: #6b7280;
  font-style: italic;
}

.message-time {
  font-size: 0.7rem;
  color: #666;
  margin-top: 4px;
}

.message-text.loading {
  opacity: 0.7;
}

.loading-dots {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.send-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.chat-input input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.chat-input-container {
  padding: 20px;
  border-top: 1px solid #e1e8ed;
  background: white;
}

.chat-input-form {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  gap: 12px !important;
  position: relative;
  width: 100%;
  min-height: 60px;
  padding: 6px 0;
}

.input-actions {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 8px !important;
  flex-shrink: 0 !important;
  order: 1;
}

.file-upload-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #1f2937;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.file-upload-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.chat-input {
  flex: 1 1 !important;
  border: 2px solid #d1d5db;
  border-radius: 28px;
  padding: 16px 20px;
  font-size: 16px;
  outline: none;
  transition: all 0.2s;
  min-height: 48px;
  max-height: 120px;
  resize: vertical;
  font-family: inherit;
  line-height: 1.4;
  background: white;
  order: 2;
}

.chat-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.chat-input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.send-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #1f2937;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  cursor: pointer;
  font-size: 18px;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: all 0.2s;
  flex-shrink: 0 !important;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  visibility: visible !important;
  opacity: 1 !important;
}

.send-btn:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.send-btn:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.2);
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
}

/* Resize handle for Legal Assistant */
.resize-handle {
  position: absolute;
  left: -6px;
  top: 0;
  width: 12px;
  height: 100%;
  cursor: ew-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  transition: background-color 0.2s;
  z-index: 10;
}

.resize-handle:hover {
  background: rgba(102, 126, 234, 0.1);
  border-radius: 0 4px 4px 0;
}

.resize-handle.resizing {
  background: rgba(102, 126, 234, 0.2);
}

/* Add cursor style for resizing state */
.legal-assistant.resizing {
  cursor: ew-resize;
  -webkit-user-select: none;
          user-select: none;
}

.resize-indicator {
  width: 4px;
  height: 40px;
  background: #667eea;
  border-radius: 2px;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.resize-handle:hover .resize-indicator {
  opacity: 1;
}

.resize-handle.resizing .resize-indicator {
  opacity: 1;
  background: #4f46e5;
}

/* Loading State */
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 1.2rem;
  color: #666;
}

/* Responsive Design */
/* Removed media query that was hiding assistant sidebar */


/* Responsive stats cards */
@media (max-width: 1200px) {
  .stats-bar {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

@media (max-width: 768px) {
  .stats-bar {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 16px !important;
  }
  
  .stat-item {
    padding: 16px !important;
    gap: 12px !important;
  }
  
  .stat-number {
    font-size: 20px !important;
  }
  
  .stat-label {
    font-size: 12px !important;
  }
}

@media (max-width: 640px) {
  .stats-bar {
    grid-template-columns: 1fr !important;
    gap: 12px !important;
  }
  
  .stat-item {
    padding: 12px !important;
  }
  
  .stat-icon {
    padding: 8px !important;
    font-size: 16px !important;
  }
  
  .stat-number {
    font-size: 18px !important;
  }
  
  .stat-label {
    font-size: 11px !important;
  }
}

@media (max-width: 768px) {
  .sidebar {
    width: 220px;
  }
  
  .sidebar-toggle {
    display: none;
  }
  
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .search-bar input {
    width: 200px;
  }
}

@media (max-width: 640px) {
  .sidebar {
    display: none;
  }
  
  /* Mobile Menu Toggle Button */
  .mobile-menu-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: transparent;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    cursor: pointer;
    color: #475569;
    font-size: 20px;
    margin-right: 12px;
    transition: all 0.2s ease;
  }
  
  .mobile-menu-toggle:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
  }
  
  .mobile-menu-toggle:active {
    background: #e2e8f0;
  }
  
  /* Mobile Menu Overlay */
  .mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2000;
    display: flex;
    animation: fadeIn 0.2s ease;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  /* Mobile Menu Drawer */
  .mobile-menu-drawer {
    width: 280px;
    max-width: 85vw;
    background: white;
    height: 100%;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    animation: slideIn 0.3s ease;
    overflow: hidden;
  }
  
  @keyframes slideIn {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0);
    }
  }
  
  .mobile-menu-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid #e2e8f0;
    background: #f8fafc;
  }
  
  .mobile-menu-header h2 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: #1e293b;
  }
  
  .mobile-menu-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: transparent;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    cursor: pointer;
    color: #475569;
    font-size: 18px;
    transition: all 0.2s ease;
  }
  
  .mobile-menu-close:hover {
    background: #e2e8f0;
    border-color: #cbd5e1;
  }
  
  .mobile-menu-content {
    flex: 1 1;
    overflow-y: auto;
    padding: 16px 0;
  }
  
  .mobile-nav-section {
    margin-bottom: 24px;
  }
  
  .mobile-section-title {
    font-size: 0.75rem;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding: 0 20px;
    margin-bottom: 8px;
  }
  
  .mobile-nav-item {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 12px 20px;
    background: none;
    border: none;
    cursor: pointer;
    color: #475569;
    text-align: left;
    transition: all 0.15s ease;
    font-size: 15px;
    font-weight: 400;
  }
  
  .mobile-nav-item:hover {
    background: #f8fafc;
    color: #1e293b;
  }
  
  .mobile-nav-item.active {
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);
    color: #667eea;
    font-weight: 500;
    border-left: 3px solid #667eea;
  }
  
  .mobile-nav-item.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .mobile-nav-item.disabled:hover {
    background: #f8fafc;
    color: #475569;
  }
  
  .mobile-nav-icon {
    font-size: 1.1rem;
    width: 24px;
    color: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .mobile-nav-label {
    flex: 1 1;
    font-weight: inherit;
    font-size: 15px;
  }
  
  .mobile-nav-blocked {
    font-size: 0.75rem;
    opacity: 0.7;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .section-header {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  
  .search-bar input {
    width: 100%;
  }
  
  /* Hide mobile menu toggle on desktop */
  @media (min-width: 641px) {
    .mobile-menu-toggle {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  .create-account-content {
    max-width: 100%;
    padding: 1rem;
    margin-top: 4rem;
  }

  .create-account-form-wrapper {
    padding: 2rem 1.5rem;
  }

  .create-account-logo-top {
    top: 1rem;
    left: 1rem;
  }

  .create-account-logo-top .logo-img {
    max-height: 100px;
  }

  .password-policy-box {
    margin-bottom: 16px;
  }
}
/* .login-container {
  display: flex;
  width: 900px;
  height: 600px;
  margin: 40px auto;
  background: transparent;
  box-shadow: 0 2px 24px rgba(24,90,219,0.08);
  border-radius: 24px;
  overflow: hidden;
} */
.login-left {
  width: 50%;
  min-width: 340px;
  background: #185adb;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 60px 48px;
  border-radius: 24px 0 0 24px;
  height: 85%;
}
.login-right {
  width: 50%;
  min-width: 340px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 60px 48px;
  border-radius: 0 24px 24px 0;
  height: 85%;
  box-shadow: none;
}
@media (max-width: 768px) {
  .login-content {
    max-width: 100%;
    padding: 1rem;
  }

  .login-form-wrapper {
    padding: 2rem 1.5rem;
  }

  .login-logo .logo-img {
    max-height: 100px;
  }

  .back-to-home-btn {
    top: 0.75rem;
    left: 0.75rem;
    padding: 0.4rem 0.8rem;
    font-size: 0.85rem;
  }
}

/* New Case Form Styles */
.new-case {
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
}

.form-header {
  margin-bottom: 2rem;
  text-align: center;
}

.form-header h2 {
  color: #333;
  margin-bottom: 0.5rem;
}

.form-header p {
  color: #666;
  font-size: 1rem;
}

.new-case-form {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.form-section {
  margin-bottom: 1.5rem;
  flex: 1 1;
}

/* Remove top margin from first section */
.form-section:first-child {
  margin-top: 0.5rem;
  margin-bottom: 1rem;
}

.form-section h3 {
  color: #333;
  margin-bottom: 0.75rem;
  margin-top: 0;
  padding-bottom: 0.25rem;
  border-bottom: 2px solid #e0e0e0;
  font-size: 1.1rem;
  font-weight: 600;
}

/* Reduce spacing for the first section */
.form-section:first-child h3 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

.form-group {
  margin-bottom: 1rem;
  position: relative;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #333;
}



.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

/* Make input fields smaller than form width */
.form-group input[type="text"],
.form-group input[type="email"] {
  width: 90%;
  max-width: 600px;
}

/* Style dropdowns to be clearly distinguishable */
.form-group select {
  width: 90%;
  max-width: 600px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  cursor: pointer;
  /* Remove default browser dropdown arrow */
  appearance: none;
}

/* Make textarea smaller to fit in window */
.form-group textarea {
  width: 90%;
  max-width: 600px;
  min-height: 120px;
  resize: vertical;
}

/* Add fade effect to indicate scrollable content */
.edit-case-form::after {
  content: "";
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.8));
  pointer-events: none;
  z-index: 1;
}



.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

/* Hover effects for dropdowns */
.form-group select:hover {
  border-color: #007bff;
  background-color: #f8f9fa;
}

/* Different styling for text inputs vs dropdowns */
.form-group input[type="text"]:hover,
.form-group input[type="email"]:hover {
  border-color: #007bff;
  background-color: #f8f9fa;
}

/* Subtle background for dropdowns to distinguish them */
.form-group select {
  background-color: #f8f9fa;
  border-radius: 8px;
  font-family: inherit;
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

.form-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e0e0e0;
  background: white;
  padding-bottom: 1rem;
  flex-wrap: wrap;
  flex-shrink: 0;
  position: relative;
}

/* Add subtle scroll indicator */
.form-actions::before {
  content: "";
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 4px;
  background: linear-gradient(to right, transparent, #e0e0e0, transparent);
  border-radius: 2px;
}

.cancel-btn {
  padding: 0.75rem 2rem;
  background: #6c757d;
  color: #1f2937;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  min-width: 140px;
  width: 140px;
  white-space: nowrap;
  flex: 1 1;
  max-width: 200px;
}

.cancel-btn:hover {
  background: #5a6268;
}

.submit-btn {
  padding: 0.75rem 2rem;
  background: #007bff;
  color: #1f2937;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  min-width: 140px;
  width: 140px;
  white-space: nowrap;
  flex: 1 1;
  max-width: 200px;
}

.submit-btn:hover {
  background: #0056b3;
}

.submit-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* Responsive styles for edit case modal */
@media (max-width: 768px) {
  .edit-case-modal {
    width: 98%;
    max-width: none;
    max-height: 98vh;
    margin: 5px;
  }
  
  .edit-case-form {
    padding: 1rem 1rem 1rem 1rem;
  }
  
  /* Make inputs full width on mobile for better usability */
  .form-group input[type="text"],
  .form-group input[type="email"],
  .form-group select,
  .form-group textarea {
    width: 100%;
    max-width: none;
    padding-right: 0.75rem;
  }
  
  .form-group select {
    padding-right: 2.5rem;
  }
  
  .form-actions {
    flex-direction: column;
    gap: 0.75rem;
    padding: 1rem;
  }
  
  .form-actions button {
    width: 100%;
    min-width: auto;
    max-width: none;
  }
  
  .cancel-btn,
  .submit-btn {
    padding: 0.75rem 1rem;
    min-width: auto;
    width: 100%;
  }
}

.back-btn {
  padding: 0.75rem 1.5rem;
  background: #007bff;
  color: #1f2937;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.back-btn:hover {
  background: #0056b3;
}

/* Edit Case Modal Styles */
.edit-case-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 10px;
}

.edit-case-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  max-width: 1000px;
  width: 98%;
  max-height: 98vh;
  overflow-y: auto;
  margin: 10px;
  display: flex;
  flex-direction: column;
  /* Custom scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}



/* Custom scrollbar styling for modal */
.edit-case-modal::-webkit-scrollbar {
  width: 12px;
}

.edit-case-modal::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 6px;
}

.edit-case-modal::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 6px;
  border: 2px solid #f1f1f1;
}

.edit-case-modal::-webkit-scrollbar-thumb:hover {
  background: #666;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  border-bottom: 1px solid #e0e0e0;
}

.modal-header h2 {
  margin: 0;
  color: #333;
}

.close-btn {
  background: #dc3545;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  color: #1f2937;
  padding: 6px 12px;
  width: auto;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: background-color 0.2s;
  font-weight: 500;
  min-width: 60px;
}

.close-btn:hover {
  background: #c82333;
  color: #1f2937;
}

.edit-case-form {
  padding: 0.5rem 2rem;
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  /* Custom scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

/* Custom scrollbar styling for webkit browsers */
.edit-case-form::-webkit-scrollbar {
  width: 12px;
}

.edit-case-form::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 6px;
}

.edit-case-form::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 6px;
  border: 2px solid #f1f1f1;
}

.edit-case-form::-webkit-scrollbar-thumb:hover {
  background: #666;
}

/* Case Details Modal Styles */
.case-details-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 10px;
}

.case-details-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  max-width: 1200px;
  width: 98%;
  max-height: 98vh;
  overflow-y: auto;
  margin: 10px;
  display: flex;
  flex-direction: column;
}

.case-details-content {
  padding: 1rem 2rem;
  flex: 1 1;
  overflow-y: auto;
}

.case-info-section,
.client-info-section,
.documents-section,
.ocr-summary-section {
  margin-bottom: 2rem;
}

.case-info-section h3,
.client-info-section h3,
.documents-section h3,
.ocr-summary-section h3 {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.2rem;
  font-weight: 600;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 0.5rem;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.info-item label {
  font-weight: 600;
  color: #495057;
}

.document-checklist {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.document-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.document-item:hover {
  background: #e9ecef;
  border-color: #007bff;
}

.document-info {
  flex: 1 1;
}

.document-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.category-icon {
  font-size: 1.2rem;
}

.document-name {
  font-weight: 600;
  color: #333;
}

.required-badge {
  background: #dc3545;
  color: #1f2937;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
}

.status-icon {
  font-size: 1.1rem;
}

.document-description {
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
}

.document-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 120px;
}

.upload-btn {
  background: #007bff;
  color: #1f2937;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}

.upload-btn:hover {
  background: #0056b3;
}

.uploaded-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.view-btn,
.replace-btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}

.view-btn {
  background: #28a745;
  color: #1f2937;
}

.view-btn:hover {
  background: #218838;
}

.replace-btn {
  background: #6c757d;
  color: #1f2937;
}

.replace-btn:hover {
  background: #5a6268;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem 2rem;
  border-top: 1px solid #e0e0e0;
  background: #f8f9fa;
}

.edit-btn {
  background: #007bff;
  color: #1f2937;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.2s;
}

.edit-btn:hover {
  background: #0056b3;
}

/* Tab Navigation */
.tab-navigation {
  display: flex;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 2rem;
  background: #f8f9fa;
  border-radius: 8px 8px 0 0;
}

.tab-btn {
  flex: 1 1;
  padding: 1rem 1.5rem;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  color: #6c757d;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
}

.tab-btn:hover {
  background: #e9ecef;
  color: #495057;
}

.tab-btn.active {
  background: white;
  color: #007bff;
  border-bottom-color: #007bff;
  font-weight: 600;
}

/* Overview Content */
.overview-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.progress-summary-section {
  margin-top: 1rem;
}

.progress-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-top: 1rem;
}

.progress-item {
  text-align: center;
}

.progress-circle {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #1f2937;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto 1rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.progress-number {
  font-size: 2rem;
  font-weight: bold;
  line-height: 1;
}

.progress-label {
  font-size: 0.8rem;
  opacity: 0.9;
  margin-top: 0.25rem;
}

/* Documents Content */
.documents-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.bulk-upload-section {
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
  text-align: center;
}

.bulk-upload-section h4 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 1.1rem;
}

.bulk-upload-section p {
  margin: 0 0 16px 0;
  color: #666;
  font-size: 0.9rem;
}

.bulk-upload-btn {
  display: inline-block;
  background: #007bff;
  color: #1f2937;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s ease;
  margin-bottom: 12px;
}

.bulk-upload-btn:hover {
  background: #0056b3;
}

.upload-tips {
  background: #e3f2fd;
  border-radius: 4px;
  padding: 8px 12px;
  border-left: 4px solid #2196f3;
}

.upload-tips small {
  color: #1976d2;
  font-size: 0.85rem;
  line-height: 1.4;
}

/* Document Selection Styles */
.document-selection-section,
.form-selection-section {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.section-header h4 {
  margin: 0;
  color: #333;
  font-size: 1.1rem;
}

.add-custom-btn {
  background: #28a745;
  color: #1f2937;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.add-custom-btn:hover {
  background: #218838;
}

.document-list,
.form-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.document-selection-item,
.form-selection-item {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;
}

.document-selection-item:hover,
.form-selection-item:hover {
  border-color: #007bff;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);
}

.document-selection-info,
.form-selection-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

.document-details,
.form-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.document-name,
.form-name {
  font-weight: 600;
  color: #333;
  font-size: 1rem;
}

.document-description,
.form-description {
  color: #666;
  font-size: 0.9rem;
}

.form-meta {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 4px;
}

.estimated-time {
  color: #666;
  font-size: 0.85rem;
}

/* Checkbox Styles */
.checkbox-container {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  background-color: #fff;
  border: 2px solid #ddd;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.checkbox-container:hover input ~ .checkmark {
  border-color: #007bff;
}

.checkbox-container input:checked ~ .checkmark {
  background-color: #007bff;
  border-color: #007bff;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-container .checkmark:after {
  left: 6px;
  top: 2px;
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* Selected Items Styles */
.selected-documents-section,
.selected-forms-section {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
}

.selected-documents-section h4,
.selected-forms-section h4 {
  margin: 0 0 16px 0;
  color: #333;
  font-size: 1.1rem;
}

.selected-documents-list,
.selected-forms-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.selected-document-item,
.selected-form-item {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.custom-badge {
  background: #ffc107;
  color: #212529;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-left: 8px;
}

.remove-btn {
  background: #dc3545;
  color: #1f2937;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  margin-left: 8px;
}

.remove-btn:hover {
  background: #c82333;
}

/* Save Button */
.save-btn {
  background: #28a745;
  color: #1f2937;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s ease;
  margin-right: 12px;
}

.save-btn:hover {
  background: #218838;
}

/* Custom Modal Styles */
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.custom-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 500px;
  overflow: hidden;
}

.custom-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}

.custom-modal-header h3 {
  margin: 0;
  color: #333;
}

.custom-modal-content {
  padding: 20px;
}

.custom-modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 20px;
}

.add-btn {
  background: #28a745;
  color: #1f2937;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.add-btn:hover {
  background: #218838;
}

/* Forms Content */
.forms-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.forms-checklist {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-item {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 1.5rem;
  transition: all 0.3s ease;
}

.form-item:hover {
  background: #e9ecef;
  border-color: #007bff;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.1);
}

.form-info {
  flex: 1 1;
}

.form-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.form-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  flex: 1 1;
}

.form-status {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: capitalize;
}

.form-description {
  color: #6c757d;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.form-details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.form-detail-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.form-detail-item label {
  font-weight: 600;
  color: #495057;
  min-width: 120px;
}

.required-docs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.doc-tag {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
}

.doc-tag.uploaded {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.doc-tag.pending {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

.form-actions {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  flex-wrap: wrap;
}

.form-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.form-btn.start {
  background: #28a745;
  color: #1f2937;
}

.form-btn.start:hover {
  background: #218838;
}

.form-btn.completed {
  background: #6c757d;
  color: #1f2937;
}

.form-btn.completed:hover {
  background: #5a6268;
}

.form-btn.secondary {
  background: #007bff;
  color: #1f2937;
}

.form-btn.secondary:hover {
  background: #0056b3;
}

/* Priority Badge Colors */
.priority-badge.text-red-600.bg-red-100 {
  background: #f8d7da !important;
  color: #721c24 !important;
  border: 1px solid #f5c6cb;
}

.priority-badge.text-yellow-600.bg-yellow-100 {
  background: #fff3cd !important;
  color: #856404 !important;
  border: 1px solid #ffeaa7;
}

.priority-badge.text-green-600.bg-green-100 {
  background: #d4edda !important;
  color: #155724 !important;
  border: 1px solid #c3e6cb;
}

/* Form Status Colors */
.form-status.text-green-600.bg-green-100 {
  background: #d4edda !important;
  color: #155724 !important;
}

.form-status.text-blue-600.bg-blue-100 {
  background: #d1ecf1 !important;
  color: #0c5460 !important;
}

.form-status.text-gray-600.bg-gray-100 {
  background: #e2e3e5 !important;
  color: #383d41 !important;
}

/* Responsive Design for Case Details */
@media (max-width: 768px) {
  .case-details-modal {
    width: 95%;
    margin: 5px;
  }
  
  .case-details-content {
    padding: 1rem;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .document-item {
    flex-direction: column;
    gap: 1rem;
  }
  
  .document-actions {
    min-width: auto;
    width: 100%;
  }
  
  .uploaded-actions {
    flex-direction: row;
  }
  
  .extracted-fields {
    grid-template-columns: 1fr;
  }
  
  .tab-navigation {
    flex-direction: column;
  }
  
  .tab-btn {
    border-bottom: none;
    border-right: 3px solid transparent;
  }
  
  .tab-btn.active {
    border-bottom: none;
    border-right-color: #007bff;
  }
  
  .progress-grid {
    grid-template-columns: 1fr;
  }
  
  .form-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .form-actions {
    flex-direction: column;
  }
  
  .form-btn {
    width: 100%;
    justify-content: center;
  }
}

/* Document Upload Styles */
.document-upload {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
}

.upload-section {
  margin-bottom: 24px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 16px;
}

.file-selection {
  margin-bottom: 16px;
}

.file-input-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.file-input {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.file-label {
  display: block;
  padding: 12px 16px;
  background: #f3f4f6;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #6b7280;
}

.file-label:hover {
  background: #e5e7eb;
  border-color: #9ca3af;
}

.file-info {
  margin-top: 8px;
  padding: 8px 12px;
  background: #f0f9ff;
  border-radius: 6px;
  font-size: 14px;
}

.file-name {
  font-weight: 500;
  color: #1f2937;
}

.file-size {
  color: #6b7280;
  margin-left: 8px;
}

.document-type-selection {
  margin-bottom: 16px;
}

.label {
  display: block;
  font-weight: 500;
  color: #374151;
  margin-bottom: 6px;
}

.select-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
  font-size: 14px;
  color: #1f2937;
}

.select-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.upload-button {
  width: 100%;
  padding: 12px 16px;
  background: #3b82f6;
  color: #1f2937;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.upload-button:hover:not(:disabled) {
  background: #2563eb;
}

.upload-button:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

/* Upload Progress Styles */
.upload-progress {
  border-top: 1px solid #e5e7eb;
  padding-top: 20px;
}

.progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.progress-header h4 {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.clear-button {
  padding: 6px 12px;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
}

.clear-button:hover:not(:disabled) {
  background: #e5e7eb;
  color: #374151;
}

.clear-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.uploads-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.upload-item {
  padding: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fafafa;
  transition: all 0.2s ease;
}

.upload-item.upload-ready {
  border-color: #10b981;
  background: #f0fdf4;
}

.upload-item.upload-failed {
  border-color: #ef4444;
  background: #fef2f2;
}

.upload-item.upload-uploading {
  border-color: #3b82f6;
  background: #eff6ff;
}

.upload-info {
  margin-bottom: 12px;
}

.upload-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.status-icon {
  font-size: 16px;
}

.file-name {
  flex: 1 1;
  font-weight: 500;
  color: #1f2937;
}

.status-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.text-yellow-600 {
  color: #d97706;
  background: #fef3c7;
}

.text-blue-600 {
  color: #2563eb;
  background: #dbeafe;
}

.text-purple-600 {
  color: #7c3aed;
  background: #ede9fe;
}

.text-green-600 {
  color: #059669;
  background: #d1fae5;
}

.text-red-600 {
  color: #dc2626;
  background: #fee2e2;
}

.text-gray-600 {
  color: #4b5563;
  background: #f3f4f6;
}

.upload-details {
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: #6b7280;
}

.progress-bar {
  width: 100%;
  height: 4px;
  background: #e5e7eb;
  border-radius: 2px;
  overflow: hidden;
  margin-top: 8px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #3b82f6, #1d4ed8);
  transition: width 0.3s ease;
}

.error-message {
  margin-top: 8px;
  padding: 8px 12px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  font-size: 12px;
  color: #dc2626;
}

.upload-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.action-button {
  padding: 6px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
}

.download-button {
  color: #059669;
  border-color: #10b981;
}

.download-button:hover {
  background: #f0fdf4;
  border-color: #059669;
}

.retry-button {
  color: #d97706;
  border-color: #f59e0b;
}

.retry-button:hover {
  background: #fef3c7;
  border-color: #d97706;
}

.remove-button {
  color: #dc2626;
  border-color: #f87171;
}

.remove-button:hover {
  background: #fef2f2;
  border-color: #dc2626;
}

/* Documents Component Styles */
.documents {
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
}

.documents-header {
  margin-bottom: 24px;
  text-align: center;
}

.documents-header h2 {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 8px;
}

.documents-header p {
  color: #6b7280;
  font-size: 16px;
}

.case-selection {
  margin-bottom: 24px;
  max-width: 400px;
}

.documents-list {
  margin-top: 32px;
}

.documents-list h3 {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 16px;
}

.documents-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}

.document-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.document-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.document-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.document-name {
  flex: 1 1;
  font-weight: 600;
  color: #1f2937;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.document-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
  font-size: 12px;
  color: #6b7280;
}

.document-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.delete-button {
  color: #dc2626;
  border-color: #f87171;
}

.delete-button:hover {
  background: #fef2f2;
  border-color: #dc2626;
}

.debug-button {
  color: #7c3aed;
  border-color: #a78bfa;
}

.debug-button:hover {
  background: #ede9fe;
  border-color: #7c3aed;
}

.fix-button {
  color: #d97706;
  border-color: #fbbf24;
}

.fix-button:hover {
  background: #fef3c7;
  border-color: #d97706;
}

.empty-state {
  text-align: center;
  padding: 48px 24px;
  background: white;
  border: 2px dashed #d1d5db;
  border-radius: 12px;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state h4 {
  font-size: 18px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.empty-state p {
  color: #6b7280;
  font-size: 14px;
}

.loading {
  text-align: center;
  padding: 48px;
  color: #6b7280;
  font-size: 16px;
}

/* Status badge styles for documents */
.status-pending {
  color: #d97706;
  background: #fef3c7;
}

.status-uploading {
  color: #2563eb;
  background: #dbeafe;
}

.status-processing {
  color: #7c3aed;
  background: #ede9fe;
}

.status-ready {
  color: #059669;
  background: #d1fae5;
}

.status-failed {
  color: #dc2626;
  background: #fee2e2;
}

/* Document Manager Styles */
.document-manager {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.upload-widget {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.upload-widget h3 {
  margin: 0 0 20px 0;
  color: #1f2937;
  font-size: 18px;
  font-weight: 600;
}

.upload-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 500;
  color: #374151;
  font-size: 14px;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f0f9ff;
  border-radius: 6px;
  font-size: 14px;
  color: #1f2937;
}

.download-widget {
  background: white;
  border: 2px solid #10b981;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.download-widget h3 {
  margin: 0 0 20px 0;
  color: #1f2937;
  font-size: 18px;
  font-weight: 600;
}

.documents-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.document-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fafafa;
  transition: all 0.2s ease;
}

.document-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.document-info {
  flex: 1 1;
}

.document-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.document-name {
  font-weight: 600;
  color: #1f2937;
  font-size: 14px;
}

.document-details {
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: #6b7280;
}

.document-actions {
  display: flex;
  gap: 8px;
}

/* Status badges for document manager */
.status-ready {
  color: #059669;
  background: #d1fae5;
}

.status-pending {
  color: #d97706;
  background: #fef3c7;
}

.status-uploading {
  color: #2563eb;
  background: #dbeafe;
}

.status-processing {
  color: #7c3aed;
  background: #ede9fe;
}

.status-failed {
  color: #dc2626;
  background: #fee2e2;
}

/* Document Management - New Two-Panel Design */

.documents-page {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  background: #f8f9fa;
  min-height: 100vh;
}

.documents-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.documents-header h1 {
  margin: 0;
  color: #2c3e50;
  font-size: 24px;
  font-weight: 600;
}

.case-selector select {
  padding: 10px 15px;
  border: 2px solid #e1e8ed;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  min-width: 250px;
  cursor: pointer;
}

.case-selector select:focus {
  outline: none;
  border-color: #3498db;
}

/* Bulk Actions */
.bulk-actions {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
  padding: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.bulk-upload {
  flex: 1 1;
}

.bulk-upload-btn {
  display: inline-block;
  padding: 12px 24px;
  background: #27ae60;
  color: #1f2937;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.3s ease;
}

.bulk-upload-btn:hover {
  background: #229954;
}

.bulk-download-btn {
  padding: 12px 24px;
  background: #3498db;
  color: #1f2937;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.3s ease;
}

.bulk-download-btn:hover:not(:disabled) {
  background: #2980b9;
}

.bulk-download-btn:disabled {
  background: #bdc3c7;
  cursor: not-allowed;
}

/* Top Panel - Required Documents Checklist */
.required-documents-panel {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin-bottom: 25px;
  overflow: hidden;
}

.required-documents-panel .panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 10px 20px;
  flex-wrap: wrap;
  gap: 12px;
}

.required-documents-panel .panel-header h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 20px;
  font-weight: 600;
}

.required-documents-panel .panel-header p {
  margin: 0;
  color: #7f8c8d;
  font-size: 14px;
}

.refresh-btn {
  background: #007bff;
  color: #1f2937;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.refresh-btn:hover {
  background: #0056b3;
}

.refresh-btn:active {
  background: #004085;
}

/* Category Selection */
.category-selection {
  margin-bottom: 20px;
  padding: 0 20px;
}

.category-selector {
  display: flex;
  gap: 12px;
  align-items: center;
}

.category-dropdown {
  flex: 1 1;
  padding: 10px 12px;
  border: 1px solid #e1e8ed;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  cursor: pointer;
  transition: border-color 0.2s;
}

.category-dropdown:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.1);
}

.add-category-btn {
  padding: 10px 16px;
  background: #059669;
  color: #1f2937;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
}

.add-category-btn:hover:not(:disabled) {
  background: #047857;
}

.add-category-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

.remove-category-btn {
  padding: 6px 10px;
  background: #ef4444;
  color: #1f2937;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-left: 8px;
}

.remove-category-btn:hover:not(.disabled) {
  background: #dc2626;
}

.remove-category-btn.disabled {
  background: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}

.remove-category-btn.disabled:hover {
  background: #9ca3af;
  transform: none;
}

.document-requirements {
  padding: 0 20px 20px 20px;
}

.document-requirement {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border: 1px solid #e1e8ed;
  border-radius: 8px;
  margin-bottom: 10px;
  transition: all 0.3s ease;
}

.document-requirement:hover {
  border-color: #3498db;
  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.1);
}

.requirement-info {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1 1;
}

.category-icon {
  font-size: 24px;
  width: 40px;
  text-align: center;
}

.requirement-details h3 {
  margin: 0 0 5px 0;
  color: #2c3e50;
  font-size: 16px;
  font-weight: 600;
}

.requirement-details p {
  margin: 0;
  color: #7f8c8d;
  font-size: 14px;
}

.requirement-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.status {
  font-size: 14px;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 20px;
  background: #f8f9fa;
}

.status.text-green-600 {
  background: #d4edda;
  color: #155724;
}

.status.text-orange-600 {
  background: #fff3cd;
  color: #856404;
}

.upload-btn {
  padding: 8px 16px;
  background: #3498db;
  color: #1f2937;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.3s ease;
}

.upload-btn:hover {
  background: #2980b9;
}

.download-btn {
  padding: 8px 16px;
  background: #27ae60;
  color: #1f2937;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.3s ease;
}

.download-btn:hover {
  background: #229954;
}

/* Bottom Panel - Uploaded Documents */
.uploaded-documents-panel {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  overflow: hidden;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e1e8ed;
}

.panel-header h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 20px;
  font-weight: 600;
}

.panel-controls {
  display: flex;
  gap: 15px;
  align-items: center;
}

.category-filter {
  padding: 8px 12px;
  border: 1px solid #e1e8ed;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  min-width: 150px;
}

.search-box {
  position: relative;
  display: flex;
  align-items: center;
}

.search-box input {
  padding: 8px 35px 8px 12px;
  border: 1px solid #e1e8ed;
  border-radius: 6px;
  font-size: 14px;
  width: 250px;
}

.search-box input:focus {
  outline: none;
  border-color: #3498db;
}

.search-icon {
  display: none;
}

.uploaded-documents-list {
  padding: 20px;
}

.uploaded-document {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border: 1px solid #e1e8ed;
  border-radius: 8px;
  margin-bottom: 10px;
  transition: all 0.3s ease;
}

.uploaded-document:hover {
  border-color: #3498db;
  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.1);
}

.document-info {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1 1;
}

.file-icon {
  font-size: 24px;
  width: 40px;
  text-align: center;
}

.document-details h4 {
  margin: 0 0 5px 0;
  color: #2c3e50;
  font-size: 16px;
  font-weight: 600;
}

.document-details p {
  margin: 0;
  color: #7f8c8d;
  font-size: 14px;
}

.document-actions {
  display: flex;
  gap: 10px;
}

.view-btn, .download-btn, .delete-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.view-btn {
  background: #3498db;
  color: #1f2937;
}

.view-btn:hover {
  background: #2980b9;
}

.download-btn {
  background: #27ae60;
  color: #1f2937;
}

.download-btn:hover {
  background: #229954;
}

.delete-btn {
  background: #e74c3c;
  color: #1f2937;
}

.delete-btn:hover {
  background: #c0392b;
}

/* Empty States */
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #7f8c8d;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 15px;
}

.empty-state h3 {
  margin: 0 0 10px 0;
  color: #2c3e50;
  font-size: 18px;
  font-weight: 600;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
}

.no-case-selected {
  text-align: center;
  padding: 60px 20px;
  color: #7f8c8d;
}

.no-case-selected .empty-icon {
  font-size: 64px;
  margin-bottom: 20px;
}

.no-case-selected h3 {
  margin: 0 0 10px 0;
  color: #2c3e50;
  font-size: 20px;
  font-weight: 600;
}

.no-case-selected p {
  margin: 0;
  font-size: 16px;
}

/* Loading State */
.loading {
  text-align: center;
  padding: 60px 20px;
  color: #7f8c8d;
  font-size: 16px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .documents-header {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
  
  .case-selector select {
    min-width: auto;
  }
  
  .bulk-actions {
    flex-direction: column;
  }
  
  .document-requirement {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }
  
  .requirement-actions {
    justify-content: space-between;
  }
  
  .panel-header {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
  
  .panel-controls {
    flex-direction: column;
  }
  
  .search-box input {
    width: 100%;
  }
  
  .uploaded-document {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }
  
  .document-actions {
    justify-content: space-between;
  }
}

/* Delete Confirmation Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.delete-modal {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  animation: modalSlideIn 0.3s ease-out;
  display: flex;
  flex-direction: column;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.modal-header {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: #1f2937;
  padding: 20px 24px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.modal-header h3 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.modal-content {
  padding: 32px;
  text-align: center;
}

.modal-content p {
  margin: 0 0 20px 0;
  font-size: 16px;
  color: #4a5568;
  line-height: 1.6;
}

.document-info {
  background: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin: 20px 0;
}

.document-info strong {
  color: #2d3748;
  font-size: 18px;
  word-break: break-word;
}

.warning-text {
  background: #fff5f5;
  border: 1px solid #fed7d7;
  border-radius: 8px;
  padding: 16px;
  color: #c53030;
  font-size: 14px;
  line-height: 1.5;
  margin: 20px 0 0 0;
}

.modal-actions {
  display: flex;
  gap: 16px;
  padding: 24px 32px 32px 32px;
  justify-content: center;
}

.cancel-btn {
  background: white;
  color: #4a5568;
  border: 2px solid #e2e8f0;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
}

.cancel-btn:hover {
  background: #f7fafc;
  border-color: #cbd5e0;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.delete-confirm-btn {
  background: linear-gradient(135deg, #ff6b6b, #ee5a52);
  color: #1f2937;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 160px;
  box-shadow: 0 4px 12px rgba(238, 90, 82, 0.3);
}

.delete-confirm-btn:hover {
  background: linear-gradient(135deg, #ff5252, #d32f2f);
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(238, 90, 82, 0.4);
}

.delete-confirm-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(238, 90, 82, 0.3);
}

/* Responsive design for mobile */
@media (max-width: 768px) {
  .delete-modal {
    width: 95%;
    margin: 20px;
    max-height: 85vh;
  }
  
  .modal-header {
    padding: 12px 16px;
  }
  
  .modal-close-btn {
    top: 12px;
    right: 12px;
    width: 28px;
    height: 28px;
    font-size: 16px;
  }
  
  .modal-content {
    padding: 16px;
  }
  
  .modal-actions {
    padding: 12px 16px;
    flex-direction: column;
  }
  
  .cancel-btn,
  .delete-confirm-btn {
    width: 100%;
    min-width: auto;
  }
}

@media (max-height: 600px) {
  .delete-modal {
    max-height: 95vh;
  }
  
  .delete-modal .modal-body {
    padding: 12px 16px;
  }
  
  .delete-modal .case-info,
  .delete-modal .warning-box,
  .delete-modal .content-summary {
    padding: 8px 12px;
    margin: 8px 0;
  }
}

/* File Type Modal */
.file-type-modal {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  animation: modalSlideIn 0.3s ease-out;
}

.file-type-modal .modal-header {
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  color: #1f2937;
  padding: 24px 32px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.file-type-modal .modal-icon {
  font-size: 48px;
  margin-bottom: 12px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.file-type-modal .modal-header h3 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.file-type-modal .modal-content {
  padding: 32px;
}

.file-preview-info {
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
}

.file-preview-info .file-icon {
  font-size: 32px;
  margin-right: 16px;
  color: #64748b;
}

.file-preview-info .file-details h4 {
  margin: 0 0 8px 0;
  color: #1e293b;
  font-size: 18px;
  font-weight: 600;
  word-break: break-word;
}

.file-preview-info .file-type-info {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}

.supported-formats {
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
}

.supported-formats h5 {
  margin: 0 0 12px 0;
  color: #0369a1;
  font-size: 16px;
  font-weight: 600;
}

.format-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.format-item {
  color: #0c4a6e;
  font-size: 14px;
  padding: 4px 0;
}

.action-suggestion {
  background: #fef3c7;
  border: 1px solid #f59e0b;
  border-radius: 8px;
  padding: 16px;
}

.action-suggestion p {
  margin: 0;
  color: #92400e;
  font-size: 14px;
  line-height: 1.5;
}

.download-confirm-btn {
  background: linear-gradient(135deg, #059669, #10b981);
  color: #1f2937;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 160px;
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);
}

.download-confirm-btn:hover {
  background: linear-gradient(135deg, #047857, #059669);
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(5, 150, 105, 0.4);
}

.download-confirm-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(5, 150, 105, 0.3);
}

/* Responsive design for file type modal */
@media (max-width: 768px) {
  .file-type-modal {
    width: 95%;
    margin: 20px;
  }
  
  .file-type-modal .modal-header {
    padding: 20px 24px;
  }
  
  .file-type-modal .modal-content {
    padding: 24px;
  }
  
  .file-preview-info {
    flex-direction: column;
    text-align: center;
  }
  
  .file-preview-info .file-icon {
    margin-right: 0;
    margin-bottom: 12px;
  }
  
  .modal-actions {
    padding: 20px 24px 24px 24px;
    flex-direction: column;
  }
  
  .cancel-btn,
  .download-confirm-btn {
    width: 100%;
    min-width: auto;
  }
}

/* File size limit indicators */
.file-size-limit {
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 6px;
  padding: 8px 12px;
  margin: 12px 0;
  color: #0369a1;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.file-size-hint {
  color: #64748b;
  font-size: 12px;
  margin-left: 8px;
  font-style: italic;
}

/* Responsive design for file size indicators */
@media (max-width: 768px) {
  .file-size-limit {
    font-size: 13px;
    padding: 6px 10px;
  }
  
  .file-size-hint {
    display: block;
    margin-left: 0;
    margin-top: 4px;
    text-align: center;
  }
}

/* File Size Error Modal */
.file-size-error-modal {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  animation: modalSlideIn 0.3s ease-out;
}

.file-size-error-modal .modal-header {
  background: linear-gradient(135deg, #dc2626, #ef4444);
  color: #1f2937;
  padding: 24px 32px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.file-size-error-modal .modal-icon {
  font-size: 48px;
  margin-bottom: 12px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.file-size-error-modal .modal-header h3 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.modal-close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: #1f2937;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  backdrop-filter: blur(4px);
}

.modal-close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.modal-close-btn:active {
  transform: scale(0.95);
}

.file-size-error-modal .modal-content {
  padding: 32px;
}

.file-error-info {
  display: flex;
  align-items: center;
  background: #fef2f2;
  border: 2px solid #fecaca;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
}

.file-error-info .file-icon {
  font-size: 32px;
  margin-right: 16px;
  color: #dc2626;
}

.file-error-info .file-details h4 {
  margin: 0 0 8px 0;
  color: #1e293b;
  font-size: 18px;
  font-weight: 600;
  word-break: break-word;
}

.file-error-info .file-size-error {
  margin: 0;
  color: #dc2626;
  font-size: 14px;
}

.size-limit-info {
  background: #fef3c7;
  border: 1px solid #f59e0b;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
}

.size-limit-info h5 {
  margin: 0 0 12px 0;
  color: #92400e;
  font-size: 16px;
  font-weight: 600;
}

.size-limit-info p {
  margin: 0 0 8px 0;
  color: #92400e;
  font-size: 14px;
  line-height: 1.5;
}

.helpful-tips {
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
}

.helpful-tips h5 {
  margin: 0 0 12px 0;
  color: #0369a1;
  font-size: 16px;
  font-weight: 600;
}

.helpful-tips ul {
  margin: 0;
  padding-left: 20px;
  color: #0c4a6e;
  font-size: 14px;
  line-height: 1.6;
}

.helpful-tips li {
  margin-bottom: 6px;
}

.close-error-btn {
  background: linear-gradient(135deg, #dc2626, #ef4444);
  color: #1f2937;
  border: none;
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
}

.close-error-btn:hover {
  background: linear-gradient(135deg, #b91c1c, #dc2626);
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(220, 38, 38, 0.4);
}

.close-error-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);
}

/* Responsive design for file size error modal */
@media (max-width: 768px) {
  .file-size-error-modal {
    width: 95%;
    margin: 20px;
  }
  
  .file-size-error-modal .modal-header {
    padding: 20px 24px;
  }
  
  .modal-close-btn {
    top: 12px;
    right: 12px;
    width: 28px;
    height: 28px;
    font-size: 16px;
  }
  
  .file-size-error-modal .modal-content {
    padding: 24px;
  }
  
  .file-error-info {
    flex-direction: column;
    text-align: center;
  }
  
  .file-error-info .file-icon {
    margin-right: 0;
    margin-bottom: 12px;
  }
  
  .modal-actions {
    padding: 20px 24px 24px 24px;
    flex-direction: column;
  }
  
  .close-error-btn {
    width: 100%;
    min-width: auto;
  }
}

/* Upload hint */
.upload-hint {
  color: #059669;
  font-size: 12px;
  margin-left: 8px;
  font-style: italic;
}

/* Categorization Review Modal */
.categorization-review-modal {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 700px;
  width: 90%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: modalSlideIn 0.3s ease-out;
}

.categorization-review-modal .modal-header {
  background: linear-gradient(135deg, #059669, #10b981);
  color: #1f2937;
  padding: 24px 32px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.categorization-review-modal .modal-icon {
  font-size: 48px;
  margin-bottom: 12px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.categorization-review-modal .modal-header h3 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.categorization-review-modal .modal-content {
  padding: 32px;
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
}

.categorization-review-modal .modal-content p {
  margin: 0 0 20px 0;
  color: #4a5568;
  line-height: 1.6;
}

.documents-to-review {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.document-review-item {
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.document-preview {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1 1;
}

.document-preview .file-icon {
  font-size: 32px;
  color: #64748b;
}

.document-preview .file-details h4 {
  margin: 0 0 8px 0;
  color: #1e293b;
  font-size: 16px;
  font-weight: 600;
  word-break: break-word;
}

.document-preview .file-details p {
  margin: 0 0 4px 0;
  color: #64748b;
  font-size: 14px;
}

.review-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 200px;
}

.category-select {
  padding: 8px 12px;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  color: #1e293b;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.category-select:focus {
  outline: none;
  border-color: #059669;
}

.categorization-review-modal .modal-actions {
  padding: 24px 32px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-shrink: 0;
}

.accept-all-btn {
  background: linear-gradient(135deg, #059669, #10b981);
  color: #1f2937;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 160px;
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);
}

.accept-all-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #047857, #059669);
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(5, 150, 105, 0.4);
}

.accept-all-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.categorization-review-modal .cancel-btn {
  background: #6b7280;
  color: #1f2937;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
}

.categorization-review-modal .cancel-btn:hover {
  background: #4b5563;
}

/* Quality Error Details */
.quality-error-details {
  margin-top: 12px;
  text-align: left;
}

.quality-error-details p {
  margin: 8px 0;
  font-size: 14px;
  line-height: 1.4;
}

.quality-error-details strong {
  color: #374151;
}

/* Success Modal */
.success-modal {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: modalSlideIn 0.3s ease-out;
}

.success-modal .modal-header {
  background: linear-gradient(135deg, #059669, #10b981);
  color: #1f2937;
  padding: 24px 32px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.success-modal .modal-icon {
  font-size: 48px;
  margin-bottom: 12px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.success-modal .modal-header h3 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.success-modal .modal-content {
  padding: 32px;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 20px;
}

.success-icon {
  font-size: 64px;
  animation: bounce 0.6s ease-in-out;
}

.success-details h4 {
  margin: 0 0 12px 0;
  color: #059669;
  font-size: 20px;
  font-weight: 600;
}

.success-details p {
  margin: 0;
  color: #4a5568;
  line-height: 1.6;
  font-size: 16px;
}

.success-modal .modal-actions {
  padding: 24px 32px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
}

.success-ok-btn {
  background: linear-gradient(135deg, #059669, #10b981);
  color: #1f2937;
  border: none;
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);
}

.success-ok-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(5, 150, 105, 0.4);
}

.success-ok-btn:active {
  transform: translateY(0);
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

/* Processing Status Modal */
.processing-status-modal {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  animation: modalSlideIn 0.3s ease-out;
}

.processing-status-modal .modal-header {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: #1f2937;
  padding: 24px 32px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.processing-status-modal .modal-icon {
  font-size: 48px;
  margin-bottom: 12px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.processing-status-modal .modal-header h3 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.processing-status-modal .modal-content {
  padding: 32px;
  text-align: center;
}

.processing-status-modal .modal-content p {
  margin: 0 0 20px 0;
  color: #4a5568;
  line-height: 1.6;
  font-size: 16px;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
  margin: 20px 0;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  border-radius: 4px;
  transition: width 0.3s ease;
}

/* Responsive design for new modals */
@media (max-width: 768px) {
  .categorization-review-modal {
    width: 95%;
    margin: 20px;
  }
  
  .categorization-review-modal .modal-header {
    padding: 20px 24px;
  }
  
  .categorization-review-modal .modal-content {
    padding: 24px;
  }
  
  .document-review-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .review-actions {
    width: 100%;
    min-width: auto;
  }
  
  .categorization-review-modal .modal-actions {
    padding: 20px 24px;
    flex-direction: column;
    gap: 12px;
  }
  
  .categorization-review-modal .modal-actions button {
    width: 100%;
    min-width: auto;
  }
  
  .success-modal {
    width: 95%;
    margin: 20px;
  }
  
  .success-modal .modal-header {
    padding: 20px 24px;
  }
  
  .success-modal .modal-content {
    padding: 24px;
  }
  
  .success-info {
    gap: 16px;
  }
  
  .success-icon {
    font-size: 48px;
  }
  
  .success-details h4 {
    font-size: 18px;
  }
  
  .success-details p {
    font-size: 14px;
  }
  
  .success-modal .modal-actions {
    padding: 20px 24px;
  }
  
  .success-ok-btn {
    width: 100%;
    min-width: auto;
  }
  
  .processing-status-modal {
    width: 95%;
    margin: 20px;
  }
  
  .processing-status-modal .modal-header {
    padding: 20px 24px;
  }
  
  .processing-status-modal .modal-content {
    padding: 24px;
  }
  
  .upload-hint {
    display: block;
    margin-left: 0;
    margin-top: 4px;
    text-align: center;
  }
}

/* Custom Category Modal */
.custom-category-modal {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: modalSlideIn 0.3s ease-out;
}

.custom-category-modal .modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #1f2937;
  padding: 24px 32px;
  border-radius: 16px 16px 0 0;
  display: flex;
  align-items: center;
  gap: 16px;
}

.custom-category-modal .modal-content {
  padding: 32px;
  flex: 1 1;
  overflow-y: auto;
}

.custom-category-modal .form-group {
  margin-bottom: 24px;
}

.custom-category-modal .form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}

.custom-category-modal .form-input,
.custom-category-modal .form-textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
}

.custom-category-modal .form-input:focus,
.custom-category-modal .form-textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.custom-category-modal .form-textarea {
  resize: vertical;
  min-height: 80px;
}

.custom-category-modal .modal-actions {
  padding: 24px 32px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  flex-shrink: 0;
}

.custom-category-modal .create-btn {
  background: #667eea;
  color: #1f2937;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px;
}

.custom-category-modal .create-btn:hover {
  background: #5a67d8;
  transform: translateY(-1px);
}

.custom-category-modal .create-btn:active {
  transform: translateY(0);
}

@media (max-width: 768px) {
  .custom-category-modal {
    width: 95%;
    margin: 20px;
  }
  
  .custom-category-modal .modal-header {
    padding: 20px 24px;
  }
  
  .custom-category-modal .modal-content {
    padding: 24px;
  }
  
  .custom-category-modal .modal-actions {
    padding: 20px 24px;
    flex-direction: column;
  }
  
  .custom-category-modal .modal-actions button {
    width: 100%;
    min-width: auto;
  }
}

/* Multi-file upload improvements */
.upload-btn {
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
}

.upload-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.upload-btn::after {
  content: "";
  font-size: 0.8em;
  opacity: 0.7;
  font-weight: normal;
}

/* Drag and Drop Upload Areas */
.upload-action {
  position: relative;
  transition: all 0.2s ease;
}

.upload-action:hover {
  transform: translateY(-1px);
}

.upload-action:active {
  transform: translateY(0);
}

.bulk-upload {
  position: relative;
  transition: all 0.2s ease;
}

.bulk-upload:hover {
  transform: translateY(-1px);
}

.bulk-upload:active {
  transform: translateY(0);
}

/* Drag over states */
.upload-action.drag-over,
.bulk-upload.drag-over {
  border-color: #3b82f6 !important;
  background-color: #f0f9ff !important;
  transform: scale(1.02);
}

/* Form Bulk Operations */
.autofill-checkbox-container {
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.autofill-checkbox-container:hover {
  background-color: #f3f4f6;
}

.autofill-checkbox {
  accent-color: #7c3aed;
  cursor: pointer;
}

.autofill-checkbox:hover {
  transform: scale(1.1);
}

.autofill-hint {
  font-size: 8px;
  color: #7c3aed;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.autofill-checkbox-container:hover .autofill-hint {
  opacity: 1;
}

/* Disabled download checkbox styling */
.download-checkbox:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.download-checkbox:disabled:hover {
  transform: none;
}

.download-checkbox-container:has(.download-checkbox:disabled):hover {
  background-color: transparent;
}

/* Loading animation */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

/* File upload progress indicator */
.upload-progress {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 5px;
  font-size: 0.9em;
  color: #666;
}

.upload-progress-bar {
  flex: 1 1;
  height: 4px;
  background-color: #e0e0e0;
  border-radius: 2px;
  overflow: hidden;
}

.upload-progress-fill {
  height: 100%;
  background-color: #007bff;
  transition: width 0.3s ease;
}

/* Success message for multiple uploads */
.upload-success {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
  padding: 8px 12px;
  border-radius: 4px;
  margin-top: 5px;
  font-size: 0.9em;
}

/* PDF Merging Styles */
.merge-pdfs-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #1f2937;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  margin-right: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.merge-pdfs-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.merge-checkbox {
  margin-right: 8px;
  transform: scale(1.2);
  accent-color: #667eea;
}

/* PDF Merge Modal */
.pdf-merge-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.15);
  max-width: 700px;
  width: 90%;
  max-height: 85vh;
  overflow-y: auto;
  position: relative;
}

.pdf-merge-modal .modal-header {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pdf-merge-modal .modal-header h3 {
  font-weight: 600;
  font-size: 18px;
  color: #1f2937;
}

.pdf-merge-modal .modal-content {
  padding: 16px;
  max-height: 65vh;
  overflow-y: auto;
}

.merge-section {
  margin-bottom: 16px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.merge-section h4 {
  margin: 0 0 12px 0;
  color: #495057;
  font-size: 16px;
  font-weight: 600;
}

.document-selection-list {
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: white;
}

.document-selection-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #f1f3f4;
  transition: background-color 0.2s ease;
}

.document-selection-item:hover {
  background-color: #f8f9fa;
}

.document-selection-item:last-child {
  border-bottom: none;
}

.document-selection-item .document-details {
  flex: 1 1;
  margin-left: 8px;
}

.document-selection-item .document-details strong {
  display: block;
  font-size: 14px;
  color: #212529;
}

.document-selection-item .document-details small {
  color: #6c757d;
  font-size: 12px;
}

.merge-order-controls {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.merge-order-controls label {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}

.merge-order-controls label:hover {
  background-color: #e9ecef;
}

.merge-order-controls input[type="radio"] {
  margin-right: 8px;
  transform: scale(1.1);
  accent-color: #667eea;
}

.custom-order-interface {
  margin-top: 16px;
  padding: 16px;
  background: white;
  border-radius: 6px;
  border: 1px solid #dee2e6;
}

.custom-order-list {
  margin-top: 12px;
}

.custom-order-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin: 4px 0;
  background: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

.custom-order-item .order-number {
  font-weight: bold;
  color: #667eea;
  margin-right: 12px;
  min-width: 20px;
}

.custom-order-item .file-name {
  flex: 1 1;
  font-size: 14px;
}

.custom-order-item .drag-handle {
  color: #6c757d;
  cursor: grab;
  font-size: 16px;
}

.merge-actions {
  text-align: center;
  padding: 16px 0;
  border-top: 1px solid #e9ecef;
  margin-top: 16px;
}

.merge-btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 200px;
}

.merge-btn.enabled {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #1f2937;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.merge-btn.enabled:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.merge-btn.disabled {
  background: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
}

.merged-documents-list {
  max-height: 150px;
  overflow-y: auto;
}

.merged-document-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  margin: 8px 0;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  transition: box-shadow 0.2s ease;
}

.merged-document-item:hover {
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.merged-doc-info strong {
  display: block;
  font-size: 14px;
  color: #212529;
}

.merged-doc-info small {
  color: #6c757d;
  font-size: 12px;
}

.merged-doc-actions {
  display: flex;
  gap: 8px;
}

.merged-doc-actions .download-btn,
.merged-doc-actions .delete-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.merged-doc-actions .download-btn {
  background: #28a745;
  color: #1f2937;
}

.merged-doc-actions .download-btn:hover {
  background: #218838;
}

.merged-doc-actions .delete-btn {
  background: #dc3545;
  color: #1f2937;
}

.merged-doc-actions .delete-btn:hover {
  background: #c82333;
}

.no-merged-docs {
  text-align: center;
  color: #6c757d;
  font-style: italic;
  padding: 20px;
}

/* Enhanced document list with merge checkboxes */
.uploaded-document .document-info {
  display: flex;
  align-items: center;
  flex: 1 1;
}

.uploaded-document .document-info .file-icon {
  margin-left: 8px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .pdf-merge-modal {
    width: 95%;
    margin: 20px;
  }
  
  .merge-order-controls {
    gap: 8px;
  }
  
  .merged-doc-actions {
    flex-direction: column;
    gap: 4px;
  }
  
  .merged-doc-actions .download-btn,
  .merged-doc-actions .delete-btn {
    padding: 4px 8px;
    font-size: 11px;
  }
}

/* Custom Order Interface Styles */
.custom-order-interface {
  margin-top: 16px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.custom-order-interface p {
  margin: 0 0 12px 0;
  font-weight: 600;
  color: #495057;
}

.custom-order-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.custom-order-item {
  display: flex;
  align-items: center;
  padding: 12px;
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  cursor: grab;
  transition: all 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
}

.custom-order-item:hover {
  border-color: #007bff;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1);
}

.custom-order-item.dragging {
  opacity: 0.5;
  transform: rotate(2deg);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  cursor: grabbing;
}

.custom-order-item.drag-over {
  border-color: #28a745;
  background: #f8fff9;
  transform: scale(1.02);
}

.custom-order-item .order-number {
  font-weight: bold;
  color: #007bff;
  margin-right: 12px;
  min-width: 24px;
}

.custom-order-item .file-name {
  flex: 1 1;
  font-size: 14px;
  color: #495057;
}

.custom-order-item .drag-handle {
  color: #6c757d;
  font-size: 16px;
  cursor: grab;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.2s ease;
}

.custom-order-item .drag-handle:hover {
  background: #e9ecef;
  color: #495057;
}

.custom-order-item.dragging .drag-handle {
  cursor: grabbing;
}

/* Merge Modal Improvements */
.pdf-merge-modal .modal-content {
  max-height: 80vh;
  overflow-y: auto;
}

.merge-section {
  margin-bottom: 24px;
}

.merge-section h4 {
  margin: 0 0 16px 0;
  color: #495057;
  font-size: 16px;
  font-weight: 600;
}

.merge-order-controls {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.merge-order-controls label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background 0.2s ease;
}

.merge-order-controls label:hover {
  background: #f8f9fa;
}

.merge-order-controls input[type="radio"] {
  margin: 0;
}

.merge-actions {
  margin-top: 24px;
  text-align: center;
}

.merge-btn {
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.merge-btn.enabled {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: #1f2937;
}

.merge-btn.enabled:hover {
  background: #5a32a3;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(111, 66, 193, 0.3);
}

.merge-btn.disabled {
  background: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
}

/* Drag and Drop Visual Improvements */
.custom-order-item:active {
  cursor: grabbing;
}

.custom-order-item.dragging {
  z-index: 1000;
  position: relative;
}

.custom-order-item.drag-over::before {
  content: '';
  position: absolute;
  top: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background: #28a745;
  border-radius: 1px;
}

/* Case Forms Styles */
.case-forms-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.forms-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e0e0e0;
}

.forms-header h2 {
  margin: 0;
  color: #333;
  font-size: 24px;
}

.case-selector {
  display: flex;
  align-items: center;
  gap: 10px;
}

.case-dropdown {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  font-size: 14px;
  min-width: 250px;
}

.no-case-selected {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.no-case-selected h2 {
  margin-bottom: 10px;
  color: #333;
}

.forms-content {
  display: grid;
  gap: 30px;
}

.available-forms-section,
.selected-forms-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
}

.add-custom-btn {
  background: #007bff;
  color: #1f2937;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.add-custom-btn:hover {
  background: #0056b3;
}

.forms-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.form-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  background: #fafafa;
  transition: all 0.2s ease;
}

.form-card:hover {
  border-color: #007bff;
  box-shadow: 0 2px 8px rgba(0,123,255,0.1);
}

.form-card .form-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}

.form-card h4 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 16px;
  line-height: 1.3;
}

.form-description {
  color: #666;
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 12px;
}

.form-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  font-size: 12px;
}

.estimated-time {
  color: #666;
}

.category-badge {
  background: #e9ecef;
  color: #495057;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
}

.add-form-btn {
  width: 100%;
  background: #28a745;
  color: #1f2937;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.add-form-btn:hover {
  background: #218838;
}

.selected-forms-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.selected-form-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}

.form-info {
  flex: 1 1;
}

.selected-form-item .form-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.selected-form-item h4 {
  margin: 0;
  color: #333;
  font-size: 16px;
  flex: 1 1;
}

.custom-badge {
  background: #ffc107;
  color: #212529;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: bold;
}

.status-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-completed {
  background: #d4edda;
  color: #155724;
}

.status-processing {
  background: #cce7ff;
  color: #004085;
}

.status-pending {
  background: #fff3cd;
  color: #856404;
}

.priority-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.priority-high {
  background: #f8d7da;
  color: #721c24;
}

.priority-medium {
  background: #fff3cd;
  color: #856404;
}

.priority-low {
  background: #d1ecf1;
  color: #0c5460;
}

.form-details {
  display: grid;
  gap: 8px;
  margin-top: 12px;
}

.form-detail-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.form-detail-item label {
  font-weight: 500;
  color: #333;
  min-width: 120px;
  font-size: 14px;
}

.required-docs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.doc-tag {
  background: #e9ecef;
  color: #495057;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  text-transform: capitalize;
}

.form-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 150px;
}

.status-select {
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  font-size: 12px;
}

.view-form-btn {
  background: #007bff;
  color: #1f2937;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.view-form-btn:hover {
  background: #0056b3;
}

.remove-btn {
  background: #dc3545;
  color: #1f2937;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.remove-btn:hover {
  background: #c82333;
}

.no-forms-message {
  text-align: center;
  padding: 40px 20px;
  color: #666;
  font-style: italic;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
}

/* Modal styles for custom form */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: white;
  border-radius: 8px;
  padding: 0;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.modal-header h3 {
  margin: 0;
  color: #333;
}

.modal-content {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
}

.form-group input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.add-btn {
  background: #28a745;
  color: #1f2937;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.add-btn:hover {
  background: #218838;
}

.cancel-btn {
  background: #6c757d;
  color: #1f2937;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.cancel-btn:hover {
  background: #5a6268;
}

/* Responsive design */
@media (max-width: 768px) {
  .forms-header {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
  
  .case-dropdown {
    min-width: auto;
  }
  
  .forms-grid {
    grid-template-columns: 1fr;
  }
  
  .selected-form-item {
    flex-direction: column;
    gap: 15px;
  }
  
  .form-actions {
    min-width: auto;
    width: 100%;
  }
  
  .form-actions {
    flex-direction: row;
    justify-content: space-between;
  }
}

/* Form Selection Controls */
.form-selection-controls {
  display: flex;
  gap: 12px;
  align-items: center;
}

.form-category-dropdown {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  font-size: 14px;
  min-width: 200px;
}

.form-selection-area {
  margin-top: 20px;
}

.form-dropdown-section {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
}

.form-dropdown-section label {
  display: block;
  margin-bottom: 15px;
  font-weight: 600;
  color: #333;
  font-size: 16px;
}

.form-options-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 15px;
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;
  background: white;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
}

.form-option-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #fafafa;
  transition: all 0.2s ease;
}

.form-option-item:hover {
  border-color: #007bff;
  background: #f0f8ff;
}

.form-option-info {
  flex: 1 1;
  margin-right: 15px;
}

.form-option-info .form-name {
  display: block;
  font-weight: 600;
  color: #333;
  font-size: 14px;
  margin-bottom: 5px;
  line-height: 1.3;
}

.form-option-info .form-description {
  display: block;
  color: #666;
  font-size: 12px;
  margin-bottom: 8px;
  line-height: 1.4;
}

.form-option-info .form-meta {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.form-option-info .estimated-time {
  font-size: 11px;
  color: #666;
}

.form-option-item .add-form-btn {
  background: #28a745;
  color: #1f2937;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
  min-width: 60px;
}

.form-option-item .add-form-btn:hover {
  background: #218838;
}

.no-forms-available {
  grid-column: 1 / -1;
  text-align: center;
  padding: 40px 20px;
  color: #666;
  font-style: italic;
}

/* Update existing styles */
.required-forms-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 30px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .form-selection-controls {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  
  .form-category-dropdown {
    min-width: auto;
  }
  
  .form-options-grid {
    grid-template-columns: 1fr;
    max-height: 300px;
  }
  
  .form-option-item {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  
  .form-option-info {
    margin-right: 0;
  }
  
  .form-option-item .add-form-btn {
    align-self: flex-end;
  }
}

/* Case Details Modal - Country Field */
.country-value {
  font-weight: 600;
  color: #2c5aa0;
  background: #f0f8ff;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #d1e7ff;
  display: inline-block;
  min-width: 60px;
  text-align: center;
}

/* Case Forms - Country Indicator */
.country-indicator {
  margin-bottom: 15px;
}

.country-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #1f2937;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.country-hint {
  color: #666;
  font-weight: normal;
  font-size: 13px;
  margin-left: 8px;
  font-style: italic;
}

/* Update section header for better layout */
.required-forms-section .section-header {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.required-forms-section .section-header h3 {
  margin: 0;
}

.required-forms-section .form-selection-controls {
  align-self: flex-end;
}

/* Case Forms - Form Dropdown Interface */
.form-selector {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 10px;
}

.form-dropdown {
  flex: 1 1;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  font-size: 14px;
  min-width: 300px;
}

.form-dropdown:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.form-selector .add-form-btn {
  background: #28a745;
  color: #1f2937;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  min-width: 80px;
  transition: background-color 0.2s ease;
}

.form-selector .add-form-btn:hover:not(:disabled) {
  background: #218838;
}

.form-selector .add-form-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

/* Update form dropdown section styling */
.form-dropdown-section {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.form-dropdown-section label {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #333;
  font-size: 16px;
}

/* Case Delete Modal Styles */
.delete-modal .modal-header {
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: #1f2937;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.delete-modal .modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.delete-modal .modal-body {
  padding: 20px 24px;
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
}

.delete-modal .case-info {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 12px 0;
}

.delete-modal .case-info p {
  margin: 8px 0;
  font-size: 0.9rem;
  color: #374151;
}

.delete-modal .warning-box {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 12px 0;
}

.delete-modal .warning-box p {
  margin: 8px 0;
  color: #dc3545;
  font-weight: 500;
}

.delete-modal .content-summary {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 12px 0;
}

.delete-modal .content-summary p {
  margin: 8px 0;
  font-weight: 600;
  color: #374151;
}

.delete-modal .content-summary ul {
  margin: 8px 0;
  padding-left: 20px;
}

.delete-modal .content-summary li {
  margin: 4px 0;
  color: #6b7280;
}

.delete-modal .modal-footer {
  padding: 16px 24px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;
  background: white;
}

.delete-modal .cancel-btn {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.delete-modal .cancel-btn:hover {
  background: #e5e7eb;
  border-color: #9ca3af;
}

.delete-modal .delete-btn {
  background: #dc3545;
  color: #1f2937;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.delete-modal .delete-btn:hover {
  background: #c82333;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(220, 53, 69, 0.3);
}

/* Government Requirements Notice */
.govt-requirements-notice {
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  border: 2px solid #f59e0b;
  border-radius: 12px;
  padding: 16px 20px;
  margin: 16px 0;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.1);
  animation: slideInDown 0.3s ease-out;
}

.govt-requirements-notice .notice-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.govt-requirements-notice .notice-icon {
  font-size: 18px;
  color: #92400e;
}

.govt-requirements-notice .notice-title {
  color: #92400e;
  font-weight: 600;
  font-size: 14px;
  margin: 0;
}

.govt-requirements-notice .notice-text {
  color: #92400e;
  font-size: 12px;
  line-height: 1.5;
  margin: 0;
  opacity: 0.9;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mode switch buttons */
.mode-switch {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.mode-switch.active {
  background: #185adb;
  border-color: #185adb;
  color: #fff;
}

/* Assistant full width container */
.assistant-fullwidth {
  flex: 1 1;
  display: flex;
}

/* Assistant sidebar container (split view) */
.assistant-sidebar {
  width: auto;
  min-width: 0; /* allow shrinking to avoid gaps */
  max-width: none;
  border-left: none;
  background: transparent;
  display: flex;
}

/* Allow main-content to handle full width / split flex */
.main-content {
  display: flex;
  height: calc(100vh - 64px);
}

/* Legal assistant base */
.legal-assistant.drag-over {
  outline: 2px dashed #3b82f6;
  outline-offset: -6px;
}

/* Assistant side placement borders */
.assistant-sidebar.left {
  border-right: 1px solid #e5e7eb;
}
.assistant-sidebar.right {
  border-left: 1px solid #e5e7eb;
}

/* Assistant collapse/expand controls */
.assistant-collapse-btn {
  position: absolute;
  top: 10px;
  left: -14px;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: #fff;
  color: #667eea;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

/* Dock/Undock toggle */
.dock-toggle-btn {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.dock-toggle-btn:hover {
  background: #e5e7eb;
}

/* AI-First Layout */
.main-content.ai-first {
  display: flex;
  height: 100vh;
  width: 100%;
}

.assistant-fullwidth {
  flex: 1 1;
  width: 100%;
  height: 100%;
}

.legal-assistant {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 0;
}

.assistant-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #1f2937;
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.assistant-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.header-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.back-to-dashboard-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #1f2937;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.back-to-dashboard-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.login-left, .login-right {
  border-radius: 0 0 0 0;
}
/* PDF Merge Modal - Compression and Filename Controls */
.compression-controls {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.compression-controls label {
  font-weight: 500;
  color: #374151;
  font-size: 14px;
}

.compression-select {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: white;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.compression-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.compression-info {
  font-size: 12px;
  margin: 0;
  padding: 8px 12px;
  border-radius: 6px;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  color: #0369a1;
}

.filename-controls {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.filename-controls label {
  font-weight: 500;
  color: #374151;
  font-size: 14px;
}

.filename-input {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: white;
  font-size: 14px;
  color: #374151;
  transition: border-color 0.2s ease;
}

.filename-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.filename-input::placeholder {
  color: #9ca3af;
}

.filename-info {
  font-size: 12px;
  margin: 0;
  padding: 8px 12px;
  border-radius: 6px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  color: #6b7280;
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .compression-controls label,
  .filename-controls label {
    color: #e5e7eb;
  }
  
  .compression-select,
  .filename-input {
    background: #374151;
    border-color: #4b5563;
    color: #e5e7eb;
  }
  
  .compression-select:focus,
  .filename-input:focus {
    border-color: #60a5fa;
    box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.1);
  }
  
  .filename-input::placeholder {
    color: #9ca3af;
  }
  
  .compression-info {
    background: #1e3a8a;
    border-color: #1d4ed8;
    color: #93c5fd;
  }
  
  .filename-info {
    background: #374151;
    border-color: #4b5563;
    color: #9ca3af;
  }
}

/* Mobile responsiveness */
@media (max-width: 640px) {
  .compression-controls,
  .filename-controls {
    gap: 8px;
  }
  
  .compression-select,
  .filename-input {
    padding: 10px 12px;
    font-size: 16px; /* Prevents zoom on iOS */
  }
}

/* Modern Delete Modal - Smooth & Stylish */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.delete-modal {
  background: white;
  border-radius: 24px;
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.25),
    0 0 0 1px rgba(255, 255, 255, 0.1);
  max-width: 480px;
  width: 90%;
  max-height: 85vh;
  overflow: hidden;
  animation: slideInUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  flex-direction: column;
  position: relative;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(32px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.delete-modal::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #ef4444, #f97316, #eab308, #22c55e, #3b82f6, #8b5cf6, #ec4899);
  border-radius: 24px 24px 0 0;
}

.modal-header {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  color: #dc2626;
  padding: 24px 28px 20px;
  text-align: center;
  border-bottom: 1px solid rgba(220, 38, 38, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.025em;
  display: flex;
  align-items: center;
  gap: 8px;
}

.modal-header h3::before {
  content: '🗑️';
  font-size: 18px;
}

.modal-content {
  padding: 28px;
  text-align: center;
  flex: 1 1;
}

.modal-content p {
  margin: 0 0 24px 0;
  font-size: 16px;
  color: #374151;
  line-height: 1.6;
  font-weight: 500;
}

.document-info {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  margin: 24px 0;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.document-info::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #3b82f6, #8b5cf6);
}

.document-info:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.document-info .document-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  border-radius: 12px;
  margin-right: 12px;
  color: white;
  font-size: 18px;
}

.document-info .document-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1 1;
}

.document-info strong {
  color: #1f2937;
  font-size: 16px;
  font-weight: 600;
  word-break: break-word;
  flex: 1 1;
  text-align: left;
}

.document-type-badge {
  background: linear-gradient(135deg, #f3f4f6, #e5e7eb);
  color: #6b7280;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
  border: 1px solid #d1d5db;
}

.warning-text {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fecaca;
  border-radius: 16px;
  padding: 16px 20px;
  color: #dc2626;
  font-size: 14px;
  line-height: 1.5;
  margin: 24px 0 0 0;
  font-weight: 500;
  position: relative;
  overflow: hidden;
}

.warning-text::before {
  content: '⚠️';
  margin-right: 8px;
  font-size: 16px;
}

.modal-actions {
  display: flex;
  gap: 12px;
  padding: 20px 28px 28px;
  justify-content: center;
  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
  border-top: 1px solid #e5e7eb;
}

.cancel-btn {
  background: white;
  color: #6b7280;
  border: 2px solid #e5e7eb;
  padding: 12px 24px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 120px;
  position: relative;
  overflow: hidden;
}

.cancel-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.5s;
}

.cancel-btn:hover::before {
  left: 100%;
}

.cancel-btn:hover {
  background: #f9fafb;
  border-color: #d1d5db;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  color: #374151;
}

.delete-confirm-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 160px;
  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.3);
  position: relative;
  overflow: hidden;
}

.delete-confirm-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.delete-confirm-btn:hover::before {
  left: 100%;
}

.delete-confirm-btn:hover {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4);
}

.delete-confirm-btn:active {
  transform: translateY(0);
  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.3);
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .delete-modal {
    width: 95%;
    margin: 20px;
    max-height: 90vh;
    border-radius: 20px;
  }
  
  .modal-header {
    padding: 20px 24px 16px;
  }
  
  .modal-header h3 {
    font-size: 18px;
  }
  
  .modal-content {
    padding: 24px;
  }
  
  .document-info {
    padding: 16px;
    border-radius: 12px;
  }
  
  .modal-actions {
    padding: 16px 24px 24px;
    flex-direction: column;
  }
  
  .cancel-btn,
  .delete-confirm-btn {
    width: 100%;
    min-width: auto;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .delete-modal {
    background: #1f2937;
    box-shadow: 
      0 25px 50px -12px rgba(0, 0, 0, 0.5),
      0 0 0 1px rgba(255, 255, 255, 0.1);
  }
  
  .modal-header {
    background: linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%);
    color: #fca5a5;
  }
  
  .modal-content p {
    color: #d1d5db;
  }
  
  .document-info {
    background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
    border-color: #4b5563;
  }
  
  .document-info strong {
    color: #f9fafb;
  }
  
  .document-type-badge {
    background: linear-gradient(135deg, #4b5563, #6b7280);
    color: #d1d5db;
    border-color: #6b7280;
  }
  
  .warning-text {
    background: linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%);
    border-color: #dc2626;
    color: #fca5a5;
  }
  
  .modal-actions {
    background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
    border-top-color: #4b5563;
  }
  
  .cancel-btn {
    background: #4b5563;
    color: #d1d5db;
    border-color: #6b7280;
  }
  
  .cancel-btn:hover {
    background: #6b7280;
    border-color: #9ca3af;
    color: #f9fafb;
  }
}

/* Document Item Styling for Delete Modal */
.document-item {
  display: flex;
  align-items: center;
  padding: 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  margin: 8px 0;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.document-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #3b82f6, #8b5cf6);
}

.document-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.document-item .document-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  border-radius: 10px;
  margin-right: 12px;
  color: white;
  font-size: 16px;
  flex-shrink: 0;
}

.document-item .document-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1 1;
  min-width: 0;
}

.document-item strong {
  color: #1f2937;
  font-size: 15px;
  font-weight: 600;
  word-break: break-word;
  flex: 1 1;
  text-align: left;
  margin-right: 12px;
}

.document-item .document-type-badge {
  background: linear-gradient(135deg, #f3f4f6, #e5e7eb);
  color: #6b7280;
  padding: 4px 10px;
  border-radius: 16px;
  font-size: 11px;
  font-weight: 500;
  text-transform: capitalize;
  border: 1px solid #d1d5db;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Dark mode for document items */
@media (prefers-color-scheme: dark) {
  .document-item {
    background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
    border-color: #4b5563;
  }
  
  .document-item strong {
    color: #f9fafb;
  }
  
  .document-item .document-type-badge {
    background: linear-gradient(135deg, #4b5563, #6b7280);
    color: #d1d5db;
    border-color: #6b7280;
  }
}

/* Enhanced Bulk Delete Modal - Smooth & Modern */
.documents-to-delete {
  max-height: 300px;
  overflow-y: auto;
  border: none;
  border-radius: 16px;
  padding: 16px;
  margin: 20px 0;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  box-shadow: 
    inset 0 2px 4px rgba(0, 0, 0, 0.06),
    0 1px 3px rgba(0, 0, 0, 0.1);
  position: relative;
}

.documents-to-delete::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899);
  border-radius: 16px 16px 0 0;
}

.document-to-delete {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border: none;
  background: white;
  border-radius: 12px;
  margin-bottom: 12px;
  box-shadow: 
    0 2px 8px rgba(0, 0, 0, 0.04),
    0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.document-to-delete::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(180deg, #ef4444, #dc2626);
  border-radius: 0 2px 2px 0;
}

.document-to-delete:hover {
  transform: translateY(-2px);
  box-shadow: 
    0 8px 25px rgba(0, 0, 0, 0.1),
    0 4px 12px rgba(0, 0, 0, 0.05);
  background: linear-gradient(135deg, #ffffff 0%, #fefefe 100%);
}

.document-to-delete:last-child {
  margin-bottom: 0;
}

.document-to-delete .document-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #ef4444, #dc2626);
  border-radius: 10px;
  color: white;
  font-size: 18px;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
  flex-shrink: 0;
}

.document-to-delete .document-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.document-to-delete .document-info strong {
  display: block;
  font-size: 15px;
  color: #1f2937;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
}

.document-to-delete .document-info small {
  display: block;
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
  text-transform: capitalize;
  background: linear-gradient(135deg, #f3f4f6, #e5e7eb);
  padding: 2px 8px;
  border-radius: 6px;
  width: fit-content;
  border: 1px solid #d1d5db;
}

/* Enhanced warning text for bulk delete */
.bulk-delete-warning {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fecaca;
  border-radius: 16px;
  padding: 20px 24px;
  color: #dc2626;
  font-size: 15px;
  line-height: 1.6;
  margin: 24px 0 0 0;
  font-weight: 600;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.1);
}

.bulk-delete-warning::before {
  content: '⚠️';
  margin-right: 10px;
  font-size: 18px;
  display: inline-block;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

/* Enhanced modal actions for bulk delete */
.bulk-delete-actions {
  display: flex;
  gap: 16px;
  padding: 24px 28px 28px;
  justify-content: center;
  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
  border-top: 1px solid #e5e7eb;
}

.bulk-delete-cancel-btn {
  background: white;
  color: #6b7280;
  border: 2px solid #e5e7eb;
  padding: 14px 28px;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 140px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.bulk-delete-cancel-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.5s;
}

.bulk-delete-cancel-btn:hover::before {
  left: 100%;
}

.bulk-delete-cancel-btn:hover {
  background: #f9fafb;
  border-color: #d1d5db;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  color: #374151;
}

.bulk-delete-confirm-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  border: none;
  padding: 14px 28px;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 180px;
  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.3);
  position: relative;
  overflow: hidden;
}

.bulk-delete-confirm-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.bulk-delete-confirm-btn:hover::before {
  left: 100%;
}

.bulk-delete-confirm-btn:hover {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4);
}

.bulk-delete-confirm-btn:active {
  transform: translateY(0);
  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.3);
}

.bulk-delete-confirm-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* Mobile responsiveness for bulk delete */
@media (max-width: 768px) {
  .documents-to-delete {
    max-height: 250px;
    padding: 12px;
    border-radius: 12px;
  }
  
  .document-to-delete {
    padding: 12px 16px;
    border-radius: 10px;
    margin-bottom: 8px;
  }
  
  .document-to-delete .document-icon {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }
  
  .document-to-delete .document-info strong {
    font-size: 14px;
  }
  
  .document-to-delete .document-info small {
    font-size: 11px;
  }
  
  .bulk-delete-actions {
    flex-direction: column;
    gap: 12px;
    padding: 20px 24px 24px;
  }
  
  .bulk-delete-cancel-btn,
  .bulk-delete-confirm-btn {
    width: 100%;
    min-width: auto;
    padding: 16px 24px;
  }
}

/* Dark mode support for bulk delete */
@media (prefers-color-scheme: dark) {
  .documents-to-delete {
    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
    border-color: #374151;
  }
  
  .document-to-delete {
    background: #374151;
    border-color: #4b5563;
  }
  
  .document-to-delete:hover {
    background: linear-gradient(135deg, #4b5563 0%, #374151 100%);
  }
  
  .document-to-delete .document-info strong {
    color: #f9fafb;
  }
  
  .document-to-delete .document-info small {
    background: linear-gradient(135deg, #4b5563, #374151);
    color: #d1d5db;
    border-color: #6b7280;
  }
  
  .bulk-delete-warning {
    background: linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%);
    border-color: #dc2626;
    color: #fecaca;
  }
  
  .bulk-delete-actions {
    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
    border-color: #374151;
  }
  
  .bulk-delete-cancel-btn {
    background: #374151;
    color: #d1d5db;
    border-color: #4b5563;
  }
  
  .bulk-delete-cancel-btn:hover {
    background: #4b5563;
    border-color: #6b7280;
    color: #f9fafb;
  }
}

/* Smooth document list animations */
.document-to-delete {
  animation: slideInFromLeft 0.4s cubic-bezier(0.4, 0, 0.2, 1) both;
}

.document-to-delete:nth-child(1) { animation-delay: 0.1s; }
.document-to-delete:nth-child(2) { animation-delay: 0.15s; }
.document-to-delete:nth-child(3) { animation-delay: 0.2s; }
.document-to-delete:nth-child(4) { animation-delay: 0.25s; }
.document-to-delete:nth-child(5) { animation-delay: 0.3s; }
.document-to-delete:nth-child(6) { animation-delay: 0.35s; }
.document-to-delete:nth-child(7) { animation-delay: 0.4s; }
.document-to-delete:nth-child(8) { animation-delay: 0.45s; }
.document-to-delete:nth-child(9) { animation-delay: 0.5s; }
.document-to-delete:nth-child(10) { animation-delay: 0.55s; }

@keyframes slideInFromLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Enhanced scrollbar for documents list */
.documents-to-delete::-webkit-scrollbar {
  width: 6px;
}

.documents-to-delete::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}

.documents-to-delete::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #3b82f6, #8b5cf6);
  border-radius: 3px;
}

.documents-to-delete::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #2563eb, #7c3aed);
}

/* Smooth loading state for bulk delete */
.bulk-delete-loading {
  position: relative;
  overflow: hidden;
}

.bulk-delete-loading::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

/* Clean & Minimal Bulk Delete Modal - Refined Design */
.documents-to-delete {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 0;
  margin: 20px 0;
  background: #fafafa;
  box-shadow: none;
  position: relative;
}

.documents-to-delete::before {
  display: none; /* Remove colorful accent bar */
}

.document-to-delete {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  border: none;
  background: white;
  border-radius: 0;
  margin-bottom: 0;
  box-shadow: none;
  transition: all 0.2s ease;
  position: relative;
  border-bottom: 1px solid #f3f4f6;
}

.document-to-delete::before {
  display: none; /* Remove red accent line */
}

.document-to-delete:last-child {
  border-bottom: none;
  border-radius: 0 0 12px 12px;
}

.document-to-delete:first-child {
  border-radius: 12px 12px 0 0;
}

.document-to-delete:hover {
  background: #f8fafc;
  transform: none;
  box-shadow: none;
}

.document-to-delete .document-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #f3f4f6;
  border-radius: 8px;
  color: #6b7280;
  font-size: 16px;
  box-shadow: none;
  flex-shrink: 0;
  border: 1px solid #e5e7eb;
}

.document-to-delete .document-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.document-to-delete .document-info strong {
  display: block;
  font-size: 14px;
  color: #1f2937;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
}

.document-to-delete .document-info small {
  display: block;
  font-size: 12px;
  color: #9ca3af;
  font-weight: 400;
  text-transform: capitalize;
  background: none;
  padding: 0;
  border-radius: 0;
  width: auto;
  border: none;
}

/* Clean warning text */
.bulk-delete-warning {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 16px 20px;
  color: #dc2626;
  font-size: 14px;
  line-height: 1.5;
  margin: 20px 0 0 0;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  box-shadow: none;
}

.bulk-delete-warning::before {
  content: '⚠️';
  margin-right: 8px;
  font-size: 16px;
  display: inline-block;
  animation: none; /* Remove pulse animation */
}

/* Clean modal actions */
.bulk-delete-actions {
  display: flex;
  gap: 12px;
  padding: 20px 28px 28px;
  justify-content: center;
  background: #fafafa;
  border-top: 1px solid #e5e7eb;
}

.bulk-delete-cancel-btn {
  background: white;
  color: #6b7280;
  border: 1px solid #d1d5db;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
  position: relative;
  overflow: hidden;
  box-shadow: none;
}

.bulk-delete-cancel-btn::before {
  display: none; /* Remove shimmer effect */
}

.bulk-delete-cancel-btn:hover {
  background: #f9fafb;
  border-color: #9ca3af;
  transform: none;
  box-shadow: none;
  color: #374151;
}

.bulk-delete-confirm-btn {
  background: #dc2626;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 160px;
  box-shadow: none;
  position: relative;
  overflow: hidden;
}

.bulk-delete-confirm-btn::before {
  display: none; /* Remove shimmer effect */
}

.bulk-delete-confirm-btn:hover {
  background: #b91c1c;
  transform: none;
  box-shadow: none;
}

.bulk-delete-confirm-btn:active {
  transform: none;
  box-shadow: none;
}

.bulk-delete-confirm-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Remove all animations for cleaner look */
.document-to-delete {
  animation: none;
}

.document-to-delete:nth-child(1),
.document-to-delete:nth-child(2),
.document-to-delete:nth-child(3),
.document-to-delete:nth-child(4),
.document-to-delete:nth-child(5),
.document-to-delete:nth-child(6),
.document-to-delete:nth-child(7),
.document-to-delete:nth-child(8),
.document-to-delete:nth-child(9),
.document-to-delete:nth-child(10) {
  animation-delay: 0s;
}

/* Clean scrollbar */
.documents-to-delete::-webkit-scrollbar {
  width: 6px;
}

.documents-to-delete::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.documents-to-delete::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.documents-to-delete::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .documents-to-delete {
    max-height: 250px;
    border-radius: 8px;
  }
  
  .document-to-delete {
    padding: 12px 16px;
  }
  
  .document-to-delete .document-icon {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }
  
  .document-to-delete .document-info strong {
    font-size: 13px;
  }
  
  .document-to-delete .document-info small {
    font-size: 11px;
  }
  
  .bulk-delete-actions {
    flex-direction: column;
    gap: 10px;
    padding: 16px 20px 20px;
  }
  
  .bulk-delete-cancel-btn,
  .bulk-delete-confirm-btn {
    width: 100%;
    min-width: auto;
    padding: 14px 20px;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .documents-to-delete {
    background: #1f2937;
    border-color: #374151;
  }
  
  .document-to-delete {
    background: #374151;
    border-color: #4b5563;
  }
  
  .document-to-delete:hover {
    background: #4b5563;
  }
  
  .document-to-delete .document-icon {
    background: #4b5563;
    color: #9ca3af;
    border-color: #6b7280;
  }
  
  .document-to-delete .document-info strong {
    color: #f9fafb;
  }
  
  .document-to-delete .document-info small {
    color: #9ca3af;
  }
  
  .bulk-delete-warning {
    background: #7f1d1d;
    border-color: #dc2626;
    color: #fecaca;
  }
  
  .bulk-delete-actions {
    background: #1f2937;
    border-color: #374151;
  }
  
  .bulk-delete-cancel-btn {
    background: #374151;
    color: #d1d5db;
    border-color: #4b5563;
  }
  
  .bulk-delete-cancel-btn:hover {
    background: #4b5563;
    border-color: #6b7280;
    color: #f9fafb;
  }
}

/* Compact Bulk Delete Modal - Space Efficient */
.documents-to-delete {
  max-height: 200px; /* Reduced from 300px */
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0;
  margin: 16px 0; /* Reduced margin */
  background: #fafafa;
  box-shadow: none;
  position: relative;
}

.document-to-delete {
  display: flex;
  align-items: center;
  gap: 12px; /* Reduced gap */
  padding: 10px 16px; /* Reduced padding */
  border: none;
  background: white;
  border-radius: 0;
  margin-bottom: 0;
  box-shadow: none;
  transition: all 0.2s ease;
  position: relative;
  border-bottom: 1px solid #f3f4f6;
  min-height: 48px; /* Fixed height for consistency */
}

.document-to-delete:last-child {
  border-bottom: none;
  border-radius: 0 0 8px 8px;
}

.document-to-delete:first-child {
  border-radius: 8px 8px 0 0;
}

.document-to-delete:hover {
  background: #f8fafc;
  transform: none;
  box-shadow: none;
}

.document-to-delete .document-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px; /* Reduced from 36px */
  height: 28px; /* Reduced from 36px */
  background: #f3f4f6;
  border-radius: 6px; /* Reduced from 8px */
  color: #6b7280;
  font-size: 14px; /* Reduced from 16px */
  box-shadow: none;
  flex-shrink: 0;
  border: 1px solid #e5e7eb;
}

.document-to-delete .document-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px; /* Reduced gap */
  justify-content: center; /* Center content vertically */
}

.document-to-delete .document-info strong {
  display: block;
  font-size: 13px; /* Reduced from 14px */
  color: #1f2937;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3; /* Tighter line height */
}

.document-to-delete .document-info small {
  display: block;
  font-size: 11px; /* Reduced from 12px */
  color: #9ca3af;
  font-weight: 400;
  text-transform: capitalize;
  background: none;
  padding: 0;
  border-radius: 0;
  width: auto;
  border: none;
  line-height: 1.2; /* Tighter line height */
}

/* Compact warning text */
.bulk-delete-warning {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px; /* Reduced from 8px */
  padding: 12px 16px; /* Reduced padding */
  color: #dc2626;
  font-size: 13px; /* Reduced from 14px */
  line-height: 1.4; /* Tighter line height */
  margin: 16px 0 0 0; /* Reduced margin */
  font-weight: 500;
  position: relative;
  overflow: hidden;
  box-shadow: none;
}

.bulk-delete-warning::before {
  content: '⚠️';
  margin-right: 6px; /* Reduced margin */
  font-size: 14px; /* Reduced from 16px */
  display: inline-block;
  animation: none;
}

/* Compact modal actions */
.bulk-delete-actions {
  display: flex;
  gap: 10px; /* Reduced gap */
  padding: 16px 20px 20px; /* Reduced padding */
  justify-content: center;
  background: #fafafa;
  border-top: 1px solid #e5e7eb;
}

.bulk-delete-cancel-btn {
  background: white;
  color: #6b7280;
  border: 1px solid #d1d5db;
  padding: 10px 20px; /* Reduced padding */
  border-radius: 6px; /* Reduced from 8px */
  font-size: 13px; /* Reduced from 14px */
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px; /* Reduced from 120px */
  position: relative;
  overflow: hidden;
  box-shadow: none;
}

.bulk-delete-confirm-btn {
  background: #dc2626;
  color: white;
  border: none;
  padding: 10px 20px; /* Reduced padding */
  border-radius: 6px; /* Reduced from 8px */
  font-size: 13px; /* Reduced from 14px */
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px; /* Reduced from 160px */
  box-shadow: none;
  position: relative;
  overflow: hidden;
}

/* Alternative compact layout for many documents */
.documents-to-delete.compact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr; /* Two columns */
  gap: 1px;
  background: #e5e7eb;
  padding: 1px;
  border-radius: 8px;
  max-height: 180px;
}

.documents-to-delete.compact-grid .document-to-delete {
  background: white;
  border: none;
  border-radius: 0;
  margin: 0;
  min-height: 40px;
  padding: 8px 12px;
}

.documents-to-delete.compact-grid .document-to-delete:nth-child(odd) {
  border-radius: 0;
}

.documents-to-delete.compact-grid .document-to-delete:nth-child(even) {
  border-radius: 0;
}

.documents-to-delete.compact-grid .document-to-delete .document-icon {
  width: 24px;
  height: 24px;
  font-size: 12px;
}

.documents-to-delete.compact-grid .document-to-delete .document-info strong {
  font-size: 12px;
}

.documents-to-delete.compact-grid .document-to-delete .document-info small {
  font-size: 10px;
}

/* Mobile responsiveness for compact design */
@media (max-width: 768px) {
  .documents-to-delete {
    max-height: 160px; /* Even more compact on mobile */
    border-radius: 6px;
  }
  
  .document-to-delete {
    padding: 8px 12px;
    min-height: 44px;
  }
  
  .document-to-delete .document-icon {
    width: 24px;
    height: 24px;
    font-size: 12px;
  }
  
  .document-to-delete .document-info strong {
    font-size: 12px;
  }
  
  .document-to-delete .document-info small {
    font-size: 10px;
  }
  
  .bulk-delete-actions {
    flex-direction: column;
    gap: 8px;
    padding: 12px 16px 16px;
  }
  
  .bulk-delete-cancel-btn,
  .bulk-delete-confirm-btn {
    width: 100%;
    min-width: auto;
    padding: 12px 16px;
  }
  
  /* Single column on mobile for grid layout */
  .documents-to-delete.compact-grid {
    grid-template-columns: 1fr;
    max-height: 140px;
  }
}

/* Dark mode support for compact design */
@media (prefers-color-scheme: dark) {
  .documents-to-delete {
    background: #1f2937;
    border-color: #374151;
  }
  
  .document-to-delete {
    background: #374151;
    border-color: #4b5563;
  }
  
  .document-to-delete:hover {
    background: #4b5563;
  }
  
  .document-to-delete .document-icon {
    background: #4b5563;
    color: #9ca3af;
    border-color: #6b7280;
  }
  
  .document-to-delete .document-info strong {
    color: #f9fafb;
  }
  
  .document-to-delete .document-info small {
    color: #9ca3af;
  }
  
  .bulk-delete-warning {
    background: #7f1d1d;
    border-color: #dc2626;
    color: #fecaca;
  }
  
  .bulk-delete-actions {
    background: #1f2937;
    border-color: #374151;
  }
  
  .bulk-delete-cancel-btn {
    background: #374151;
    color: #d1d5db;
    border-color: #4b5563;
  }
  
  .bulk-delete-cancel-btn:hover {
    background: #4b5563;
    border-color: #6b7280;
    color: #f9fafb;
  }
  
  .documents-to-delete.compact-grid {
    background: #374151;
  }
}
/* Desktop / large screens */
.create-account-container {
  display: flex;
  width: 100%;
  height: 100vh; /* full viewport height */
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: auto;
  border-radius: 0;
}

/* Left panel — take fixed width and full height */
.create-account-left {
  width: 40%;              /* adjust percentage as you like (e.g. 35%, 45%) */
  background: #185adb;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 48px;
  box-sizing: border-box;
  height: 100%;             /* full vertical stretch */
  border-radius: 0;
}

/* Right panel — flexes to fill rest of screen */
.create-account-right {
  flex: 1 1;
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 24px 32px;
  box-sizing: border-box;
  overflow: auto;     
  border-radius: 0;
  max-height: 100vh;
}

/* Scroll only form area */
.create-account-right .form-scroll-area {
  flex: 1 1;
  overflow-y: auto;
  width: 100%;
  padding-right: 8px;
  box-sizing: border-box;
  max-height: 8vh;
}

/* Mobile view: stack panels vertically */
@media (max-width: 950px) {
  .create-account-container {
    flex-direction: column;
    height: 100vh;
  }

  .create-account-left {
    width: 100%;
    height: 40%; /* left section smaller on mobile */
  }

  .create-account-right {
    width: 100%;
    height: 60%; /* right section takes rest */
    padding: 24px 16px;
  }

  .create-account-right .form-scroll-area {
    padding-right: 0;
  }
}

.nav-logo {
  display: flex;
  align-items: center; /* vertically centers the logo */
  height: 125px; /* navbar height you want */
}

.logo-img {
  max-height: 100%; /* fits the container's height */
  width: auto;      /* maintains aspect ratio */
  height: 170px;
  object-fit: contain;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,+DAA+D;;AAE/D,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,qEAAqE;AACvE;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,YAAY,QAAQ,eAAe;EACnC,aAAa,OAAO,gBAAgB;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,wCAAwC;;AAGxC,4BAA4B;AAC5B;EACE,uKAAuK;AACzK;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uKAAuK;EACvK,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,+BAA+B;AAC/B,yDAAyD;AACzD;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,4DAA4D;AAC5D;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;EAC/C,6DAA6D;AAC/D;;AAEA,4EAA4E;;AAE5E,gDAAgD;;AAEhD,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,uDAAuD;AACzD;;AAEA;EACE,mCAAmC;AACrC;;AAEA,oCAAoC;AACpC;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,uDAAuD;AACzD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,uDAAuD;AACzD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gGAAgG;EAChG,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gGAAgG;EAChG,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,sEAAsE;EACtE,oBAAoB;EACpB,8BAA8B;EAC9B,kCAAkC;EAClC,gCAAgC;EAChC,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;AAC9B;;;;AAIA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gDAAgD;AAClD;;;;;;;;AAQA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8FAA8F;EAC9F,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB,EAAE,wCAAwC;EAC3D,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+FAA+F;EAC/F,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iDAAiD;EACjD,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iDAAiD;EACjD,mBAAmB;EACnB,uCAAuC;EACvC,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B,6DAA6D,UAAU,EAAE,EAAE,YAAY;AACvF,6DAA6D,UAAU,EAAE,EAAE,WAAW;AACtF,6DAA6D,UAAU,EAAE,EAAE,SAAS;AACpF,6DAA6D,UAAU,EAAE,EAAE,WAAW;AACtF,6DAA6D,UAAU,EAAE,EAAE,aAAa;AACxF,6DAA6D,UAAU,EAAE,EAAE,iBAAiB;AAC5F,6DAA6D,UAAU,EAAE,EAAE,YAAY;;AAEvF,iCAAiC;AACjC;;+BAE+B,YAAY;EACzC,mBAAmB;AACrB;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,+FAA+F;EAC/F,qBAAqB;AACvB;;AAEA,qEAAqE;;AAErE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;AAC3B;;AAEA,0EAA0E;AAC1E;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB,EAAE,8BAA8B;EAChD,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA,6EAA6E;;AAE7E;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,oBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,oBAAoB;EACpB,yBAAyB;EACzB,8CAA8C;EAC9C,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,8CAA8C;EAC9C,6DAA6D;AAC/D;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA,sBAAsB;AACtB,0DAA0D;;;AAG1D,2BAA2B;AAC3B;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;IAChD,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA,8BAA8B;EAC9B;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,wBAAwB;EACxB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;EAEA,uBAAuB;EACvB;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE;MACE,4BAA4B;IAC9B;IACA;MACE,wBAAwB;IAC1B;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,gGAAgG;IAChG,cAAc;IACd,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,SAAO;IACP,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA,uCAAuC;EACvC;IACE;MACE,aAAa;IACf;EACF;AACF;;AAEA;EACE;IACE,eAAe;IACf,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;AACF;AACA;;;;;;;;;GASG;AACH;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,SAAO;AACT;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;;;AAIA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA,8CAA8C;AAC9C;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,UAAU;EACV,gBAAgB;EAChB,yDAAmP;EACnP,wCAAwC;EACxC,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,eAAe;EACf,0CAA0C;EAG1C,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,6EAA6E;EAC7E,oBAAoB;EACpB,UAAU;AACZ;;;;AAIA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,wEAAwE;EACxE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,4BAA4B;EAC9B;;EAEA,0DAA0D;EAC1D;;;;IAIE,WAAW;IACX,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA;;IAEE,qBAAqB;IACrB,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;EACrB,6BAA6B;AAC/B;;;;AAIA,uCAAuC;AACvC;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,iDAAiD;AACjD;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;EACE;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,mCAAmC;EACrC;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,uCAAuC;AACvC;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,+CAA+C;;AAE/C;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iDAAiD;EACjD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA,iCAAiC;AACjC;EACE;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA,0CAA0C;AAC1C;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA,gDAAgD;AAChD;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;;EAEE,gCAAgC;EAChC,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,uCAAuC;AACvC;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,qDAAqD;EACrD,cAAc;EACd,kBAAkB;EAClB,iDAAiD;EACjD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA,mCAAmC;AACnC;EACE,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA,mCAAmC;AACnC;EACE,SAAO;EACP,aAAa;AACf;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,YAAY,EAAE,kCAAkC;EAChD,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;AACf;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;AACA,wDAAwD;AACxD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;;IAEE,cAAc;EAChB;;EAEA;;IAEE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;;IAEE,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;AACF;;AAEA,0BAA0B;AAC1B;EACE;;IAEE,QAAQ;EACV;;EAEA;;IAEE,kBAAkB;IAClB,eAAe,EAAE,yBAAyB;EAC5C;AACF;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB;;sCAEoC;EACpC,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,uDAAuD;EACvD,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iGAAiG;EACjG,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,6DAA6D;EAC7D,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA,0BAA0B;AAC1B;EACE;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;IACnB;;wCAEoC;EACtC;;EAEA;IACE,6DAA6D;IAC7D,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,6DAA6D;IAC7D,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qDAAqD;IACrD,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,6DAA6D;IAC7D,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,6DAA6D;IAC7D,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;AACF;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE;IACE,6DAA6D;IAC7D,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qDAAqD;IACrD,cAAc;IACd,qBAAqB;EACvB;AACF;;AAEA,iDAAiD;AACjD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,6DAA6D;EAC7D;;gCAE8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB;;gCAE8B;EAC9B,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,qDAAqD;EACrD,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B;;kCAEgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,qDAAqD;EACrD,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,qBAAqB,EAAE;AAC/B;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,6DAA6D;EAC7D,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,6DAA6D;IAC7D,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qDAAqD;IACrD,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,6DAA6D;IAC7D,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,6DAA6D;IAC7D,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;AACF;;AAEA,oCAAoC;AACpC;EACE,iEAAiE;AACnE;;AAEA,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,qBAAqB,EAAE;AAC1D,oCAAoC,sBAAsB,EAAE;;AAE5D;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,0CAA0C;AAC1C;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;AACvD;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,gCAAgC;AAClC;;AAEA;EACE,KAAK,WAAW,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;AAEA,uDAAuD;AACvD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,+BAA+B;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa,EAAE,2BAA2B;AAC5C;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,eAAe,EAAE,2BAA2B;AAC9C;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa,EAAE,0BAA0B;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa,EAAE,0BAA0B;AAC3C;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,eAAe;AACjB;;AAEA;;;;;;;;;;EAUE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;AACF;;AAEA,gDAAgD;AAChD;EACE,iBAAiB,EAAE,uBAAuB;EAC1C,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,cAAc,EAAE,mBAAmB;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,gBAAgB;EAC3B,kBAAkB,EAAE,oBAAoB;EACxC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB,EAAE,iCAAiC;AACrD;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,EAAE,sBAAsB;EACnC,YAAY,EAAE,sBAAsB;EACpC,mBAAmB;EACnB,kBAAkB,EAAE,qBAAqB;EACzC,cAAc;EACd,eAAe,EAAE,sBAAsB;EACvC,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAE,gBAAgB;EAC1B,uBAAuB,EAAE,8BAA8B;AACzD;;AAEA;EACE,cAAc;EACd,eAAe,EAAE,sBAAsB;EACvC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB,EAAE,wBAAwB;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe,EAAE,sBAAsB;EACvC,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAE,wBAAwB;AAC5C;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB,EAAE,qBAAqB;EACzC,kBAAkB,EAAE,oBAAoB;EACxC,cAAc;EACd,eAAe,EAAE,sBAAsB;EACvC,gBAAgB,EAAE,wBAAwB;EAC1C,kBAAkB,EAAE,mBAAmB;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB,EAAE,mBAAmB;EACtC,eAAe,EAAE,sBAAsB;EACvC,qBAAqB;EACrB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS,EAAE,gBAAgB;EAC3B,uBAAuB,EAAE,oBAAoB;EAC7C,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB,EAAE,oBAAoB;EACxC,kBAAkB,EAAE,qBAAqB;EACzC,eAAe,EAAE,sBAAsB;EACvC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB,EAAE,uBAAuB;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB,EAAE,oBAAoB;EACxC,kBAAkB,EAAE,qBAAqB;EACzC,eAAe,EAAE,sBAAsB;EACvC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB,EAAE,uBAAuB;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,8BAA8B,EAAE,gBAAgB;EAChD,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE;IACE,iBAAiB,EAAE,gCAAgC;IACnD,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;EACzB;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA,4CAA4C;EAC5C;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;AACF;AACA,4BAA4B;AAC5B;EACE,aAAa;EACb,WAAW;EACX,aAAa,EAAE,yBAAyB;EACxC,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,UAAU,eAAe,kDAAkD;EAC3E,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY,cAAc,0BAA0B;EACpD,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,SAAO;EACP,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,WAAW,EAAE,mCAAmC;EAClD;;EAEA;IACE,WAAW;IACX,WAAW,EAAE,6BAA6B;IAC1C,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,gCAAgC;EACrD,aAAa,EAAE,2BAA2B;AAC5C;;AAEA;EACE,gBAAgB,EAAE,gCAAgC;EAClD,WAAW,OAAO,2BAA2B;EAC7C,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".App {\n  text-align: center;\n}\n\nhtml, body, #root {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: #1f2937;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Global smooth transitions - disabled for instant rendering */\n\n/* No Assistant Message Styles */\n.no-assistant-message {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n}\n\n.no-assistant-content {\n  text-align: center;\n  max-width: 500px;\n  padding: 2rem;\n  background: white;\n  border-radius: 1rem;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n}\n\n.no-assistant-content h2 {\n  color: #1f2937;\n  margin-bottom: 1rem;\n  font-size: 1.5rem;\n}\n\n.no-assistant-content p {\n  color: #6b7280;\n  margin-bottom: 0.5rem;\n  line-height: 1.6;\n}\n\n.no-assistant-content p:last-child {\n  margin-bottom: 0;\n  font-style: italic;\n  color: #4f46e5;\n}\n\n/* Override for specific elements that shouldn't have global transitions */\n.message-text, .chat-input, input[type=\"text\"], input[type=\"email\"], input[type=\"password\"], textarea {\n  transition: border-color 0.3s, box-shadow 0.3s, background-color 0.3s;\n}\n\n/* App.css */\n.login-container {\n  display: flex;\n  width: 100vw;       /* full width */\n  height: 100vh;      /* full height */\n  background: #f5f8fd;\n  position: relative;\n  box-sizing: border-box;\n  justify-content: center;\n  align-items: center;\n}\n\n.back-to-home-btn {\n  position: absolute;\n  top: 1rem;\n  left: 1rem;\n  background: #185adb !important;\n  border: none !important;\n  color: white !important;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n  z-index: 1000;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  box-shadow: 0 2px 8px rgba(24, 90, 219, 0.2);\n}\n\n.back-to-home-btn:hover {\n  background: #1548b8 !important;\n  color: white !important;\n}\n\n/* Simple centered login layout */\n.login-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 450px;\n  padding: 2rem;\n}\n\n.login-logo {\n  margin-bottom: 2rem;\n  display: flex;\n  justify-content: center;\n}\n\n.login-logo .logo-img {\n  max-height: 120px;\n  width: auto;\n  object-fit: contain;\n}\n\n.login-form-wrapper {\n  width: 100%;\n  background: #fff;\n  padding: 2.5rem;\n  border-radius: 1rem;\n  box-shadow: 0 2px 24px rgba(24,90,219,0.08);\n}\n\n.login-form-wrapper h2 {\n  margin-bottom: 24px;\n  text-align: center;\n  color: #1e293b;\n  font-size: 1.75rem;\n}\n\n.login-form-wrapper input,\n.login-form-wrapper form input {\n  width: 100%;\n  padding: 12px 16px;\n  margin-bottom: 16px;\n  border: 1px solid #e3e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  box-sizing: border-box;\n}\n\n.login-form-wrapper input:focus {\n  outline: none;\n  border-color: #185adb;\n  box-shadow: 0 0 0 3px rgba(24, 90, 219, 0.1);\n}\n\n.login-form-wrapper button[type=\"submit\"],\n.login-form-wrapper form button[type=\"submit\"] {\n  width: 100%;\n  padding: 12px;\n  background: #185adb;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  margin-top: 8px;\n  transition: background 0.2s;\n}\n\n.login-form-wrapper button[type=\"submit\"]:hover:not(:disabled) {\n  background: #1548b8;\n}\n\n.login-form-wrapper button[type=\"submit\"]:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Keep old classes for backward compatibility but hide them */\n.login-left {\n  display: none;\n}\n\n.login-right {\n  display: none;\n}\n\n.role-select {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.role-select button {\n  border: 2px solid #e3e8f0;\n  background: #f5f8fd;\n  color: #185adb;\n  border-radius: 10px;\n  padding: 12px 18px;\n  cursor: pointer;\n  font-size: 1rem;\n  min-width: 100px;\n  transition: border 0.2s, background 0.2s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.role-select button.selected {\n  border: 2px solid #185adb;\n  background: #e3eefd;\n  color: #185adb;\n}\n\n.role-select button.disabled {\n  border: 2px solid #d1d5db;\n  background: #f3f4f6;\n  color: #9ca3af;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.role-select button.disabled:hover {\n  border: 2px solid #d1d5db;\n  background: #f3f4f6;\n  color: #9ca3af;\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.create-account-right form {\n  margin-bottom: 24px;\n}\n\ninput[type=\"email\"], input[type=\"password\"] {\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #e3e8f0;\n  font-size: 1rem;\n}\n\nbutton[type=\"submit\"] {\n  background: #111827;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 12px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  margin-top: 8px;\n  transition: all 0.15s ease;\n}\n\nbutton[type=\"submit\"]:disabled {\n  background: #a3bffa;\n  cursor: not-allowed;\n}\n\n.oauth-divider {\n  text-align: center;\n  color: #888;\n  margin: 16px 0 8px 0;\n  width: 100%;\n}\n\n.oauth-btn {\n  width: 100%;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #e3e8f0;\n  background: #fff;\n  color: #222;\n  font-size: 1rem;\n  margin-bottom: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background 0.2s, border 0.2s;\n}\n\n.oauth-btn.google {\n  border-color: #ea4335;\n  color: #ea4335;\n}\n\n.oauth-btn.google:hover {\n  background: #ea4335;\n  color: #1f2937;\n}\n\n.oauth-btn.microsoft {\n  border-color: #4285f4;\n  color: #4285f4;\n}\n\n.oauth-btn.microsoft:hover {\n  background: #4285f4;\n  color: #1f2937;\n}\n\n.signup-link {\n  margin-top: 16px;\n  color: #185adb;\n}\n\n.signup-link a {\n  color: #185adb;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n@media (max-width: 900px) {\n  .login-container {\n    flex-direction: column;\n    min-height: unset;\n  }\n  .login-left, .login-right {\n    border-radius: 20px 20px 0 0;\n    padding: 32px 16px;\n    width: 100%;\n  }\n  .login-right {\n    border-radius: 0 0 20px 20px;\n  }\n}\n\n/* Import Inter font from Google Fonts */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n/* Global font application */\n*, *::before, *::after {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n/* Two-pane layout fix */\nbody, #root {\n  height: 100vh;\n  margin: 0;\n  background: #f5f8fd;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Create Account Page Styles */\n/* Centered Create Account layout (matching login page) */\n.create-account-container {\n  display: flex;\n  width: 100vw;\n  min-height: 100vh;\n  height: auto;\n  background: #f5f8fd;\n  position: relative;\n  box-sizing: border-box;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 1rem 0;\n  overflow-y: auto;\n}\n\n.create-account-logo-top {\n  position: absolute;\n  top: 1.5rem;\n  left: 2rem;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n}\n\n.create-account-logo-top .logo-img {\n  max-height: 120px;\n  width: auto;\n  object-fit: contain;\n}\n\n.create-account-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 500px;\n  padding: 2rem;\n  margin-top: 2rem;\n  overflow-y: visible;\n}\n\n/* Hide old logo inside content */\n.create-account-logo {\n  display: none;\n}\n\n.create-account-form-wrapper {\n  width: 100%;\n  background: #fff;\n  padding: 2.5rem;\n  border-radius: 1rem;\n  box-shadow: 0 2px 24px rgba(24,90,219,0.08);\n}\n\n.create-account-form-wrapper h2 {\n  margin-bottom: 8px;\n  color: #185adb;\n  text-align: center;\n  font-size: 1.75rem;\n}\n\n/* Hide old left/right sections */\n.create-account-left {\n  display: none;\n}\n\n.create-account-right {\n  display: none;\n}\n\n.create-account-form-wrapper .instruction-text {\n  color: #666;\n  margin-bottom: 24px;\n  font-size: 0.9rem;\n  text-align: center;\n}\n\n.form-group {\n  margin-bottom: 16px;\n  width: 100%;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 500;\n  color: #333;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #e3e8f0;\n  font-size: 1rem;\n  box-sizing: border-box;\n}\n\n.password-policy-box {\n  background: #f0f8ff;\n  border: 1px solid #185adb;\n  border-radius: 8px;\n  padding: 12px;\n  margin-bottom: 16px;\n}\n\n.password-policy-box h4 {\n  margin: 0 0 8px 0;\n  color: #185adb;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.password-policy-box ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.password-policy-box li {\n  margin-bottom: 4px;\n  font-size: 0.7rem;\n  color: #666;\n  position: relative;\n  padding-left: 14px;\n  line-height: 1.2;\n}\n\n.password-policy-box li:before {\n  content: '•';\n  position: absolute;\n  left: 0;\n  color: #999;\n}\n\n.password-policy-box li.valid {\n  color: #059669;\n}\n\n.password-policy-box li.valid:before {\n  content: '✓';\n  color: #059669;\n}\n\n.password-policy-box li.invalid {\n  color: #dc2626;\n}\n\n.password-policy-box li.invalid:before {\n  content: '✗';\n  color: #dc2626;\n}\n\n.error-message {\n  color: #dc2626;\n  font-size: 0.8rem;\n  margin-top: 4px;\n}\n\n.button-group {\n  display: flex;\n  gap: 12px;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  width: 100%;\n}\n\n.button-group button {\n  flex: 1;\n  padding: 12px;\n  border-radius: 8px;\n  border: none;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.button-group button[type=\"submit\"] {\n  background: #185adb;\n  color: #fff;\n}\n\n.button-group button[type=\"submit\"]:disabled {\n  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n.cancel-btn {\n  background: #6b7280 !important;\n  color: #fff !important;\n}\n\n.login-link {\n  margin-top: 16px;\n  color: #185adb;\n  text-align: center;\n  width: 100%;\n}\n\n.login-link a {\n  color: #185adb;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n/* Success Message Styles */\n.success-message {\n  text-align: center;\n  padding: 20px 0;\n  width: 100%;\n}\n\n.success-icon {\n  font-size: 3rem;\n  color: #059669;\n  margin-bottom: 16px;\n}\n\n.success-message h2 {\n  color: #059669;\n  margin-bottom: 16px;\n}\n\n.success-message p {\n  color: #666;\n  margin-bottom: 12px;\n  line-height: 1.5;\n}\n\n.email-notes {\n  background: #f0f8ff;\n  border: 1px solid #185adb;\n  border-radius: 8px;\n  padding: 16px;\n  margin: 20px 0;\n  text-align: left;\n}\n\n.email-notes p {\n  margin-bottom: 8px;\n  color: #185adb;\n  font-weight: 600;\n}\n\n.email-notes ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.email-notes li {\n  margin-bottom: 6px;\n  font-size: 0.9rem;\n  color: #666;\n  position: relative;\n  padding-left: 16px;\n}\n\n.email-notes li:before {\n  content: '•';\n  position: absolute;\n  left: 0;\n  color: #185adb;\n}\n\n.back-to-login-btn {\n  background: #185adb;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 24px;\n  font-size: 1rem;\n  cursor: pointer;\n  margin-top: 16px;\n  transition: background 0.2s;\n}\n\n.back-to-login-btn:hover {\n  background: #1e40af;\n}\n\n/* Dashboard Styles */\n.dashboard-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background: transparent;\n}\n\n.top-bar {\n  background: #ffffff;\n  border-bottom: 1px solid #f1f3f4;\n  padding: 16px 32px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.top-bar-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n/* Mobile Menu Toggle - Hidden by default, shown on mobile */\n.mobile-menu-toggle {\n  display: none;\n}\n\n.logo {\n  font-size: 24px;\n  font-weight: 600;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin: 0;\n  letter-spacing: -0.3px;\n}\n\n.dock-toggle-btn {\n  background: #111827;\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 160px;\n  justify-content: center;\n}\n\n.dock-toggle-btn:hover {\n  background: #1f2937;\n}\n\n.top-bar-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.subscription-badge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: transparent;\n  color: #667eea;\n  padding: 6px 14px;\n  border-radius: 20px;\n  border: 1.5px solid #667eea;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.subscription-badge:hover {\n  background: rgba(102, 126, 234, 0.05);\n  border-color: #764ba2;\n  color: #764ba2;\n}\n\n.badge-icon {\n  font-size: 1rem;\n}\n\n.badge-text {\n  font-size: 0.875rem;\n}\n\n.user-profile {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 8px;\n  position: relative;\n  z-index: 1001;\n}\n\n.user-profile:hover {\n  background: #f3f4f6;\n}\n\n.user-avatar {\n  font-size: 1.2rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.user-name {\n  font-weight: 500;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.dropdown-arrow {\n  font-size: 0.8rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.user-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background: #fff;\n  border: 1px solid #e3e8f0;\n  border-radius: 8px;\n  padding: 8px 0;\n  min-width: 120px;\n  display: none;\n  z-index: 1000;\n}\n\n.user-profile:hover .user-dropdown {\n  display: block;\n}\n\n.user-dropdown button {\n  width: 100%;\n  padding: 8px 16px;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  color: #333;\n}\n\n.user-dropdown button:hover {\n  background: #f3f4f6;\n}\n\n.main-content {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n.sidebar {\n  width: 280px;\n  background: #ffffff;\n  border-right: 1px solid #edeff1;\n  padding: 8px 0;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.assistant-expand-btn {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 16px;\n  width: 64px;\n  height: 64px;\n  font-size: 28px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 1001;\n  box-shadow: 0 6px 24px rgba(102, 126, 234, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(8px);\n}\n\n.assistant-expand-btn:hover {\n  transform: scale(1.05) translateY(-2px);\n  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.5);\n  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);\n}\n\n/* Removed - button styling now handled inline in LegalAssistant component */\n\n/* Removed the blue vertical line from sidebar */\n\n/* PDF Merge Checkbox Styling */\n.merge-checkbox-container {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n.merge-checkbox-container:hover {\n  background-color: rgba(24, 90, 219, 0.1);\n}\n\n.merge-checkbox {\n  accent-color: #185adb !important;\n  cursor: pointer !important;\n  transform: scale(1.1);\n  transition: transform 0.2s ease;\n}\n\n.merge-checkbox:hover {\n  transform: scale(1.2);\n}\n\n.merge-hint {\n  font-size: 10px;\n  color: #6b7280;\n  cursor: help;\n  transition: color 0.2s ease;\n}\n\n.merge-checkbox-container:hover .merge-hint {\n  color: #185adb;\n}\n\n/* Merge PDFs Button Styling */\n.merge-pdfs-btn {\n  background-color: #185adb !important;\n  color: white !important;\n  border: none !important;\n  border-radius: 4px !important;\n  font-weight: 500 !important;\n  transition: all 0.2s ease !important;\n  box-shadow: 0 2px 4px rgba(24, 90, 219, 0.2) !important;\n}\n\n.merge-pdfs-btn:hover {\n  background-color: #1347b3 !important;\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 8px rgba(24, 90, 219, 0.3) !important;\n}\n\n.merge-pdfs-btn:active {\n  transform: translateY(0) !important;\n}\n\n/* Delete Documents Button Styling */\n.delete-documents-btn {\n  background-color: #dc2626 !important;\n  color: white !important;\n  border: none !important;\n  border-radius: 4px !important;\n  font-weight: 500 !important;\n  transition: all 0.2s ease !important;\n  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.2) !important;\n}\n\n.delete-documents-btn:hover {\n  background-color: #b91c1c !important;\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 8px rgba(220, 38, 38, 0.3) !important;\n}\n\n.delete-documents-btn:active {\n  transform: translateY(0) !important;\n}\n\n.delete-documents-btn:disabled {\n  background-color: #9ca3af !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* Delete Checkbox Styling */\n.delete-checkbox-container {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n.delete-checkbox-container:hover {\n  background-color: rgba(220, 38, 38, 0.1);\n}\n\n.delete-checkbox {\n  accent-color: #dc2626 !important;\n  cursor: pointer !important;\n  transform: scale(1.1);\n  transition: transform 0.2s ease;\n}\n\n.delete-checkbox:hover {\n  transform: scale(1.2);\n}\n\n.delete-hint {\n  font-size: 10px;\n  color: #6b7280;\n  cursor: help;\n  transition: color 0.2s ease;\n}\n\n.delete-checkbox-container:hover .delete-hint {\n  color: #dc2626;\n}\n\n/* Download Documents Button Styling */\n.download-documents-btn {\n  background-color: #059669 !important;\n  color: white !important;\n  border: none !important;\n  border-radius: 4px !important;\n  font-weight: 500 !important;\n  transition: all 0.2s ease !important;\n  box-shadow: 0 2px 4px rgba(5, 150, 105, 0.2) !important;\n}\n\n.download-documents-btn:hover {\n  background-color: #047857 !important;\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 8px rgba(5, 150, 105, 0.3) !important;\n}\n\n.download-documents-btn:active {\n  transform: translateY(0) !important;\n}\n\n.download-documents-btn:disabled {\n  background-color: #9ca3af !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* Download Checkbox Styling */\n.download-checkbox-container {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n.download-checkbox-container:hover {\n  background-color: rgba(5, 150, 105, 0.1);\n}\n\n.download-checkbox {\n  accent-color: #059669 !important;\n  cursor: pointer !important;\n  transform: scale(1.1);\n  transition: transform 0.2s ease;\n}\n\n.download-checkbox:hover {\n  transform: scale(1.2);\n}\n\n.download-hint {\n  font-size: 10px;\n  color: #6b7280;\n  cursor: help;\n  transition: color 0.2s ease;\n}\n\n.download-checkbox-container:hover .download-hint {\n  color: #059669;\n}\n\n/* Bulk Delete Modal Styling */\n.documents-to-delete {\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 8px;\n  margin: 12px 0;\n  background-color: #f9fafb;\n}\n\n.document-to-delete {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  border-bottom: 1px solid #e5e7eb;\n  background-color: #1f2937;\n  border-radius: 4px;\n  margin-bottom: 4px;\n}\n\n.document-to-delete:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.document-to-delete .document-icon {\n  font-size: 16px;\n  color: #6b7280;\n}\n\n.document-to-delete .document-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.document-to-delete .document-info strong {\n  display: block;\n  font-size: 13px;\n  color: #374151;\n  margin-bottom: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.document-to-delete .document-info small {\n  display: block;\n  font-size: 11px;\n  color: #6b7280;\n}\n\n/* Simple Success Modal Styling */\n.simple-success-modal {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  max-width: 400px;\n  text-align: center;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  animation: slideIn 0.3s ease-out;\n}\n\n.simple-success-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.simple-success-icon {\n  font-size: 32px;\n  color: #10b981;\n}\n\n.simple-success-icon.error {\n  color: #dc2626;\n}\n\n.simple-success-icon.download {\n  color: #059669;\n}\n\n.simple-success-icon.downloading {\n  color: #3b82f6;\n}\n\n.simple-success-message h4 {\n  margin: 0;\n  color: #374151;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.sidebar.collapsed {\n  width: 60px;\n  padding: 24px 0 24px 0;\n  overflow: hidden;\n}\n\n.sidebar.collapsed .sidebar-toggle {\n  left: 14px !important;\n  background: #f8fafc !important;\n}\n\n.sidebar:not(.collapsed) .sidebar-toggle {\n  position: absolute;\n  top: 18px;\n  right: 8px;\n  left: auto !important;\n  z-index: 10;\n}\n\n.sidebar-toggle {\n  position: fixed;\n  top: 80px;\n  left: 260px;\n  width: 32px;\n  height: 32px;\n  background: #f8fafc;\n  color: #64748b;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 500;\n  z-index: 103;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n  transition: left 0.05s ease;\n}\n\n.sidebar-toggle:hover {\n  background: #e2e8f0;\n  color: #475569;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.15);\n}\n\n.sidebar-toggle:active {\n  background: #cbd5e1;\n}\n\n.collapsed-nav {\n  padding: 50px 8px 0 8px;\n}\n\n.collapsed-nav-section {\n  margin-bottom: 24px;\n}\n\n.collapsed-nav-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #878a8c;\n  border-radius: 4px;\n  margin: 2px auto;\n  transition: all 0.15s ease;\n  position: relative;\n}\n\n.collapsed-nav-item:hover {\n  background: #f6f7f8;\n  color: #1c1c1c;\n}\n\n.collapsed-nav-item.active {\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);\n  color: #667eea;\n}\n\n.collapsed-nav-item .nav-icon {\n  font-size: 1rem;\n}\n\n.nav-section {\n  margin-bottom: 24px;\n}\n\n.section-title {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #878a8c;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  margin: 16px 12px 8px 12px;\n  padding: 0 40px 0 0;\n  white-space: nowrap;\n  width: 100%;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: calc(100% - 16px);\n  margin: 1px 8px;\n  padding: 10px 12px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #878a8c;\n  text-align: left;\n  transition: all 0.15s ease;\n  border-radius: 4px;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.nav-item:hover {\n  background: #f6f7f8;\n  color: #1c1c1c;\n}\n\n.nav-item.active {\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);\n  color: #667eea;\n  font-weight: 500;\n}\n\n.nav-item.disabled {\n  opacity: 0.5;\n  cursor: not-allowed !important;\n  position: relative;\n}\n\n.nav-item.disabled:hover {\n  background: #f6f7f8;\n  color: #878a8c;\n}\n\n.nav-blocked-indicator {\n  font-size: 0.75rem;\n  margin-left: auto;\n  opacity: 0.7;\n}\n\n.collapsed-nav-item.disabled {\n  opacity: 0.5;\n  cursor: not-allowed !important;\n}\n\n.collapsed-nav-item.disabled:hover {\n  background: #f6f7f8;\n  color: #878a8c;\n}\n\n.nav-icon {\n  font-size: 1rem;\n  width: 20px;\n  color: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.nav-label {\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.content-area {\n  flex: 1;\n  padding: 24px 32px;\n  overflow-y: auto;\n  background: transparent;\n  margin-top: 0;\n}\n\n.content-area.sidebar-collapsed {\n  margin-left: 0;\n  padding: 24px 32px;\n}\n\n.assistant-sidebar {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: auto;\n  height: 100vh;\n  background: transparent;\n  border: none;\n  display: flex;\n  flex-direction: column;\n  z-index: 1000;\n  box-shadow: none;\n  padding: 0;\n  margin: 0;\n  transform: translateX(0);\n  transition: transform 0.3s ease;\n}\n\n/* Case Dashboard Styles */\n.case-dashboard h2 {\n  margin-bottom: 24px;\n  color: #333;\n  font-size: 1.8rem;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 32px;\n}\n\n.dashboard-container {\n  margin-bottom: 32px;\n}\n\n.stats-bar {\n  display: grid !important;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)) !important;\n  gap: 20px !important;\n  margin-bottom: 32px !important;\n  background: transparent !important;\n  backdrop-filter: none !important;\n  border-radius: 0 !important;\n  padding: 0 !important;\n  border: none !important;\n  box-shadow: none !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  overflow: visible !important;\n}\n\n\n\n.stat-item:last-child {\n  border-right: none !important;\n}\n\n.stat-item:hover {\n  background: rgba(114, 137, 218, 0.08) !important;\n}\n\n\n\n\n\n\n\n.stat-item {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 24px;\n  border-right: none;\n}\n\n.stat-item:last-child {\n  border-right: none;\n}\n\n.stat-item:hover {\n  background: rgba(114, 137, 218, 0.08);\n}\n\n.stat-card {\n  background: linear-gradient(135deg, #ffffff 0%, #fefefe 100%);\n  border-radius: 12px;\n  padding: 24px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  border: 1px solid #f1f3f4;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);\n}\n\n.stat-icon {\n  font-size: 1.8rem;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n  border-radius: 8px;\n  color: #667eea;\n}\n\n.stat-number {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: #111827;\n  line-height: 1;\n}\n\n.stat-label {\n  color: #666;\n  font-size: 0.9rem;\n  margin-top: 4px;\n}\n\n.recent-cases {\n  background: #fafafa;\n  backdrop-filter: none;\n  border-radius: 0 0 24px 24px;\n  padding: 32px;\n  border: none;\n  border-top: none;\n  box-shadow: none;\n  margin-left: -32px;\n  margin-right: -32px;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.section-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 1.3rem;\n}\n\n.search-bar {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-bar input {\n  padding: 8px 12px 8px 36px;\n  border: 1px solid #e3e8f0;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  width: 250px;\n}\n\n.search-icon {\n  position: absolute;\n  left: 12px;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: #666;\n}\n\n.empty-icon {\n  font-size: 4rem;\n  margin-bottom: 16px;\n  opacity: 0.5;\n}\n\n.empty-state h3 {\n  margin: 0 0 8px 0;\n  color: #333;\n}\n\n.empty-state p {\n  margin: 0 0 24px 0;\n}\n\n.new-case-btn {\n  background: #111827;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.new-case-btn:hover {\n  background: #1f2937;\n}\n\n/* Dashboard action buttons styling */\n.dashboard-action-btn {\n  background: #f3f4f6 !important;\n  color: #6b7280 !important;\n  border: 1px solid #e5e7eb !important;\n  border-radius: 6px !important;\n  padding: 8px 16px !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  cursor: pointer !important;\n  transition: all 0.15s ease !important;\n}\n\n.dashboard-action-btn:hover {\n  background: #e5e7eb !important;\n  color: #374151 !important;\n  transform: translateY(-1px) !important;\n}\n\n.cases-table {\n  overflow-x: visible;\n  font-size: 0.8rem; /* Smaller font size for compact table */\n  table-layout: fixed;\n  border-radius: 16px;\n  background: white;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.cases-table table {\n  width: 100%;\n  border-collapse: collapse;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.cases-table th {\n  background: linear-gradient(135deg, rgba(114, 137, 218, 0.1) 0%, rgba(138, 109, 184, 0.1) 100%);\n  padding: 12px 8px;\n  text-align: left;\n  font-weight: 600;\n  color: #667eea;\n  border-bottom: 2px solid rgba(114, 137, 218, 0.2);\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.cases-table td {\n  padding: 12px 8px;\n  border-bottom: 1px solid rgba(114, 137, 218, 0.1);\n  vertical-align: top;\n  transition: background-color 0.15s ease;\n  word-wrap: break-word;\n  line-height: 1.4;\n  white-space: normal;\n}\n\n/* Responsive column widths */\n.cases-table th:nth-child(1), .cases-table td:nth-child(1) { width: 14%; } /* Case ID */\n.cases-table th:nth-child(2), .cases-table td:nth-child(2) { width: 22%; } /* Client */\n.cases-table th:nth-child(3), .cases-table td:nth-child(3) { width: 12%; } /* Type */\n.cases-table th:nth-child(4), .cases-table td:nth-child(4) { width: 14%; } /* Status */\n.cases-table th:nth-child(5), .cases-table td:nth-child(5) { width: 10%; } /* Priority */\n.cases-table th:nth-child(6), .cases-table td:nth-child(6) { width: 12%; } /* Last Updated */\n.cases-table th:nth-child(7), .cases-table td:nth-child(7) { width: 16%; } /* Actions */\n\n/* Keep certain columns compact */\n.cases-table td:nth-child(5), /* Priority */\n.cases-table td:nth-child(6), /* Last Updated */\n.cases-table td:nth-child(7) { /* Actions */\n  white-space: nowrap;\n}\n\n.cases-table tbody tr:hover {\n  background: linear-gradient(135deg, rgba(114, 137, 218, 0.05) 0%, rgba(138, 109, 184, 0.05) 100%);\n}\n\n.cases-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 6px;\n  background: #f3f4f6;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  font-size: 14px;\n}\n\n.action-btn:hover {\n  background: #e5e7eb;\n  color: #374151;\n  transform: translateY(-1px);\n}\n\n.action-btn:active {\n  transform: translateY(0);\n}\n\n.case-id-link {\n  background: none;\n  border: none;\n  color: #7289da;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: none;\n  padding: 4px 8px;\n  font-size: inherit;\n  border-radius: 4px;\n  transition: all 0.15s ease;\n}\n\n.case-id-link:hover {\n  color: #8a6db8;\n  background: linear-gradient(135deg, rgba(114, 137, 218, 0.1) 0%, rgba(138, 109, 184, 0.1) 100%);\n  text-decoration: none;\n}\n\n/* Client info styles moved to CaseDashboard.css to avoid conflicts */\n\n.status-badge {\n  padding: 3px 6px;\n  border-radius: 10px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.status-pending-review {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.status-approved {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.status-rejected {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n/* Priority Badge Styles */\n.priority-badge {\n  padding: 3px 6px;\n  border-radius: 10px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.priority-low {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.priority-medium {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.priority-high {\n  background: #fed7d7;\n  color: #dc2626;\n}\n\n.priority-urgent {\n  background: #dc2626;\n  color: #ffffff;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.action-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  font-size: 1rem;\n}\n\n/* Subtle delete button styling */\n.action-btn:hover {\n  background-color: #f3f4f6;\n}\n\n/* Delete button specific styling - subtle gray by default, red on hover */\n.action-btn:last-child {\n  color: #6b7280;\n}\n\n.action-btn:last-child:hover {\n  color: #dc3545;\n  background-color: #fef2f2;\n}\n\n.case-id-link {\n  background: none;\n  border: none;\n  color: #007bff;\n  text-decoration: underline;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: inherit;\n  padding: 0;\n  margin: 0;\n  transition: color 0.2s ease;\n}\n\n.case-id-link:hover {\n  color: #0056b3;\n  text-decoration: none;\n}\n\n/* Legal Assistant Styles */\n.legal-assistant {\n  width: 100%;\n  height: 100%;\n  background: white;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #e1e8ed;\n  border-radius: 0; /* flush edges in split view */\n  position: relative;\n  transition: width 0.1s ease-out;\n}\n\n.assistant-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: #1f2937;\n  padding: 16px 20px;\n  border-radius: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.assistant-header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.panel-width-indicator {\n  font-size: 12px;\n  opacity: 0.7;\n  font-weight: normal;\n}\n\n.minimize-btn {\n  background: none;\n  border: none;\n  color: #1f2937;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.minimize-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background: #f8fafc;\n}\n\n.message {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n}\n\n.message.user {\n  flex-direction: row-reverse;\n}\n\n.message-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.message.assistant .message-avatar {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: #1f2937;\n}\n\n.message.user .message-avatar {\n  background: #f3f4f6;\n  color: #6b7280;\n}\n\n.message-content {\n  background: #f9fafb;\n  padding: 12px 16px;\n  border-radius: 12px;\n  max-width: 85%;\n  font-size: 14px;\n  line-height: 1.5;\n  word-wrap: break-word;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* Removed conflicting user message styling - handled in LegalAssistant.css */\n\n.message.isLoading .message-content {\n  background: #f3f4f6;\n  color: #6b7280;\n  font-style: italic;\n}\n\n.message-time {\n  font-size: 0.7rem;\n  color: #666;\n  margin-top: 4px;\n}\n\n.message-text.loading {\n  opacity: 0.7;\n}\n\n.loading-dots {\n  animation: pulse 1.5s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n.send-btn.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.chat-input input:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.chat-input-container {\n  padding: 20px;\n  border-top: 1px solid #e1e8ed;\n  background: white;\n}\n\n.chat-input-form {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  gap: 12px !important;\n  position: relative;\n  width: 100%;\n  min-height: 60px;\n  padding: 6px 0;\n}\n\n.input-actions {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  gap: 8px !important;\n  flex-shrink: 0 !important;\n  order: 1;\n}\n\n.file-upload-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: #1f2937;\n  border: none;\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  cursor: pointer;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  flex-shrink: 0;\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n}\n\n.file-upload-btn:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.chat-input {\n  flex: 1 !important;\n  border: 2px solid #d1d5db;\n  border-radius: 28px;\n  padding: 16px 20px;\n  font-size: 16px;\n  outline: none;\n  transition: all 0.2s;\n  min-height: 48px;\n  max-height: 120px;\n  resize: vertical;\n  font-family: inherit;\n  line-height: 1.4;\n  background: white;\n  order: 2;\n}\n\n.chat-input:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.chat-input:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.send-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: #1f2937;\n  border: none;\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  cursor: pointer;\n  font-size: 18px;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  transition: all 0.2s;\n  flex-shrink: 0 !important;\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n.send-btn:hover:not(:disabled) {\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.send-btn:disabled {\n  opacity: 0.6 !important;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.2);\n  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);\n}\n\n/* Resize handle for Legal Assistant */\n.resize-handle {\n  position: absolute;\n  left: -6px;\n  top: 0;\n  width: 12px;\n  height: 100%;\n  cursor: ew-resize;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  transition: background-color 0.2s;\n  z-index: 10;\n}\n\n.resize-handle:hover {\n  background: rgba(102, 126, 234, 0.1);\n  border-radius: 0 4px 4px 0;\n}\n\n.resize-handle.resizing {\n  background: rgba(102, 126, 234, 0.2);\n}\n\n/* Add cursor style for resizing state */\n.legal-assistant.resizing {\n  cursor: ew-resize;\n  user-select: none;\n}\n\n.resize-indicator {\n  width: 4px;\n  height: 40px;\n  background: #667eea;\n  border-radius: 2px;\n  opacity: 0.6;\n  transition: opacity 0.2s;\n}\n\n.resize-handle:hover .resize-indicator {\n  opacity: 1;\n}\n\n.resize-handle.resizing .resize-indicator {\n  opacity: 1;\n  background: #4f46e5;\n}\n\n/* Loading State */\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  font-size: 1.2rem;\n  color: #666;\n}\n\n/* Responsive Design */\n/* Removed media query that was hiding assistant sidebar */\n\n\n/* Responsive stats cards */\n@media (max-width: 1200px) {\n  .stats-bar {\n    grid-template-columns: repeat(2, 1fr) !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .stats-bar {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 16px !important;\n  }\n  \n  .stat-item {\n    padding: 16px !important;\n    gap: 12px !important;\n  }\n  \n  .stat-number {\n    font-size: 20px !important;\n  }\n  \n  .stat-label {\n    font-size: 12px !important;\n  }\n}\n\n@media (max-width: 640px) {\n  .stats-bar {\n    grid-template-columns: 1fr !important;\n    gap: 12px !important;\n  }\n  \n  .stat-item {\n    padding: 12px !important;\n  }\n  \n  .stat-icon {\n    padding: 8px !important;\n    font-size: 16px !important;\n  }\n  \n  .stat-number {\n    font-size: 18px !important;\n  }\n  \n  .stat-label {\n    font-size: 11px !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .sidebar {\n    width: 220px;\n  }\n  \n  .sidebar-toggle {\n    display: none;\n  }\n  \n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .search-bar input {\n    width: 200px;\n  }\n}\n\n@media (max-width: 640px) {\n  .sidebar {\n    display: none;\n  }\n  \n  /* Mobile Menu Toggle Button */\n  .mobile-menu-toggle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    background: transparent;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    cursor: pointer;\n    color: #475569;\n    font-size: 20px;\n    margin-right: 12px;\n    transition: all 0.2s ease;\n  }\n  \n  .mobile-menu-toggle:hover {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n  }\n  \n  .mobile-menu-toggle:active {\n    background: #e2e8f0;\n  }\n  \n  /* Mobile Menu Overlay */\n  .mobile-menu-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 2000;\n    display: flex;\n    animation: fadeIn 0.2s ease;\n  }\n  \n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n  \n  /* Mobile Menu Drawer */\n  .mobile-menu-drawer {\n    width: 280px;\n    max-width: 85vw;\n    background: white;\n    height: 100%;\n    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n    animation: slideIn 0.3s ease;\n    overflow: hidden;\n  }\n  \n  @keyframes slideIn {\n    from {\n      transform: translateX(-100%);\n    }\n    to {\n      transform: translateX(0);\n    }\n  }\n  \n  .mobile-menu-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px;\n    border-bottom: 1px solid #e2e8f0;\n    background: #f8fafc;\n  }\n  \n  .mobile-menu-header h2 {\n    margin: 0;\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #1e293b;\n  }\n  \n  .mobile-menu-close {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    background: transparent;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    cursor: pointer;\n    color: #475569;\n    font-size: 18px;\n    transition: all 0.2s ease;\n  }\n  \n  .mobile-menu-close:hover {\n    background: #e2e8f0;\n    border-color: #cbd5e1;\n  }\n  \n  .mobile-menu-content {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px 0;\n  }\n  \n  .mobile-nav-section {\n    margin-bottom: 24px;\n  }\n  \n  .mobile-section-title {\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    padding: 0 20px;\n    margin-bottom: 8px;\n  }\n  \n  .mobile-nav-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n    padding: 12px 20px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #475569;\n    text-align: left;\n    transition: all 0.15s ease;\n    font-size: 15px;\n    font-weight: 400;\n  }\n  \n  .mobile-nav-item:hover {\n    background: #f8fafc;\n    color: #1e293b;\n  }\n  \n  .mobile-nav-item.active {\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);\n    color: #667eea;\n    font-weight: 500;\n    border-left: 3px solid #667eea;\n  }\n  \n  .mobile-nav-item.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n  \n  .mobile-nav-item.disabled:hover {\n    background: #f8fafc;\n    color: #475569;\n  }\n  \n  .mobile-nav-icon {\n    font-size: 1.1rem;\n    width: 24px;\n    color: inherit;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .mobile-nav-label {\n    flex: 1;\n    font-weight: inherit;\n    font-size: 15px;\n  }\n  \n  .mobile-nav-blocked {\n    font-size: 0.75rem;\n    opacity: 0.7;\n  }\n  \n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .section-header {\n    flex-direction: column;\n    gap: 12px;\n    align-items: stretch;\n  }\n  \n  .search-bar input {\n    width: 100%;\n  }\n  \n  /* Hide mobile menu toggle on desktop */\n  @media (min-width: 641px) {\n    .mobile-menu-toggle {\n      display: none;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .create-account-content {\n    max-width: 100%;\n    padding: 1rem;\n    margin-top: 4rem;\n  }\n\n  .create-account-form-wrapper {\n    padding: 2rem 1.5rem;\n  }\n\n  .create-account-logo-top {\n    top: 1rem;\n    left: 1rem;\n  }\n\n  .create-account-logo-top .logo-img {\n    max-height: 100px;\n  }\n\n  .password-policy-box {\n    margin-bottom: 16px;\n  }\n}\n/* .login-container {\n  display: flex;\n  width: 900px;\n  height: 600px;\n  margin: 40px auto;\n  background: transparent;\n  box-shadow: 0 2px 24px rgba(24,90,219,0.08);\n  border-radius: 24px;\n  overflow: hidden;\n} */\n.login-left {\n  width: 50%;\n  min-width: 340px;\n  background: #185adb;\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 60px 48px;\n  border-radius: 24px 0 0 24px;\n  height: 85%;\n}\n.login-right {\n  width: 50%;\n  min-width: 340px;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 60px 48px;\n  border-radius: 0 24px 24px 0;\n  height: 85%;\n  box-shadow: none;\n}\n@media (max-width: 768px) {\n  .login-content {\n    max-width: 100%;\n    padding: 1rem;\n  }\n\n  .login-form-wrapper {\n    padding: 2rem 1.5rem;\n  }\n\n  .login-logo .logo-img {\n    max-height: 100px;\n  }\n\n  .back-to-home-btn {\n    top: 0.75rem;\n    left: 0.75rem;\n    padding: 0.4rem 0.8rem;\n    font-size: 0.85rem;\n  }\n}\n\n/* New Case Form Styles */\n.new-case {\n  padding: 2rem;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.form-header {\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.form-header h2 {\n  color: #333;\n  margin-bottom: 0.5rem;\n}\n\n.form-header p {\n  color: #666;\n  font-size: 1rem;\n}\n\n.new-case-form {\n  background: white;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.form-section {\n  margin-bottom: 1.5rem;\n  flex: 1;\n}\n\n/* Remove top margin from first section */\n.form-section:first-child {\n  margin-top: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.form-section h3 {\n  color: #333;\n  margin-bottom: 0.75rem;\n  margin-top: 0;\n  padding-bottom: 0.25rem;\n  border-bottom: 2px solid #e0e0e0;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n/* Reduce spacing for the first section */\n.form-section:first-child h3 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n  position: relative;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  color: #333;\n}\n\n\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: border-color 0.3s ease;\n}\n\n/* Make input fields smaller than form width */\n.form-group input[type=\"text\"],\n.form-group input[type=\"email\"] {\n  width: 90%;\n  max-width: 600px;\n}\n\n/* Style dropdowns to be clearly distinguishable */\n.form-group select {\n  width: 90%;\n  max-width: 600px;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n  background-position: right 0.5rem center;\n  background-repeat: no-repeat;\n  background-size: 1.5em 1.5em;\n  padding-right: 2.5rem;\n  cursor: pointer;\n  /* Remove default browser dropdown arrow */\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n/* Make textarea smaller to fit in window */\n.form-group textarea {\n  width: 90%;\n  max-width: 600px;\n  min-height: 120px;\n  resize: vertical;\n}\n\n/* Add fade effect to indicate scrollable content */\n.edit-case-form::after {\n  content: \"\";\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 20px;\n  background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.8));\n  pointer-events: none;\n  z-index: 1;\n}\n\n\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n/* Hover effects for dropdowns */\n.form-group select:hover {\n  border-color: #007bff;\n  background-color: #f8f9fa;\n}\n\n/* Different styling for text inputs vs dropdowns */\n.form-group input[type=\"text\"]:hover,\n.form-group input[type=\"email\"]:hover {\n  border-color: #007bff;\n  background-color: #f8f9fa;\n}\n\n/* Subtle background for dropdowns to distinguish them */\n.form-group select {\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  font-family: inherit;\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.form-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  margin-top: 1.5rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e0e0e0;\n  background: white;\n  padding-bottom: 1rem;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  position: relative;\n}\n\n/* Add subtle scroll indicator */\n.form-actions::before {\n  content: \"\";\n  position: absolute;\n  top: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 40px;\n  height: 4px;\n  background: linear-gradient(to right, transparent, #e0e0e0, transparent);\n  border-radius: 2px;\n}\n\n.cancel-btn {\n  padding: 0.75rem 2rem;\n  background: #6c757d;\n  color: #1f2937;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  min-width: 140px;\n  width: 140px;\n  white-space: nowrap;\n  flex: 1;\n  max-width: 200px;\n}\n\n.cancel-btn:hover {\n  background: #5a6268;\n}\n\n.submit-btn {\n  padding: 0.75rem 2rem;\n  background: #007bff;\n  color: #1f2937;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  min-width: 140px;\n  width: 140px;\n  white-space: nowrap;\n  flex: 1;\n  max-width: 200px;\n}\n\n.submit-btn:hover {\n  background: #0056b3;\n}\n\n.submit-btn:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n/* Responsive styles for edit case modal */\n@media (max-width: 768px) {\n  .edit-case-modal {\n    width: 98%;\n    max-width: none;\n    max-height: 98vh;\n    margin: 5px;\n  }\n  \n  .edit-case-form {\n    padding: 1rem 1rem 1rem 1rem;\n  }\n  \n  /* Make inputs full width on mobile for better usability */\n  .form-group input[type=\"text\"],\n  .form-group input[type=\"email\"],\n  .form-group select,\n  .form-group textarea {\n    width: 100%;\n    max-width: none;\n    padding-right: 0.75rem;\n  }\n  \n  .form-group select {\n    padding-right: 2.5rem;\n  }\n  \n  .form-actions {\n    flex-direction: column;\n    gap: 0.75rem;\n    padding: 1rem;\n  }\n  \n  .form-actions button {\n    width: 100%;\n    min-width: auto;\n    max-width: none;\n  }\n  \n  .cancel-btn,\n  .submit-btn {\n    padding: 0.75rem 1rem;\n    min-width: auto;\n    width: 100%;\n  }\n}\n\n.back-btn {\n  padding: 0.75rem 1.5rem;\n  background: #007bff;\n  color: #1f2937;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.back-btn:hover {\n  background: #0056b3;\n}\n\n/* Edit Case Modal Styles */\n.edit-case-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 10px;\n}\n\n.edit-case-modal {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  max-width: 1000px;\n  width: 98%;\n  max-height: 98vh;\n  overflow-y: auto;\n  margin: 10px;\n  display: flex;\n  flex-direction: column;\n  /* Custom scrollbar styling */\n  scrollbar-width: thin;\n  scrollbar-color: #888 #f1f1f1;\n}\n\n\n\n/* Custom scrollbar styling for modal */\n.edit-case-modal::-webkit-scrollbar {\n  width: 12px;\n}\n\n.edit-case-modal::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 6px;\n}\n\n.edit-case-modal::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 6px;\n  border: 2px solid #f1f1f1;\n}\n\n.edit-case-modal::-webkit-scrollbar-thumb:hover {\n  background: #666;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 2rem;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.modal-header h2 {\n  margin: 0;\n  color: #333;\n}\n\n.close-btn {\n  background: #dc3545;\n  border: none;\n  font-size: 1rem;\n  cursor: pointer;\n  color: #1f2937;\n  padding: 6px 12px;\n  width: auto;\n  height: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: background-color 0.2s;\n  font-weight: 500;\n  min-width: 60px;\n}\n\n.close-btn:hover {\n  background: #c82333;\n  color: #1f2937;\n}\n\n.edit-case-form {\n  padding: 0.5rem 2rem;\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  /* Custom scrollbar styling */\n  scrollbar-width: thin;\n  scrollbar-color: #888 #f1f1f1;\n}\n\n/* Custom scrollbar styling for webkit browsers */\n.edit-case-form::-webkit-scrollbar {\n  width: 12px;\n}\n\n.edit-case-form::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 6px;\n}\n\n.edit-case-form::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 6px;\n  border: 2px solid #f1f1f1;\n}\n\n.edit-case-form::-webkit-scrollbar-thumb:hover {\n  background: #666;\n}\n\n/* Case Details Modal Styles */\n.case-details-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 10px;\n}\n\n.case-details-modal {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  max-width: 1200px;\n  width: 98%;\n  max-height: 98vh;\n  overflow-y: auto;\n  margin: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.case-details-content {\n  padding: 1rem 2rem;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.case-info-section,\n.client-info-section,\n.documents-section,\n.ocr-summary-section {\n  margin-bottom: 2rem;\n}\n\n.case-info-section h3,\n.client-info-section h3,\n.documents-section h3,\n.ocr-summary-section h3 {\n  color: #333;\n  margin-bottom: 1rem;\n  font-size: 1.2rem;\n  font-weight: 600;\n  border-bottom: 2px solid #e0e0e0;\n  padding-bottom: 0.5rem;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.info-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.info-item label {\n  font-weight: 600;\n  color: #495057;\n}\n\n.document-checklist {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.document-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n  transition: all 0.3s ease;\n}\n\n.document-item:hover {\n  background: #e9ecef;\n  border-color: #007bff;\n}\n\n.document-info {\n  flex: 1;\n}\n\n.document-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.category-icon {\n  font-size: 1.2rem;\n}\n\n.document-name {\n  font-weight: 600;\n  color: #333;\n}\n\n.required-badge {\n  background: #dc3545;\n  color: #1f2937;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.status-icon {\n  font-size: 1.1rem;\n}\n\n.document-description {\n  color: #6c757d;\n  font-size: 0.9rem;\n  margin-bottom: 0.5rem;\n}\n\n.document-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 120px;\n}\n\n.upload-btn {\n  background: #007bff;\n  color: #1f2937;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  text-align: center;\n  font-size: 0.9rem;\n  transition: background-color 0.2s;\n}\n\n.upload-btn:hover {\n  background: #0056b3;\n}\n\n.uploaded-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.view-btn,\n.replace-btn {\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.2s;\n}\n\n.view-btn {\n  background: #28a745;\n  color: #1f2937;\n}\n\n.view-btn:hover {\n  background: #218838;\n}\n\n.replace-btn {\n  background: #6c757d;\n  color: #1f2937;\n}\n\n.replace-btn:hover {\n  background: #5a6268;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  padding: 1rem 2rem;\n  border-top: 1px solid #e0e0e0;\n  background: #f8f9fa;\n}\n\n.edit-btn {\n  background: #007bff;\n  color: #1f2937;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background-color 0.2s;\n}\n\n.edit-btn:hover {\n  background: #0056b3;\n}\n\n/* Tab Navigation */\n.tab-navigation {\n  display: flex;\n  border-bottom: 2px solid #e0e0e0;\n  margin-bottom: 2rem;\n  background: #f8f9fa;\n  border-radius: 8px 8px 0 0;\n}\n\n.tab-btn {\n  flex: 1;\n  padding: 1rem 1.5rem;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  color: #6c757d;\n  transition: all 0.3s ease;\n  border-bottom: 3px solid transparent;\n}\n\n.tab-btn:hover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.tab-btn.active {\n  background: white;\n  color: #007bff;\n  border-bottom-color: #007bff;\n  font-weight: 600;\n}\n\n/* Overview Content */\n.overview-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.progress-summary-section {\n  margin-top: 1rem;\n}\n\n.progress-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.5rem;\n  margin-top: 1rem;\n}\n\n.progress-item {\n  text-align: center;\n}\n\n.progress-circle {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: #1f2937;\n  border-radius: 50%;\n  width: 120px;\n  height: 120px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto 1rem;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.progress-number {\n  font-size: 2rem;\n  font-weight: bold;\n  line-height: 1;\n}\n\n.progress-label {\n  font-size: 0.8rem;\n  opacity: 0.9;\n  margin-top: 0.25rem;\n}\n\n/* Documents Content */\n.documents-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.bulk-upload-section {\n  background: #f8f9fa;\n  border: 2px dashed #dee2e6;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 24px;\n  text-align: center;\n}\n\n.bulk-upload-section h4 {\n  margin: 0 0 8px 0;\n  color: #333;\n  font-size: 1.1rem;\n}\n\n.bulk-upload-section p {\n  margin: 0 0 16px 0;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.bulk-upload-btn {\n  display: inline-block;\n  background: #007bff;\n  color: #1f2937;\n  padding: 12px 24px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n  margin-bottom: 12px;\n}\n\n.bulk-upload-btn:hover {\n  background: #0056b3;\n}\n\n.upload-tips {\n  background: #e3f2fd;\n  border-radius: 4px;\n  padding: 8px 12px;\n  border-left: 4px solid #2196f3;\n}\n\n.upload-tips small {\n  color: #1976d2;\n  font-size: 0.85rem;\n  line-height: 1.4;\n}\n\n/* Document Selection Styles */\n.document-selection-section,\n.form-selection-section {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 24px;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.section-header h4 {\n  margin: 0;\n  color: #333;\n  font-size: 1.1rem;\n}\n\n.add-custom-btn {\n  background: #28a745;\n  color: #1f2937;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n}\n\n.add-custom-btn:hover {\n  background: #218838;\n}\n\n.document-list,\n.form-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.document-selection-item,\n.form-selection-item {\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all 0.2s ease;\n}\n\n.document-selection-item:hover,\n.form-selection-item:hover {\n  border-color: #007bff;\n  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);\n}\n\n.document-selection-info,\n.form-selection-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n.document-details,\n.form-details {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.document-name,\n.form-name {\n  font-weight: 600;\n  color: #333;\n  font-size: 1rem;\n}\n\n.document-description,\n.form-description {\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.form-meta {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  margin-top: 4px;\n}\n\n.estimated-time {\n  color: #666;\n  font-size: 0.85rem;\n}\n\n/* Checkbox Styles */\n.checkbox-container {\n  position: relative;\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n.checkbox-container input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  background-color: #fff;\n  border: 2px solid #ddd;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.checkbox-container:hover input ~ .checkmark {\n  border-color: #007bff;\n}\n\n.checkbox-container input:checked ~ .checkmark {\n  background-color: #007bff;\n  border-color: #007bff;\n}\n\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n.checkbox-container input:checked ~ .checkmark:after {\n  display: block;\n}\n\n.checkbox-container .checkmark:after {\n  left: 6px;\n  top: 2px;\n  width: 6px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n/* Selected Items Styles */\n.selected-documents-section,\n.selected-forms-section {\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.selected-documents-section h4,\n.selected-forms-section h4 {\n  margin: 0 0 16px 0;\n  color: #333;\n  font-size: 1.1rem;\n}\n\n.selected-documents-list,\n.selected-forms-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.selected-document-item,\n.selected-form-item {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.custom-badge {\n  background: #ffc107;\n  color: #212529;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-left: 8px;\n}\n\n.remove-btn {\n  background: #dc3545;\n  color: #1f2937;\n  border: none;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 0.8rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n  margin-left: 8px;\n}\n\n.remove-btn:hover {\n  background: #c82333;\n}\n\n/* Save Button */\n.save-btn {\n  background: #28a745;\n  color: #1f2937;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n  margin-right: 12px;\n}\n\n.save-btn:hover {\n  background: #218838;\n}\n\n/* Custom Modal Styles */\n.custom-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n}\n\n.custom-modal {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  width: 90%;\n  max-width: 500px;\n  overflow: hidden;\n}\n\n.custom-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #e9ecef;\n  background: #f8f9fa;\n}\n\n.custom-modal-header h3 {\n  margin: 0;\n  color: #333;\n}\n\n.custom-modal-content {\n  padding: 20px;\n}\n\n.custom-modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.add-btn {\n  background: #28a745;\n  color: #1f2937;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n}\n\n.add-btn:hover {\n  background: #218838;\n}\n\n/* Forms Content */\n.forms-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.forms-checklist {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-item {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 12px;\n  padding: 1.5rem;\n  transition: all 0.3s ease;\n}\n\n.form-item:hover {\n  background: #e9ecef;\n  border-color: #007bff;\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.1);\n}\n\n.form-info {\n  flex: 1;\n}\n\n.form-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n}\n\n.form-name {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #333;\n  flex: 1;\n}\n\n.form-status {\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.form-description {\n  color: #6c757d;\n  margin-bottom: 1rem;\n  line-height: 1.5;\n}\n\n.form-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.form-detail-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.form-detail-item label {\n  font-weight: 600;\n  color: #495057;\n  min-width: 120px;\n}\n\n.required-docs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.doc-tag {\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.doc-tag.uploaded {\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.doc-tag.pending {\n  background: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffeaa7;\n}\n\n.form-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.form-btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.form-btn.start {\n  background: #28a745;\n  color: #1f2937;\n}\n\n.form-btn.start:hover {\n  background: #218838;\n}\n\n.form-btn.completed {\n  background: #6c757d;\n  color: #1f2937;\n}\n\n.form-btn.completed:hover {\n  background: #5a6268;\n}\n\n.form-btn.secondary {\n  background: #007bff;\n  color: #1f2937;\n}\n\n.form-btn.secondary:hover {\n  background: #0056b3;\n}\n\n/* Priority Badge Colors */\n.priority-badge.text-red-600.bg-red-100 {\n  background: #f8d7da !important;\n  color: #721c24 !important;\n  border: 1px solid #f5c6cb;\n}\n\n.priority-badge.text-yellow-600.bg-yellow-100 {\n  background: #fff3cd !important;\n  color: #856404 !important;\n  border: 1px solid #ffeaa7;\n}\n\n.priority-badge.text-green-600.bg-green-100 {\n  background: #d4edda !important;\n  color: #155724 !important;\n  border: 1px solid #c3e6cb;\n}\n\n/* Form Status Colors */\n.form-status.text-green-600.bg-green-100 {\n  background: #d4edda !important;\n  color: #155724 !important;\n}\n\n.form-status.text-blue-600.bg-blue-100 {\n  background: #d1ecf1 !important;\n  color: #0c5460 !important;\n}\n\n.form-status.text-gray-600.bg-gray-100 {\n  background: #e2e3e5 !important;\n  color: #383d41 !important;\n}\n\n/* Responsive Design for Case Details */\n@media (max-width: 768px) {\n  .case-details-modal {\n    width: 95%;\n    margin: 5px;\n  }\n  \n  .case-details-content {\n    padding: 1rem;\n  }\n  \n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .document-item {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .document-actions {\n    min-width: auto;\n    width: 100%;\n  }\n  \n  .uploaded-actions {\n    flex-direction: row;\n  }\n  \n  .extracted-fields {\n    grid-template-columns: 1fr;\n  }\n  \n  .tab-navigation {\n    flex-direction: column;\n  }\n  \n  .tab-btn {\n    border-bottom: none;\n    border-right: 3px solid transparent;\n  }\n  \n  .tab-btn.active {\n    border-bottom: none;\n    border-right-color: #007bff;\n  }\n  \n  .progress-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .form-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n  \n  .form-actions {\n    flex-direction: column;\n  }\n  \n  .form-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* Document Upload Styles */\n.document-upload {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 24px;\n}\n\n.upload-section {\n  margin-bottom: 24px;\n}\n\n.section-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 16px;\n}\n\n.file-selection {\n  margin-bottom: 16px;\n}\n\n.file-input-wrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.file-input {\n  position: absolute;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.file-label {\n  display: block;\n  padding: 12px 16px;\n  background: #f3f4f6;\n  border: 2px dashed #d1d5db;\n  border-radius: 8px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #6b7280;\n}\n\n.file-label:hover {\n  background: #e5e7eb;\n  border-color: #9ca3af;\n}\n\n.file-info {\n  margin-top: 8px;\n  padding: 8px 12px;\n  background: #f0f9ff;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.file-name {\n  font-weight: 500;\n  color: #1f2937;\n}\n\n.file-size {\n  color: #6b7280;\n  margin-left: 8px;\n}\n\n.document-type-selection {\n  margin-bottom: 16px;\n}\n\n.label {\n  display: block;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 6px;\n}\n\n.select-input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: white;\n  font-size: 14px;\n  color: #1f2937;\n}\n\n.select-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.upload-button {\n  width: 100%;\n  padding: 12px 16px;\n  background: #3b82f6;\n  color: #1f2937;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.upload-button:hover:not(:disabled) {\n  background: #2563eb;\n}\n\n.upload-button:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* Upload Progress Styles */\n.upload-progress {\n  border-top: 1px solid #e5e7eb;\n  padding-top: 20px;\n}\n\n.progress-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.progress-header h4 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.clear-button {\n  padding: 6px 12px;\n  background: #f3f4f6;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.clear-button:hover:not(:disabled) {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n.clear-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.uploads-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.upload-item {\n  padding: 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: #fafafa;\n  transition: all 0.2s ease;\n}\n\n.upload-item.upload-ready {\n  border-color: #10b981;\n  background: #f0fdf4;\n}\n\n.upload-item.upload-failed {\n  border-color: #ef4444;\n  background: #fef2f2;\n}\n\n.upload-item.upload-uploading {\n  border-color: #3b82f6;\n  background: #eff6ff;\n}\n\n.upload-info {\n  margin-bottom: 12px;\n}\n\n.upload-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.status-icon {\n  font-size: 16px;\n}\n\n.file-name {\n  flex: 1;\n  font-weight: 500;\n  color: #1f2937;\n}\n\n.status-badge {\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.text-yellow-600 {\n  color: #d97706;\n  background: #fef3c7;\n}\n\n.text-blue-600 {\n  color: #2563eb;\n  background: #dbeafe;\n}\n\n.text-purple-600 {\n  color: #7c3aed;\n  background: #ede9fe;\n}\n\n.text-green-600 {\n  color: #059669;\n  background: #d1fae5;\n}\n\n.text-red-600 {\n  color: #dc2626;\n  background: #fee2e2;\n}\n\n.text-gray-600 {\n  color: #4b5563;\n  background: #f3f4f6;\n}\n\n.upload-details {\n  display: flex;\n  gap: 12px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 4px;\n  background: #e5e7eb;\n  border-radius: 2px;\n  overflow: hidden;\n  margin-top: 8px;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #3b82f6, #1d4ed8);\n  transition: width 0.3s ease;\n}\n\n.error-message {\n  margin-top: 8px;\n  padding: 8px 12px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #dc2626;\n}\n\n.upload-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.action-button {\n  padding: 6px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.download-button {\n  color: #059669;\n  border-color: #10b981;\n}\n\n.download-button:hover {\n  background: #f0fdf4;\n  border-color: #059669;\n}\n\n.retry-button {\n  color: #d97706;\n  border-color: #f59e0b;\n}\n\n.retry-button:hover {\n  background: #fef3c7;\n  border-color: #d97706;\n}\n\n.remove-button {\n  color: #dc2626;\n  border-color: #f87171;\n}\n\n.remove-button:hover {\n  background: #fef2f2;\n  border-color: #dc2626;\n}\n\n/* Documents Component Styles */\n.documents {\n  padding: 24px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.documents-header {\n  margin-bottom: 24px;\n  text-align: center;\n}\n\n.documents-header h2 {\n  font-size: 28px;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 8px;\n}\n\n.documents-header p {\n  color: #6b7280;\n  font-size: 16px;\n}\n\n.case-selection {\n  margin-bottom: 24px;\n  max-width: 400px;\n}\n\n.documents-list {\n  margin-top: 32px;\n}\n\n.documents-list h3 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 16px;\n}\n\n.documents-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 16px;\n}\n\n.document-card {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 20px;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.document-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transform: translateY(-2px);\n}\n\n.document-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.document-name {\n  flex: 1;\n  font-weight: 600;\n  color: #1f2937;\n  font-size: 14px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.document-details {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 16px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.document-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.delete-button {\n  color: #dc2626;\n  border-color: #f87171;\n}\n\n.delete-button:hover {\n  background: #fef2f2;\n  border-color: #dc2626;\n}\n\n.debug-button {\n  color: #7c3aed;\n  border-color: #a78bfa;\n}\n\n.debug-button:hover {\n  background: #ede9fe;\n  border-color: #7c3aed;\n}\n\n.fix-button {\n  color: #d97706;\n  border-color: #fbbf24;\n}\n\n.fix-button:hover {\n  background: #fef3c7;\n  border-color: #d97706;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 48px 24px;\n  background: white;\n  border: 2px dashed #d1d5db;\n  border-radius: 12px;\n}\n\n.empty-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n  opacity: 0.5;\n}\n\n.empty-state h4 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.empty-state p {\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.loading {\n  text-align: center;\n  padding: 48px;\n  color: #6b7280;\n  font-size: 16px;\n}\n\n/* Status badge styles for documents */\n.status-pending {\n  color: #d97706;\n  background: #fef3c7;\n}\n\n.status-uploading {\n  color: #2563eb;\n  background: #dbeafe;\n}\n\n.status-processing {\n  color: #7c3aed;\n  background: #ede9fe;\n}\n\n.status-ready {\n  color: #059669;\n  background: #d1fae5;\n}\n\n.status-failed {\n  color: #dc2626;\n  background: #fee2e2;\n}\n\n/* Document Manager Styles */\n.document-manager {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.upload-widget {\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 24px;\n  margin-bottom: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.upload-widget h3 {\n  margin: 0 0 20px 0;\n  color: #1f2937;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.upload-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-weight: 500;\n  color: #374151;\n  font-size: 14px;\n}\n\n.file-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: #f0f9ff;\n  border-radius: 6px;\n  font-size: 14px;\n  color: #1f2937;\n}\n\n.download-widget {\n  background: white;\n  border: 2px solid #10b981;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.download-widget h3 {\n  margin: 0 0 20px 0;\n  color: #1f2937;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.documents-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.document-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: #fafafa;\n  transition: all 0.2s ease;\n}\n\n.document-item:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transform: translateY(-1px);\n}\n\n.document-info {\n  flex: 1;\n}\n\n.document-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.document-name {\n  font-weight: 600;\n  color: #1f2937;\n  font-size: 14px;\n}\n\n.document-details {\n  display: flex;\n  gap: 12px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.document-actions {\n  display: flex;\n  gap: 8px;\n}\n\n/* Status badges for document manager */\n.status-ready {\n  color: #059669;\n  background: #d1fae5;\n}\n\n.status-pending {\n  color: #d97706;\n  background: #fef3c7;\n}\n\n.status-uploading {\n  color: #2563eb;\n  background: #dbeafe;\n}\n\n.status-processing {\n  color: #7c3aed;\n  background: #ede9fe;\n}\n\n.status-failed {\n  color: #dc2626;\n  background: #fee2e2;\n}\n\n/* Document Management - New Two-Panel Design */\n\n.documents-page {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n  background: #f8f9fa;\n  min-height: 100vh;\n}\n\n.documents-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding: 20px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.documents-header h1 {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.case-selector select {\n  padding: 10px 15px;\n  border: 2px solid #e1e8ed;\n  border-radius: 8px;\n  font-size: 14px;\n  background: white;\n  min-width: 250px;\n  cursor: pointer;\n}\n\n.case-selector select:focus {\n  outline: none;\n  border-color: #3498db;\n}\n\n/* Bulk Actions */\n.bulk-actions {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 25px;\n  padding: 20px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.bulk-upload {\n  flex: 1;\n}\n\n.bulk-upload-btn {\n  display: inline-block;\n  padding: 12px 24px;\n  background: #27ae60;\n  color: #1f2937;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.3s ease;\n}\n\n.bulk-upload-btn:hover {\n  background: #229954;\n}\n\n.bulk-download-btn {\n  padding: 12px 24px;\n  background: #3498db;\n  color: #1f2937;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.3s ease;\n}\n\n.bulk-download-btn:hover:not(:disabled) {\n  background: #2980b9;\n}\n\n.bulk-download-btn:disabled {\n  background: #bdc3c7;\n  cursor: not-allowed;\n}\n\n/* Top Panel - Required Documents Checklist */\n.required-documents-panel {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  margin-bottom: 25px;\n  overflow: hidden;\n}\n\n.required-documents-panel .panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 20px 10px 20px;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.required-documents-panel .panel-header h2 {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.required-documents-panel .panel-header p {\n  margin: 0;\n  color: #7f8c8d;\n  font-size: 14px;\n}\n\n.refresh-btn {\n  background: #007bff;\n  color: #1f2937;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.refresh-btn:hover {\n  background: #0056b3;\n}\n\n.refresh-btn:active {\n  background: #004085;\n}\n\n/* Category Selection */\n.category-selection {\n  margin-bottom: 20px;\n  padding: 0 20px;\n}\n\n.category-selector {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.category-dropdown {\n  flex: 1;\n  padding: 10px 12px;\n  border: 1px solid #e1e8ed;\n  border-radius: 6px;\n  font-size: 14px;\n  background: white;\n  cursor: pointer;\n  transition: border-color 0.2s;\n}\n\n.category-dropdown:focus {\n  outline: none;\n  border-color: #3498db;\n  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.1);\n}\n\n.add-category-btn {\n  padding: 10px 16px;\n  background: #059669;\n  color: #1f2937;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  white-space: nowrap;\n}\n\n.add-category-btn:hover:not(:disabled) {\n  background: #047857;\n}\n\n.add-category-btn:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n.remove-category-btn {\n  padding: 6px 10px;\n  background: #ef4444;\n  color: #1f2937;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  margin-left: 8px;\n}\n\n.remove-category-btn:hover:not(.disabled) {\n  background: #dc2626;\n}\n\n.remove-category-btn.disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.remove-category-btn.disabled:hover {\n  background: #9ca3af;\n  transform: none;\n}\n\n.document-requirements {\n  padding: 0 20px 20px 20px;\n}\n\n.document-requirement {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px;\n  border: 1px solid #e1e8ed;\n  border-radius: 8px;\n  margin-bottom: 10px;\n  transition: all 0.3s ease;\n}\n\n.document-requirement:hover {\n  border-color: #3498db;\n  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.1);\n}\n\n.requirement-info {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  flex: 1;\n}\n\n.category-icon {\n  font-size: 24px;\n  width: 40px;\n  text-align: center;\n}\n\n.requirement-details h3 {\n  margin: 0 0 5px 0;\n  color: #2c3e50;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.requirement-details p {\n  margin: 0;\n  color: #7f8c8d;\n  font-size: 14px;\n}\n\n.requirement-actions {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.status {\n  font-size: 14px;\n  font-weight: 500;\n  padding: 6px 12px;\n  border-radius: 20px;\n  background: #f8f9fa;\n}\n\n.status.text-green-600 {\n  background: #d4edda;\n  color: #155724;\n}\n\n.status.text-orange-600 {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.upload-btn {\n  padding: 8px 16px;\n  background: #3498db;\n  color: #1f2937;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.3s ease;\n}\n\n.upload-btn:hover {\n  background: #2980b9;\n}\n\n.download-btn {\n  padding: 8px 16px;\n  background: #27ae60;\n  color: #1f2937;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.3s ease;\n}\n\n.download-btn:hover {\n  background: #229954;\n}\n\n/* Bottom Panel - Uploaded Documents */\n.uploaded-documents-panel {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  overflow: hidden;\n}\n\n.panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #e1e8ed;\n}\n\n.panel-header h2 {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.panel-controls {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n}\n\n.category-filter {\n  padding: 8px 12px;\n  border: 1px solid #e1e8ed;\n  border-radius: 6px;\n  font-size: 14px;\n  background: white;\n  min-width: 150px;\n}\n\n.search-box {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-box input {\n  padding: 8px 35px 8px 12px;\n  border: 1px solid #e1e8ed;\n  border-radius: 6px;\n  font-size: 14px;\n  width: 250px;\n}\n\n.search-box input:focus {\n  outline: none;\n  border-color: #3498db;\n}\n\n.search-icon {\n  display: none;\n}\n\n.uploaded-documents-list {\n  padding: 20px;\n}\n\n.uploaded-document {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px;\n  border: 1px solid #e1e8ed;\n  border-radius: 8px;\n  margin-bottom: 10px;\n  transition: all 0.3s ease;\n}\n\n.uploaded-document:hover {\n  border-color: #3498db;\n  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.1);\n}\n\n.document-info {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  flex: 1;\n}\n\n.file-icon {\n  font-size: 24px;\n  width: 40px;\n  text-align: center;\n}\n\n.document-details h4 {\n  margin: 0 0 5px 0;\n  color: #2c3e50;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.document-details p {\n  margin: 0;\n  color: #7f8c8d;\n  font-size: 14px;\n}\n\n.document-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.view-btn, .download-btn, .delete-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.view-btn {\n  background: #3498db;\n  color: #1f2937;\n}\n\n.view-btn:hover {\n  background: #2980b9;\n}\n\n.download-btn {\n  background: #27ae60;\n  color: #1f2937;\n}\n\n.download-btn:hover {\n  background: #229954;\n}\n\n.delete-btn {\n  background: #e74c3c;\n  color: #1f2937;\n}\n\n.delete-btn:hover {\n  background: #c0392b;\n}\n\n/* Empty States */\n.empty-state {\n  text-align: center;\n  padding: 40px 20px;\n  color: #7f8c8d;\n}\n\n.empty-icon {\n  font-size: 48px;\n  margin-bottom: 15px;\n}\n\n.empty-state h3 {\n  margin: 0 0 10px 0;\n  color: #2c3e50;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.empty-state p {\n  margin: 0;\n  font-size: 14px;\n}\n\n.no-case-selected {\n  text-align: center;\n  padding: 60px 20px;\n  color: #7f8c8d;\n}\n\n.no-case-selected .empty-icon {\n  font-size: 64px;\n  margin-bottom: 20px;\n}\n\n.no-case-selected h3 {\n  margin: 0 0 10px 0;\n  color: #2c3e50;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.no-case-selected p {\n  margin: 0;\n  font-size: 16px;\n}\n\n/* Loading State */\n.loading {\n  text-align: center;\n  padding: 60px 20px;\n  color: #7f8c8d;\n  font-size: 16px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .documents-header {\n    flex-direction: column;\n    gap: 15px;\n    align-items: stretch;\n  }\n  \n  .case-selector select {\n    min-width: auto;\n  }\n  \n  .bulk-actions {\n    flex-direction: column;\n  }\n  \n  .document-requirement {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 15px;\n  }\n  \n  .requirement-actions {\n    justify-content: space-between;\n  }\n  \n  .panel-header {\n    flex-direction: column;\n    gap: 15px;\n    align-items: stretch;\n  }\n  \n  .panel-controls {\n    flex-direction: column;\n  }\n  \n  .search-box input {\n    width: 100%;\n  }\n  \n  .uploaded-document {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 15px;\n  }\n  \n  .document-actions {\n    justify-content: space-between;\n  }\n}\n\n/* Delete Confirmation Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.delete-modal {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  max-width: 500px;\n  width: 90%;\n  max-height: 80vh;\n  overflow: hidden;\n  animation: modalSlideIn 0.3s ease-out;\n  display: flex;\n  flex-direction: column;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.modal-header {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: #1f2937;\n  padding: 20px 24px;\n  text-align: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.modal-content {\n  padding: 32px;\n  text-align: center;\n}\n\n.modal-content p {\n  margin: 0 0 20px 0;\n  font-size: 16px;\n  color: #4a5568;\n  line-height: 1.6;\n}\n\n.document-info {\n  background: #f7fafc;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 16px;\n  margin: 20px 0;\n}\n\n.document-info strong {\n  color: #2d3748;\n  font-size: 18px;\n  word-break: break-word;\n}\n\n.warning-text {\n  background: #fff5f5;\n  border: 1px solid #fed7d7;\n  border-radius: 8px;\n  padding: 16px;\n  color: #c53030;\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 20px 0 0 0;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 16px;\n  padding: 24px 32px 32px 32px;\n  justify-content: center;\n}\n\n.cancel-btn {\n  background: white;\n  color: #4a5568;\n  border: 2px solid #e2e8f0;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 120px;\n}\n\n.cancel-btn:hover {\n  background: #f7fafc;\n  border-color: #cbd5e0;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.delete-confirm-btn {\n  background: linear-gradient(135deg, #ff6b6b, #ee5a52);\n  color: #1f2937;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 160px;\n  box-shadow: 0 4px 12px rgba(238, 90, 82, 0.3);\n}\n\n.delete-confirm-btn:hover {\n  background: linear-gradient(135deg, #ff5252, #d32f2f);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(238, 90, 82, 0.4);\n}\n\n.delete-confirm-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(238, 90, 82, 0.3);\n}\n\n/* Responsive design for mobile */\n@media (max-width: 768px) {\n  .delete-modal {\n    width: 95%;\n    margin: 20px;\n    max-height: 85vh;\n  }\n  \n  .modal-header {\n    padding: 12px 16px;\n  }\n  \n  .modal-close-btn {\n    top: 12px;\n    right: 12px;\n    width: 28px;\n    height: 28px;\n    font-size: 16px;\n  }\n  \n  .modal-content {\n    padding: 16px;\n  }\n  \n  .modal-actions {\n    padding: 12px 16px;\n    flex-direction: column;\n  }\n  \n  .cancel-btn,\n  .delete-confirm-btn {\n    width: 100%;\n    min-width: auto;\n  }\n}\n\n@media (max-height: 600px) {\n  .delete-modal {\n    max-height: 95vh;\n  }\n  \n  .delete-modal .modal-body {\n    padding: 12px 16px;\n  }\n  \n  .delete-modal .case-info,\n  .delete-modal .warning-box,\n  .delete-modal .content-summary {\n    padding: 8px 12px;\n    margin: 8px 0;\n  }\n}\n\n/* File Type Modal */\n.file-type-modal {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow: hidden;\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n.file-type-modal .modal-header {\n  background: linear-gradient(135deg, #4f46e5, #7c3aed);\n  color: #1f2937;\n  padding: 24px 32px;\n  text-align: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.file-type-modal .modal-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n}\n\n.file-type-modal .modal-header h3 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.file-type-modal .modal-content {\n  padding: 32px;\n}\n\n.file-preview-info {\n  display: flex;\n  align-items: center;\n  background: #f8fafc;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n}\n\n.file-preview-info .file-icon {\n  font-size: 32px;\n  margin-right: 16px;\n  color: #64748b;\n}\n\n.file-preview-info .file-details h4 {\n  margin: 0 0 8px 0;\n  color: #1e293b;\n  font-size: 18px;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.file-preview-info .file-type-info {\n  margin: 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.supported-formats {\n  background: #f0f9ff;\n  border: 1px solid #bae6fd;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 24px;\n}\n\n.supported-formats h5 {\n  margin: 0 0 12px 0;\n  color: #0369a1;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.format-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.format-item {\n  color: #0c4a6e;\n  font-size: 14px;\n  padding: 4px 0;\n}\n\n.action-suggestion {\n  background: #fef3c7;\n  border: 1px solid #f59e0b;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.action-suggestion p {\n  margin: 0;\n  color: #92400e;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.download-confirm-btn {\n  background: linear-gradient(135deg, #059669, #10b981);\n  color: #1f2937;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 160px;\n  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);\n}\n\n.download-confirm-btn:hover {\n  background: linear-gradient(135deg, #047857, #059669);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(5, 150, 105, 0.4);\n}\n\n.download-confirm-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(5, 150, 105, 0.3);\n}\n\n/* Responsive design for file type modal */\n@media (max-width: 768px) {\n  .file-type-modal {\n    width: 95%;\n    margin: 20px;\n  }\n  \n  .file-type-modal .modal-header {\n    padding: 20px 24px;\n  }\n  \n  .file-type-modal .modal-content {\n    padding: 24px;\n  }\n  \n  .file-preview-info {\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .file-preview-info .file-icon {\n    margin-right: 0;\n    margin-bottom: 12px;\n  }\n  \n  .modal-actions {\n    padding: 20px 24px 24px 24px;\n    flex-direction: column;\n  }\n  \n  .cancel-btn,\n  .download-confirm-btn {\n    width: 100%;\n    min-width: auto;\n  }\n}\n\n/* File size limit indicators */\n.file-size-limit {\n  background: #f0f9ff;\n  border: 1px solid #bae6fd;\n  border-radius: 6px;\n  padding: 8px 12px;\n  margin: 12px 0;\n  color: #0369a1;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.file-size-hint {\n  color: #64748b;\n  font-size: 12px;\n  margin-left: 8px;\n  font-style: italic;\n}\n\n/* Responsive design for file size indicators */\n@media (max-width: 768px) {\n  .file-size-limit {\n    font-size: 13px;\n    padding: 6px 10px;\n  }\n  \n  .file-size-hint {\n    display: block;\n    margin-left: 0;\n    margin-top: 4px;\n    text-align: center;\n  }\n}\n\n/* File Size Error Modal */\n.file-size-error-modal {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow: hidden;\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n.file-size-error-modal .modal-header {\n  background: linear-gradient(135deg, #dc2626, #ef4444);\n  color: #1f2937;\n  padding: 24px 32px;\n  text-align: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.file-size-error-modal .modal-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n}\n\n.file-size-error-modal .modal-header h3 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.modal-close-btn {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: #1f2937;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  font-size: 18px;\n  font-weight: bold;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  backdrop-filter: blur(4px);\n}\n\n.modal-close-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.1);\n}\n\n.modal-close-btn:active {\n  transform: scale(0.95);\n}\n\n.file-size-error-modal .modal-content {\n  padding: 32px;\n}\n\n.file-error-info {\n  display: flex;\n  align-items: center;\n  background: #fef2f2;\n  border: 2px solid #fecaca;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n}\n\n.file-error-info .file-icon {\n  font-size: 32px;\n  margin-right: 16px;\n  color: #dc2626;\n}\n\n.file-error-info .file-details h4 {\n  margin: 0 0 8px 0;\n  color: #1e293b;\n  font-size: 18px;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.file-error-info .file-size-error {\n  margin: 0;\n  color: #dc2626;\n  font-size: 14px;\n}\n\n.size-limit-info {\n  background: #fef3c7;\n  border: 1px solid #f59e0b;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 24px;\n}\n\n.size-limit-info h5 {\n  margin: 0 0 12px 0;\n  color: #92400e;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.size-limit-info p {\n  margin: 0 0 8px 0;\n  color: #92400e;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.helpful-tips {\n  background: #f0f9ff;\n  border: 1px solid #bae6fd;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 24px;\n}\n\n.helpful-tips h5 {\n  margin: 0 0 12px 0;\n  color: #0369a1;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.helpful-tips ul {\n  margin: 0;\n  padding-left: 20px;\n  color: #0c4a6e;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.helpful-tips li {\n  margin-bottom: 6px;\n}\n\n.close-error-btn {\n  background: linear-gradient(135deg, #dc2626, #ef4444);\n  color: #1f2937;\n  border: none;\n  padding: 12px 32px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 120px;\n  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);\n}\n\n.close-error-btn:hover {\n  background: linear-gradient(135deg, #b91c1c, #dc2626);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(220, 38, 38, 0.4);\n}\n\n.close-error-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);\n}\n\n/* Responsive design for file size error modal */\n@media (max-width: 768px) {\n  .file-size-error-modal {\n    width: 95%;\n    margin: 20px;\n  }\n  \n  .file-size-error-modal .modal-header {\n    padding: 20px 24px;\n  }\n  \n  .modal-close-btn {\n    top: 12px;\n    right: 12px;\n    width: 28px;\n    height: 28px;\n    font-size: 16px;\n  }\n  \n  .file-size-error-modal .modal-content {\n    padding: 24px;\n  }\n  \n  .file-error-info {\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .file-error-info .file-icon {\n    margin-right: 0;\n    margin-bottom: 12px;\n  }\n  \n  .modal-actions {\n    padding: 20px 24px 24px 24px;\n    flex-direction: column;\n  }\n  \n  .close-error-btn {\n    width: 100%;\n    min-width: auto;\n  }\n}\n\n/* Upload hint */\n.upload-hint {\n  color: #059669;\n  font-size: 12px;\n  margin-left: 8px;\n  font-style: italic;\n}\n\n/* Categorization Review Modal */\n.categorization-review-modal {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  max-width: 700px;\n  width: 90%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n.categorization-review-modal .modal-header {\n  background: linear-gradient(135deg, #059669, #10b981);\n  color: #1f2937;\n  padding: 24px 32px;\n  text-align: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.categorization-review-modal .modal-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n}\n\n.categorization-review-modal .modal-header h3 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.categorization-review-modal .modal-content {\n  padding: 32px;\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.categorization-review-modal .modal-content p {\n  margin: 0 0 20px 0;\n  color: #4a5568;\n  line-height: 1.6;\n}\n\n.documents-to-review {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.document-review-item {\n  background: #f8fafc;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.document-preview {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex: 1;\n}\n\n.document-preview .file-icon {\n  font-size: 32px;\n  color: #64748b;\n}\n\n.document-preview .file-details h4 {\n  margin: 0 0 8px 0;\n  color: #1e293b;\n  font-size: 16px;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.document-preview .file-details p {\n  margin: 0 0 4px 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.review-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 200px;\n}\n\n.category-select {\n  padding: 8px 12px;\n  border: 2px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 14px;\n  background: white;\n  color: #1e293b;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.category-select:focus {\n  outline: none;\n  border-color: #059669;\n}\n\n.categorization-review-modal .modal-actions {\n  padding: 24px 32px;\n  background: #f8fafc;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  flex-shrink: 0;\n}\n\n.accept-all-btn {\n  background: linear-gradient(135deg, #059669, #10b981);\n  color: #1f2937;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 160px;\n  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);\n}\n\n.accept-all-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #047857, #059669);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(5, 150, 105, 0.4);\n}\n\n.accept-all-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.categorization-review-modal .cancel-btn {\n  background: #6b7280;\n  color: #1f2937;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 120px;\n}\n\n.categorization-review-modal .cancel-btn:hover {\n  background: #4b5563;\n}\n\n/* Quality Error Details */\n.quality-error-details {\n  margin-top: 12px;\n  text-align: left;\n}\n\n.quality-error-details p {\n  margin: 8px 0;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.quality-error-details strong {\n  color: #374151;\n}\n\n/* Success Modal */\n.success-modal {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n.success-modal .modal-header {\n  background: linear-gradient(135deg, #059669, #10b981);\n  color: #1f2937;\n  padding: 24px 32px;\n  text-align: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.success-modal .modal-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n}\n\n.success-modal .modal-header h3 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.success-modal .modal-content {\n  padding: 32px;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.success-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 20px;\n}\n\n.success-icon {\n  font-size: 64px;\n  animation: bounce 0.6s ease-in-out;\n}\n\n.success-details h4 {\n  margin: 0 0 12px 0;\n  color: #059669;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.success-details p {\n  margin: 0;\n  color: #4a5568;\n  line-height: 1.6;\n  font-size: 16px;\n}\n\n.success-modal .modal-actions {\n  padding: 24px 32px;\n  background: #f8fafc;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.success-ok-btn {\n  background: linear-gradient(135deg, #059669, #10b981);\n  color: #1f2937;\n  border: none;\n  padding: 12px 32px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 120px;\n  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);\n}\n\n.success-ok-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(5, 150, 105, 0.4);\n}\n\n.success-ok-btn:active {\n  transform: translateY(0);\n}\n\n@keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-10px);\n  }\n  60% {\n    transform: translateY(-5px);\n  }\n}\n\n/* Processing Status Modal */\n.processing-status-modal {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow: hidden;\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n.processing-status-modal .modal-header {\n  background: linear-gradient(135deg, #3b82f6, #1d4ed8);\n  color: #1f2937;\n  padding: 24px 32px;\n  text-align: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.processing-status-modal .modal-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n}\n\n.processing-status-modal .modal-header h3 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.processing-status-modal .modal-content {\n  padding: 32px;\n  text-align: center;\n}\n\n.processing-status-modal .modal-content p {\n  margin: 0 0 20px 0;\n  color: #4a5568;\n  line-height: 1.6;\n  font-size: 16px;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #e2e8f0;\n  border-radius: 4px;\n  overflow: hidden;\n  margin: 20px 0;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(135deg, #3b82f6, #1d4ed8);\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n/* Responsive design for new modals */\n@media (max-width: 768px) {\n  .categorization-review-modal {\n    width: 95%;\n    margin: 20px;\n  }\n  \n  .categorization-review-modal .modal-header {\n    padding: 20px 24px;\n  }\n  \n  .categorization-review-modal .modal-content {\n    padding: 24px;\n  }\n  \n  .document-review-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .review-actions {\n    width: 100%;\n    min-width: auto;\n  }\n  \n  .categorization-review-modal .modal-actions {\n    padding: 20px 24px;\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .categorization-review-modal .modal-actions button {\n    width: 100%;\n    min-width: auto;\n  }\n  \n  .success-modal {\n    width: 95%;\n    margin: 20px;\n  }\n  \n  .success-modal .modal-header {\n    padding: 20px 24px;\n  }\n  \n  .success-modal .modal-content {\n    padding: 24px;\n  }\n  \n  .success-info {\n    gap: 16px;\n  }\n  \n  .success-icon {\n    font-size: 48px;\n  }\n  \n  .success-details h4 {\n    font-size: 18px;\n  }\n  \n  .success-details p {\n    font-size: 14px;\n  }\n  \n  .success-modal .modal-actions {\n    padding: 20px 24px;\n  }\n  \n  .success-ok-btn {\n    width: 100%;\n    min-width: auto;\n  }\n  \n  .processing-status-modal {\n    width: 95%;\n    margin: 20px;\n  }\n  \n  .processing-status-modal .modal-header {\n    padding: 20px 24px;\n  }\n  \n  .processing-status-modal .modal-content {\n    padding: 24px;\n  }\n  \n  .upload-hint {\n    display: block;\n    margin-left: 0;\n    margin-top: 4px;\n    text-align: center;\n  }\n}\n\n/* Custom Category Modal */\n.custom-category-modal {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n.custom-category-modal .modal-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: #1f2937;\n  padding: 24px 32px;\n  border-radius: 16px 16px 0 0;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.custom-category-modal .modal-content {\n  padding: 32px;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.custom-category-modal .form-group {\n  margin-bottom: 24px;\n}\n\n.custom-category-modal .form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #374151;\n  font-size: 14px;\n}\n\n.custom-category-modal .form-input,\n.custom-category-modal .form-textarea {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  box-sizing: border-box;\n}\n\n.custom-category-modal .form-input:focus,\n.custom-category-modal .form-textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.custom-category-modal .form-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.custom-category-modal .modal-actions {\n  padding: 24px 32px;\n  background: #f8fafc;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n  flex-shrink: 0;\n}\n\n.custom-category-modal .create-btn {\n  background: #667eea;\n  color: #1f2937;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 140px;\n}\n\n.custom-category-modal .create-btn:hover {\n  background: #5a67d8;\n  transform: translateY(-1px);\n}\n\n.custom-category-modal .create-btn:active {\n  transform: translateY(0);\n}\n\n@media (max-width: 768px) {\n  .custom-category-modal {\n    width: 95%;\n    margin: 20px;\n  }\n  \n  .custom-category-modal .modal-header {\n    padding: 20px 24px;\n  }\n  \n  .custom-category-modal .modal-content {\n    padding: 24px;\n  }\n  \n  .custom-category-modal .modal-actions {\n    padding: 20px 24px;\n    flex-direction: column;\n  }\n  \n  .custom-category-modal .modal-actions button {\n    width: 100%;\n    min-width: auto;\n  }\n}\n\n/* Multi-file upload improvements */\n.upload-btn {\n  position: relative;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.upload-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.upload-btn::after {\n  content: \"\";\n  font-size: 0.8em;\n  opacity: 0.7;\n  font-weight: normal;\n}\n\n/* Drag and Drop Upload Areas */\n.upload-action {\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.upload-action:hover {\n  transform: translateY(-1px);\n}\n\n.upload-action:active {\n  transform: translateY(0);\n}\n\n.bulk-upload {\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.bulk-upload:hover {\n  transform: translateY(-1px);\n}\n\n.bulk-upload:active {\n  transform: translateY(0);\n}\n\n/* Drag over states */\n.upload-action.drag-over,\n.bulk-upload.drag-over {\n  border-color: #3b82f6 !important;\n  background-color: #f0f9ff !important;\n  transform: scale(1.02);\n}\n\n/* Form Bulk Operations */\n.autofill-checkbox-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.autofill-checkbox-container:hover {\n  background-color: #f3f4f6;\n}\n\n.autofill-checkbox {\n  accent-color: #7c3aed;\n  cursor: pointer;\n}\n\n.autofill-checkbox:hover {\n  transform: scale(1.1);\n}\n\n.autofill-hint {\n  font-size: 8px;\n  color: #7c3aed;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n}\n\n.autofill-checkbox-container:hover .autofill-hint {\n  opacity: 1;\n}\n\n/* Disabled download checkbox styling */\n.download-checkbox:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.download-checkbox:disabled:hover {\n  transform: none;\n}\n\n.download-checkbox-container:has(.download-checkbox:disabled):hover {\n  background-color: transparent;\n}\n\n/* Loading animation */\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n/* File upload progress indicator */\n.upload-progress {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 5px;\n  font-size: 0.9em;\n  color: #666;\n}\n\n.upload-progress-bar {\n  flex: 1;\n  height: 4px;\n  background-color: #e0e0e0;\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.upload-progress-fill {\n  height: 100%;\n  background-color: #007bff;\n  transition: width 0.3s ease;\n}\n\n/* Success message for multiple uploads */\n.upload-success {\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  color: #155724;\n  padding: 8px 12px;\n  border-radius: 4px;\n  margin-top: 5px;\n  font-size: 0.9em;\n}\n\n/* PDF Merging Styles */\n.merge-pdfs-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: #1f2937;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  margin-right: 10px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.merge-pdfs-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0,0,0,0.15);\n}\n\n.merge-checkbox {\n  margin-right: 8px;\n  transform: scale(1.2);\n  accent-color: #667eea;\n}\n\n/* PDF Merge Modal */\n.pdf-merge-modal {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0,0,0,0.15);\n  max-width: 700px;\n  width: 90%;\n  max-height: 85vh;\n  overflow-y: auto;\n  position: relative;\n}\n\n.pdf-merge-modal .modal-header {\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  padding: 20px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.pdf-merge-modal .modal-header h3 {\n  font-weight: 600;\n  font-size: 18px;\n  color: #1f2937;\n}\n\n.pdf-merge-modal .modal-content {\n  padding: 16px;\n  max-height: 65vh;\n  overflow-y: auto;\n}\n\n.merge-section {\n  margin-bottom: 16px;\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.merge-section h4 {\n  margin: 0 0 12px 0;\n  color: #495057;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.document-selection-list {\n  max-height: 150px;\n  overflow-y: auto;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  background: white;\n}\n\n.document-selection-item {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  border-bottom: 1px solid #f1f3f4;\n  transition: background-color 0.2s ease;\n}\n\n.document-selection-item:hover {\n  background-color: #f8f9fa;\n}\n\n.document-selection-item:last-child {\n  border-bottom: none;\n}\n\n.document-selection-item .document-details {\n  flex: 1;\n  margin-left: 8px;\n}\n\n.document-selection-item .document-details strong {\n  display: block;\n  font-size: 14px;\n  color: #212529;\n}\n\n.document-selection-item .document-details small {\n  color: #6c757d;\n  font-size: 12px;\n}\n\n.merge-order-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.merge-order-controls label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 6px;\n  transition: background-color 0.2s ease;\n}\n\n.merge-order-controls label:hover {\n  background-color: #e9ecef;\n}\n\n.merge-order-controls input[type=\"radio\"] {\n  margin-right: 8px;\n  transform: scale(1.1);\n  accent-color: #667eea;\n}\n\n.custom-order-interface {\n  margin-top: 16px;\n  padding: 16px;\n  background: white;\n  border-radius: 6px;\n  border: 1px solid #dee2e6;\n}\n\n.custom-order-list {\n  margin-top: 12px;\n}\n\n.custom-order-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  margin: 4px 0;\n  background: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #e9ecef;\n}\n\n.custom-order-item .order-number {\n  font-weight: bold;\n  color: #667eea;\n  margin-right: 12px;\n  min-width: 20px;\n}\n\n.custom-order-item .file-name {\n  flex: 1;\n  font-size: 14px;\n}\n\n.custom-order-item .drag-handle {\n  color: #6c757d;\n  cursor: grab;\n  font-size: 16px;\n}\n\n.merge-actions {\n  text-align: center;\n  padding: 16px 0;\n  border-top: 1px solid #e9ecef;\n  margin-top: 16px;\n}\n\n.merge-btn {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 200px;\n}\n\n.merge-btn.enabled {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: #1f2937;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.merge-btn.enabled:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);\n}\n\n.merge-btn.disabled {\n  background: #e9ecef;\n  color: #6c757d;\n  cursor: not-allowed;\n}\n\n.merged-documents-list {\n  max-height: 150px;\n  overflow-y: auto;\n}\n\n.merged-document-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n  margin: 8px 0;\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  transition: box-shadow 0.2s ease;\n}\n\n.merged-document-item:hover {\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.merged-doc-info strong {\n  display: block;\n  font-size: 14px;\n  color: #212529;\n}\n\n.merged-doc-info small {\n  color: #6c757d;\n  font-size: 12px;\n}\n\n.merged-doc-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.merged-doc-actions .download-btn,\n.merged-doc-actions .delete-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.merged-doc-actions .download-btn {\n  background: #28a745;\n  color: #1f2937;\n}\n\n.merged-doc-actions .download-btn:hover {\n  background: #218838;\n}\n\n.merged-doc-actions .delete-btn {\n  background: #dc3545;\n  color: #1f2937;\n}\n\n.merged-doc-actions .delete-btn:hover {\n  background: #c82333;\n}\n\n.no-merged-docs {\n  text-align: center;\n  color: #6c757d;\n  font-style: italic;\n  padding: 20px;\n}\n\n/* Enhanced document list with merge checkboxes */\n.uploaded-document .document-info {\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n\n.uploaded-document .document-info .file-icon {\n  margin-left: 8px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .pdf-merge-modal {\n    width: 95%;\n    margin: 20px;\n  }\n  \n  .merge-order-controls {\n    gap: 8px;\n  }\n  \n  .merged-doc-actions {\n    flex-direction: column;\n    gap: 4px;\n  }\n  \n  .merged-doc-actions .download-btn,\n  .merged-doc-actions .delete-btn {\n    padding: 4px 8px;\n    font-size: 11px;\n  }\n}\n\n/* Custom Order Interface Styles */\n.custom-order-interface {\n  margin-top: 16px;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.custom-order-interface p {\n  margin: 0 0 12px 0;\n  font-weight: 600;\n  color: #495057;\n}\n\n.custom-order-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.custom-order-item {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  background: white;\n  border: 2px solid #e9ecef;\n  border-radius: 6px;\n  cursor: grab;\n  transition: all 0.2s ease;\n  user-select: none;\n}\n\n.custom-order-item:hover {\n  border-color: #007bff;\n  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1);\n}\n\n.custom-order-item.dragging {\n  opacity: 0.5;\n  transform: rotate(2deg);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  cursor: grabbing;\n}\n\n.custom-order-item.drag-over {\n  border-color: #28a745;\n  background: #f8fff9;\n  transform: scale(1.02);\n}\n\n.custom-order-item .order-number {\n  font-weight: bold;\n  color: #007bff;\n  margin-right: 12px;\n  min-width: 24px;\n}\n\n.custom-order-item .file-name {\n  flex: 1;\n  font-size: 14px;\n  color: #495057;\n}\n\n.custom-order-item .drag-handle {\n  color: #6c757d;\n  font-size: 16px;\n  cursor: grab;\n  padding: 4px;\n  border-radius: 4px;\n  transition: background 0.2s ease;\n}\n\n.custom-order-item .drag-handle:hover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.custom-order-item.dragging .drag-handle {\n  cursor: grabbing;\n}\n\n/* Merge Modal Improvements */\n.pdf-merge-modal .modal-content {\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.merge-section {\n  margin-bottom: 24px;\n}\n\n.merge-section h4 {\n  margin: 0 0 16px 0;\n  color: #495057;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.merge-order-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.merge-order-controls label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 6px;\n  transition: background 0.2s ease;\n}\n\n.merge-order-controls label:hover {\n  background: #f8f9fa;\n}\n\n.merge-order-controls input[type=\"radio\"] {\n  margin: 0;\n}\n\n.merge-actions {\n  margin-top: 24px;\n  text-align: center;\n}\n\n.merge-btn {\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.merge-btn.enabled {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: #1f2937;\n}\n\n.merge-btn.enabled:hover {\n  background: #5a32a3;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(111, 66, 193, 0.3);\n}\n\n.merge-btn.disabled {\n  background: #e9ecef;\n  color: #6c757d;\n  cursor: not-allowed;\n}\n\n/* Drag and Drop Visual Improvements */\n.custom-order-item:active {\n  cursor: grabbing;\n}\n\n.custom-order-item.dragging {\n  z-index: 1000;\n  position: relative;\n}\n\n.custom-order-item.drag-over::before {\n  content: '';\n  position: absolute;\n  top: -2px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: #28a745;\n  border-radius: 1px;\n}\n\n/* Case Forms Styles */\n.case-forms-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.forms-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.forms-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 24px;\n}\n\n.case-selector {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.case-dropdown {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  font-size: 14px;\n  min-width: 250px;\n}\n\n.no-case-selected {\n  text-align: center;\n  padding: 60px 20px;\n  color: #666;\n}\n\n.no-case-selected h2 {\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.forms-content {\n  display: grid;\n  gap: 30px;\n}\n\n.available-forms-section,\n.selected-forms-section {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.section-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 18px;\n}\n\n.add-custom-btn {\n  background: #007bff;\n  color: #1f2937;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.add-custom-btn:hover {\n  background: #0056b3;\n}\n\n.forms-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.form-card {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 16px;\n  background: #fafafa;\n  transition: all 0.2s ease;\n}\n\n.form-card:hover {\n  border-color: #007bff;\n  box-shadow: 0 2px 8px rgba(0,123,255,0.1);\n}\n\n.form-card .form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 10px;\n}\n\n.form-card h4 {\n  margin: 0 0 8px 0;\n  color: #333;\n  font-size: 16px;\n  line-height: 1.3;\n}\n\n.form-description {\n  color: #666;\n  font-size: 14px;\n  line-height: 1.4;\n  margin-bottom: 12px;\n}\n\n.form-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  font-size: 12px;\n}\n\n.estimated-time {\n  color: #666;\n}\n\n.category-badge {\n  background: #e9ecef;\n  color: #495057;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-weight: 500;\n}\n\n.add-form-btn {\n  width: 100%;\n  background: #28a745;\n  color: #1f2937;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.add-form-btn:hover {\n  background: #218838;\n}\n\n.selected-forms-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.selected-form-item {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 20px;\n  background: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.form-info {\n  flex: 1;\n}\n\n.selected-form-item .form-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n}\n\n.selected-form-item h4 {\n  margin: 0;\n  color: #333;\n  font-size: 16px;\n  flex: 1;\n}\n\n.custom-badge {\n  background: #ffc107;\n  color: #212529;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: bold;\n}\n\n.status-badge {\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.status-completed {\n  background: #d4edda;\n  color: #155724;\n}\n\n.status-processing {\n  background: #cce7ff;\n  color: #004085;\n}\n\n.status-pending {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.priority-badge {\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.priority-high {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.priority-medium {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.priority-low {\n  background: #d1ecf1;\n  color: #0c5460;\n}\n\n.form-details {\n  display: grid;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.form-detail-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.form-detail-item label {\n  font-weight: 500;\n  color: #333;\n  min-width: 120px;\n  font-size: 14px;\n}\n\n.required-docs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.doc-tag {\n  background: #e9ecef;\n  color: #495057;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  text-transform: capitalize;\n}\n\n.form-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 150px;\n}\n\n.status-select {\n  padding: 6px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background: white;\n  font-size: 12px;\n}\n\n.view-form-btn {\n  background: #007bff;\n  color: #1f2937;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.view-form-btn:hover {\n  background: #0056b3;\n}\n\n.remove-btn {\n  background: #dc3545;\n  color: #1f2937;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.remove-btn:hover {\n  background: #c82333;\n}\n\n.no-forms-message {\n  text-align: center;\n  padding: 40px 20px;\n  color: #666;\n  font-style: italic;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n  font-size: 16px;\n}\n\n/* Modal styles for custom form */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: white;\n  border-radius: 8px;\n  padding: 0;\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #333;\n}\n\n.modal-content {\n  padding: 20px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0,123,255,0.25);\n}\n\n.modal-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n.add-btn {\n  background: #28a745;\n  color: #1f2937;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.add-btn:hover {\n  background: #218838;\n}\n\n.cancel-btn {\n  background: #6c757d;\n  color: #1f2937;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.cancel-btn:hover {\n  background: #5a6268;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .forms-header {\n    flex-direction: column;\n    gap: 15px;\n    align-items: stretch;\n  }\n  \n  .case-dropdown {\n    min-width: auto;\n  }\n  \n  .forms-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .selected-form-item {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .form-actions {\n    min-width: auto;\n    width: 100%;\n  }\n  \n  .form-actions {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n}\n\n/* Form Selection Controls */\n.form-selection-controls {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.form-category-dropdown {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  font-size: 14px;\n  min-width: 200px;\n}\n\n.form-selection-area {\n  margin-top: 20px;\n}\n\n.form-dropdown-section {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.form-dropdown-section label {\n  display: block;\n  margin-bottom: 15px;\n  font-weight: 600;\n  color: #333;\n  font-size: 16px;\n}\n\n.form-options-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n  gap: 15px;\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 10px;\n  background: white;\n  border-radius: 6px;\n  border: 1px solid #e0e0e0;\n}\n\n.form-option-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  background: #fafafa;\n  transition: all 0.2s ease;\n}\n\n.form-option-item:hover {\n  border-color: #007bff;\n  background: #f0f8ff;\n}\n\n.form-option-info {\n  flex: 1;\n  margin-right: 15px;\n}\n\n.form-option-info .form-name {\n  display: block;\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n  margin-bottom: 5px;\n  line-height: 1.3;\n}\n\n.form-option-info .form-description {\n  display: block;\n  color: #666;\n  font-size: 12px;\n  margin-bottom: 8px;\n  line-height: 1.4;\n}\n\n.form-option-info .form-meta {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.form-option-info .estimated-time {\n  font-size: 11px;\n  color: #666;\n}\n\n.form-option-item .add-form-btn {\n  background: #28a745;\n  color: #1f2937;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  white-space: nowrap;\n  min-width: 60px;\n}\n\n.form-option-item .add-form-btn:hover {\n  background: #218838;\n}\n\n.no-forms-available {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 40px 20px;\n  color: #666;\n  font-style: italic;\n}\n\n/* Update existing styles */\n.required-forms-section {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  margin-bottom: 30px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .form-selection-controls {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n  \n  .form-category-dropdown {\n    min-width: auto;\n  }\n  \n  .form-options-grid {\n    grid-template-columns: 1fr;\n    max-height: 300px;\n  }\n  \n  .form-option-item {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n  \n  .form-option-info {\n    margin-right: 0;\n  }\n  \n  .form-option-item .add-form-btn {\n    align-self: flex-end;\n  }\n}\n\n/* Case Details Modal - Country Field */\n.country-value {\n  font-weight: 600;\n  color: #2c5aa0;\n  background: #f0f8ff;\n  padding: 4px 8px;\n  border-radius: 4px;\n  border: 1px solid #d1e7ff;\n  display: inline-block;\n  min-width: 60px;\n  text-align: center;\n}\n\n/* Case Forms - Country Indicator */\n.country-indicator {\n  margin-bottom: 15px;\n}\n\n.country-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: #1f2937;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-weight: 600;\n  font-size: 14px;\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n}\n\n.country-hint {\n  color: #666;\n  font-weight: normal;\n  font-size: 13px;\n  margin-left: 8px;\n  font-style: italic;\n}\n\n/* Update section header for better layout */\n.required-forms-section .section-header {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.required-forms-section .section-header h3 {\n  margin: 0;\n}\n\n.required-forms-section .form-selection-controls {\n  align-self: flex-end;\n}\n\n/* Case Forms - Form Dropdown Interface */\n.form-selector {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.form-dropdown {\n  flex: 1;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  font-size: 14px;\n  min-width: 300px;\n}\n\n.form-dropdown:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.form-selector .add-form-btn {\n  background: #28a745;\n  color: #1f2937;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  white-space: nowrap;\n  min-width: 80px;\n  transition: background-color 0.2s ease;\n}\n\n.form-selector .add-form-btn:hover:not(:disabled) {\n  background: #218838;\n}\n\n.form-selector .add-form-btn:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Update form dropdown section styling */\n.form-dropdown-section {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.form-dropdown-section label {\n  display: block;\n  margin-bottom: 10px;\n  font-weight: 600;\n  color: #333;\n  font-size: 16px;\n}\n\n/* Case Delete Modal Styles */\n.delete-modal .modal-header {\n  background: linear-gradient(135deg, #dc3545, #c82333);\n  color: #1f2937;\n  padding: 16px 24px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.delete-modal .modal-header h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.delete-modal .modal-body {\n  padding: 20px 24px;\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.delete-modal .case-info {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin: 12px 0;\n}\n\n.delete-modal .case-info p {\n  margin: 8px 0;\n  font-size: 0.9rem;\n  color: #374151;\n}\n\n.delete-modal .warning-box {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin: 12px 0;\n}\n\n.delete-modal .warning-box p {\n  margin: 8px 0;\n  color: #dc3545;\n  font-weight: 500;\n}\n\n.delete-modal .content-summary {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin: 12px 0;\n}\n\n.delete-modal .content-summary p {\n  margin: 8px 0;\n  font-weight: 600;\n  color: #374151;\n}\n\n.delete-modal .content-summary ul {\n  margin: 8px 0;\n  padding-left: 20px;\n}\n\n.delete-modal .content-summary li {\n  margin: 4px 0;\n  color: #6b7280;\n}\n\n.delete-modal .modal-footer {\n  padding: 16px 24px 20px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  flex-shrink: 0;\n  background: white;\n}\n\n.delete-modal .cancel-btn {\n  background: #f3f4f6;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.delete-modal .cancel-btn:hover {\n  background: #e5e7eb;\n  border-color: #9ca3af;\n}\n\n.delete-modal .delete-btn {\n  background: #dc3545;\n  color: #1f2937;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.delete-modal .delete-btn:hover {\n  background: #c82333;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px -1px rgba(220, 53, 69, 0.3);\n}\n\n/* Government Requirements Notice */\n.govt-requirements-notice {\n  background: linear-gradient(135deg, #fef3c7, #fde68a);\n  border: 2px solid #f59e0b;\n  border-radius: 12px;\n  padding: 16px 20px;\n  margin: 16px 0;\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.1);\n  animation: slideInDown 0.3s ease-out;\n}\n\n.govt-requirements-notice .notice-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.govt-requirements-notice .notice-icon {\n  font-size: 18px;\n  color: #92400e;\n}\n\n.govt-requirements-notice .notice-title {\n  color: #92400e;\n  font-weight: 600;\n  font-size: 14px;\n  margin: 0;\n}\n\n.govt-requirements-notice .notice-text {\n  color: #92400e;\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 0;\n  opacity: 0.9;\n}\n\n@keyframes slideInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Mode switch buttons */\n.mode-switch {\n  background: #f3f4f6;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n}\n.mode-switch.active {\n  background: #185adb;\n  border-color: #185adb;\n  color: #fff;\n}\n\n/* Assistant full width container */\n.assistant-fullwidth {\n  flex: 1;\n  display: flex;\n}\n\n/* Assistant sidebar container (split view) */\n.assistant-sidebar {\n  width: auto;\n  min-width: 0; /* allow shrinking to avoid gaps */\n  max-width: none;\n  border-left: none;\n  background: transparent;\n  display: flex;\n}\n\n/* Allow main-content to handle full width / split flex */\n.main-content {\n  display: flex;\n  height: calc(100vh - 64px);\n}\n\n/* Legal assistant base */\n.legal-assistant.drag-over {\n  outline: 2px dashed #3b82f6;\n  outline-offset: -6px;\n}\n\n/* Assistant side placement borders */\n.assistant-sidebar.left {\n  border-right: 1px solid #e5e7eb;\n}\n.assistant-sidebar.right {\n  border-left: 1px solid #e5e7eb;\n}\n\n/* Assistant collapse/expand controls */\n.assistant-collapse-btn {\n  position: absolute;\n  top: 10px;\n  left: -14px;\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: 50%;\n  background: #fff;\n  color: #667eea;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n}\n\n/* Dock/Undock toggle */\n.dock-toggle-btn {\n  background: #f3f4f6;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n}\n.dock-toggle-btn:hover {\n  background: #e5e7eb;\n}\n\n/* AI-First Layout */\n.main-content.ai-first {\n  display: flex;\n  height: 100vh;\n  width: 100%;\n}\n\n.assistant-fullwidth {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n}\n\n.legal-assistant {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-radius: 0;\n}\n\n.assistant-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: #1f2937;\n  padding: 16px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 0;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.assistant-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.header-actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.back-to-dashboard-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: #1f2937;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.back-to-dashboard-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n}\n\n.login-left, .login-right {\n  border-radius: 0 0 0 0;\n}\n/* PDF Merge Modal - Compression and Filename Controls */\n.compression-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.compression-controls label {\n  font-weight: 500;\n  color: #374151;\n  font-size: 14px;\n}\n\n.compression-select {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: white;\n  font-size: 14px;\n  color: #374151;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.compression-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.compression-info {\n  font-size: 12px;\n  margin: 0;\n  padding: 8px 12px;\n  border-radius: 6px;\n  background: #f0f9ff;\n  border: 1px solid #bae6fd;\n  color: #0369a1;\n}\n\n.filename-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.filename-controls label {\n  font-weight: 500;\n  color: #374151;\n  font-size: 14px;\n}\n\n.filename-input {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: white;\n  font-size: 14px;\n  color: #374151;\n  transition: border-color 0.2s ease;\n}\n\n.filename-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.filename-input::placeholder {\n  color: #9ca3af;\n}\n\n.filename-info {\n  font-size: 12px;\n  margin: 0;\n  padding: 8px 12px;\n  border-radius: 6px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  color: #6b7280;\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  .compression-controls label,\n  .filename-controls label {\n    color: #e5e7eb;\n  }\n  \n  .compression-select,\n  .filename-input {\n    background: #374151;\n    border-color: #4b5563;\n    color: #e5e7eb;\n  }\n  \n  .compression-select:focus,\n  .filename-input:focus {\n    border-color: #60a5fa;\n    box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.1);\n  }\n  \n  .filename-input::placeholder {\n    color: #9ca3af;\n  }\n  \n  .compression-info {\n    background: #1e3a8a;\n    border-color: #1d4ed8;\n    color: #93c5fd;\n  }\n  \n  .filename-info {\n    background: #374151;\n    border-color: #4b5563;\n    color: #9ca3af;\n  }\n}\n\n/* Mobile responsiveness */\n@media (max-width: 640px) {\n  .compression-controls,\n  .filename-controls {\n    gap: 8px;\n  }\n  \n  .compression-select,\n  .filename-input {\n    padding: 10px 12px;\n    font-size: 16px; /* Prevents zoom on iOS */\n  }\n}\n\n/* Modern Delete Modal - Smooth & Stylish */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(8px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.delete-modal {\n  background: white;\n  border-radius: 24px;\n  box-shadow: \n    0 25px 50px -12px rgba(0, 0, 0, 0.25),\n    0 0 0 1px rgba(255, 255, 255, 0.1);\n  max-width: 480px;\n  width: 90%;\n  max-height: 85vh;\n  overflow: hidden;\n  animation: slideInUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(32px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.delete-modal::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #ef4444, #f97316, #eab308, #22c55e, #3b82f6, #8b5cf6, #ec4899);\n  border-radius: 24px 24px 0 0;\n}\n\n.modal-header {\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n  color: #dc2626;\n  padding: 24px 28px 20px;\n  text-align: center;\n  border-bottom: 1px solid rgba(220, 38, 38, 0.1);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.modal-header h3::before {\n  content: '🗑️';\n  font-size: 18px;\n}\n\n.modal-content {\n  padding: 28px;\n  text-align: center;\n  flex: 1;\n}\n\n.modal-content p {\n  margin: 0 0 24px 0;\n  font-size: 16px;\n  color: #374151;\n  line-height: 1.6;\n  font-weight: 500;\n}\n\n.document-info {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 20px;\n  margin: 24px 0;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.document-info::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #3b82f6, #8b5cf6);\n}\n\n.document-info:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n}\n\n.document-info .document-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, #3b82f6, #1d4ed8);\n  border-radius: 12px;\n  margin-right: 12px;\n  color: white;\n  font-size: 18px;\n}\n\n.document-info .document-details {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex: 1;\n}\n\n.document-info strong {\n  color: #1f2937;\n  font-size: 16px;\n  font-weight: 600;\n  word-break: break-word;\n  flex: 1;\n  text-align: left;\n}\n\n.document-type-badge {\n  background: linear-gradient(135deg, #f3f4f6, #e5e7eb);\n  color: #6b7280;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: capitalize;\n  border: 1px solid #d1d5db;\n}\n\n.warning-text {\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n  border: 1px solid #fecaca;\n  border-radius: 16px;\n  padding: 16px 20px;\n  color: #dc2626;\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 24px 0 0 0;\n  font-weight: 500;\n  position: relative;\n  overflow: hidden;\n}\n\n.warning-text::before {\n  content: '⚠️';\n  margin-right: 8px;\n  font-size: 16px;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  padding: 20px 28px 28px;\n  justify-content: center;\n  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);\n  border-top: 1px solid #e5e7eb;\n}\n\n.cancel-btn {\n  background: white;\n  color: #6b7280;\n  border: 2px solid #e5e7eb;\n  padding: 12px 24px;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  min-width: 120px;\n  position: relative;\n  overflow: hidden;\n}\n\n.cancel-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\n  transition: left 0.5s;\n}\n\n.cancel-btn:hover::before {\n  left: 100%;\n}\n\n.cancel-btn:hover {\n  background: #f9fafb;\n  border-color: #d1d5db;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  color: #374151;\n}\n\n.delete-confirm-btn {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  min-width: 160px;\n  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.3);\n  position: relative;\n  overflow: hidden;\n}\n\n.delete-confirm-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s;\n}\n\n.delete-confirm-btn:hover::before {\n  left: 100%;\n}\n\n.delete-confirm-btn:hover {\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4);\n}\n\n.delete-confirm-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.3);\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 768px) {\n  .delete-modal {\n    width: 95%;\n    margin: 20px;\n    max-height: 90vh;\n    border-radius: 20px;\n  }\n  \n  .modal-header {\n    padding: 20px 24px 16px;\n  }\n  \n  .modal-header h3 {\n    font-size: 18px;\n  }\n  \n  .modal-content {\n    padding: 24px;\n  }\n  \n  .document-info {\n    padding: 16px;\n    border-radius: 12px;\n  }\n  \n  .modal-actions {\n    padding: 16px 24px 24px;\n    flex-direction: column;\n  }\n  \n  .cancel-btn,\n  .delete-confirm-btn {\n    width: 100%;\n    min-width: auto;\n  }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  .delete-modal {\n    background: #1f2937;\n    box-shadow: \n      0 25px 50px -12px rgba(0, 0, 0, 0.5),\n      0 0 0 1px rgba(255, 255, 255, 0.1);\n  }\n  \n  .modal-header {\n    background: linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%);\n    color: #fca5a5;\n  }\n  \n  .modal-content p {\n    color: #d1d5db;\n  }\n  \n  .document-info {\n    background: linear-gradient(135deg, #374151 0%, #4b5563 100%);\n    border-color: #4b5563;\n  }\n  \n  .document-info strong {\n    color: #f9fafb;\n  }\n  \n  .document-type-badge {\n    background: linear-gradient(135deg, #4b5563, #6b7280);\n    color: #d1d5db;\n    border-color: #6b7280;\n  }\n  \n  .warning-text {\n    background: linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%);\n    border-color: #dc2626;\n    color: #fca5a5;\n  }\n  \n  .modal-actions {\n    background: linear-gradient(135deg, #374151 0%, #4b5563 100%);\n    border-top-color: #4b5563;\n  }\n  \n  .cancel-btn {\n    background: #4b5563;\n    color: #d1d5db;\n    border-color: #6b7280;\n  }\n  \n  .cancel-btn:hover {\n    background: #6b7280;\n    border-color: #9ca3af;\n    color: #f9fafb;\n  }\n}\n\n/* Document Item Styling for Delete Modal */\n.document-item {\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  margin: 8px 0;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.document-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #3b82f6, #8b5cf6);\n}\n\n.document-item:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.document-item .document-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background: linear-gradient(135deg, #3b82f6, #1d4ed8);\n  border-radius: 10px;\n  margin-right: 12px;\n  color: white;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.document-item .document-details {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex: 1;\n  min-width: 0;\n}\n\n.document-item strong {\n  color: #1f2937;\n  font-size: 15px;\n  font-weight: 600;\n  word-break: break-word;\n  flex: 1;\n  text-align: left;\n  margin-right: 12px;\n}\n\n.document-item .document-type-badge {\n  background: linear-gradient(135deg, #f3f4f6, #e5e7eb);\n  color: #6b7280;\n  padding: 4px 10px;\n  border-radius: 16px;\n  font-size: 11px;\n  font-weight: 500;\n  text-transform: capitalize;\n  border: 1px solid #d1d5db;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* Dark mode for document items */\n@media (prefers-color-scheme: dark) {\n  .document-item {\n    background: linear-gradient(135deg, #374151 0%, #4b5563 100%);\n    border-color: #4b5563;\n  }\n  \n  .document-item strong {\n    color: #f9fafb;\n  }\n  \n  .document-item .document-type-badge {\n    background: linear-gradient(135deg, #4b5563, #6b7280);\n    color: #d1d5db;\n    border-color: #6b7280;\n  }\n}\n\n/* Enhanced Bulk Delete Modal - Smooth & Modern */\n.documents-to-delete {\n  max-height: 300px;\n  overflow-y: auto;\n  border: none;\n  border-radius: 16px;\n  padding: 16px;\n  margin: 20px 0;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  box-shadow: \n    inset 0 2px 4px rgba(0, 0, 0, 0.06),\n    0 1px 3px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n.documents-to-delete::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899);\n  border-radius: 16px 16px 0 0;\n}\n\n.document-to-delete {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  border: none;\n  background: white;\n  border-radius: 12px;\n  margin-bottom: 12px;\n  box-shadow: \n    0 2px 8px rgba(0, 0, 0, 0.04),\n    0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.document-to-delete::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 3px;\n  height: 100%;\n  background: linear-gradient(180deg, #ef4444, #dc2626);\n  border-radius: 0 2px 2px 0;\n}\n\n.document-to-delete:hover {\n  transform: translateY(-2px);\n  box-shadow: \n    0 8px 25px rgba(0, 0, 0, 0.1),\n    0 4px 12px rgba(0, 0, 0, 0.05);\n  background: linear-gradient(135deg, #ffffff 0%, #fefefe 100%);\n}\n\n.document-to-delete:last-child {\n  margin-bottom: 0;\n}\n\n.document-to-delete .document-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n  border-radius: 10px;\n  color: white;\n  font-size: 18px;\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);\n  flex-shrink: 0;\n}\n\n.document-to-delete .document-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.document-to-delete .document-info strong {\n  display: block;\n  font-size: 15px;\n  color: #1f2937;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.4;\n}\n\n.document-to-delete .document-info small {\n  display: block;\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 500;\n  text-transform: capitalize;\n  background: linear-gradient(135deg, #f3f4f6, #e5e7eb);\n  padding: 2px 8px;\n  border-radius: 6px;\n  width: fit-content;\n  border: 1px solid #d1d5db;\n}\n\n/* Enhanced warning text for bulk delete */\n.bulk-delete-warning {\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n  border: 1px solid #fecaca;\n  border-radius: 16px;\n  padding: 20px 24px;\n  color: #dc2626;\n  font-size: 15px;\n  line-height: 1.6;\n  margin: 24px 0 0 0;\n  font-weight: 600;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.1);\n}\n\n.bulk-delete-warning::before {\n  content: '⚠️';\n  margin-right: 10px;\n  font-size: 18px;\n  display: inline-block;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.1); }\n}\n\n/* Enhanced modal actions for bulk delete */\n.bulk-delete-actions {\n  display: flex;\n  gap: 16px;\n  padding: 24px 28px 28px;\n  justify-content: center;\n  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);\n  border-top: 1px solid #e5e7eb;\n}\n\n.bulk-delete-cancel-btn {\n  background: white;\n  color: #6b7280;\n  border: 2px solid #e5e7eb;\n  padding: 14px 28px;\n  border-radius: 14px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  min-width: 140px;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.bulk-delete-cancel-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\n  transition: left 0.5s;\n}\n\n.bulk-delete-cancel-btn:hover::before {\n  left: 100%;\n}\n\n.bulk-delete-cancel-btn:hover {\n  background: #f9fafb;\n  border-color: #d1d5db;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  color: #374151;\n}\n\n.bulk-delete-confirm-btn {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  color: white;\n  border: none;\n  padding: 14px 28px;\n  border-radius: 14px;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  min-width: 180px;\n  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.3);\n  position: relative;\n  overflow: hidden;\n}\n\n.bulk-delete-confirm-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s;\n}\n\n.bulk-delete-confirm-btn:hover::before {\n  left: 100%;\n}\n\n.bulk-delete-confirm-btn:hover {\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4);\n}\n\n.bulk-delete-confirm-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.3);\n}\n\n.bulk-delete-confirm-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Mobile responsiveness for bulk delete */\n@media (max-width: 768px) {\n  .documents-to-delete {\n    max-height: 250px;\n    padding: 12px;\n    border-radius: 12px;\n  }\n  \n  .document-to-delete {\n    padding: 12px 16px;\n    border-radius: 10px;\n    margin-bottom: 8px;\n  }\n  \n  .document-to-delete .document-icon {\n    width: 36px;\n    height: 36px;\n    font-size: 16px;\n  }\n  \n  .document-to-delete .document-info strong {\n    font-size: 14px;\n  }\n  \n  .document-to-delete .document-info small {\n    font-size: 11px;\n  }\n  \n  .bulk-delete-actions {\n    flex-direction: column;\n    gap: 12px;\n    padding: 20px 24px 24px;\n  }\n  \n  .bulk-delete-cancel-btn,\n  .bulk-delete-confirm-btn {\n    width: 100%;\n    min-width: auto;\n    padding: 16px 24px;\n  }\n}\n\n/* Dark mode support for bulk delete */\n@media (prefers-color-scheme: dark) {\n  .documents-to-delete {\n    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);\n    border-color: #374151;\n  }\n  \n  .document-to-delete {\n    background: #374151;\n    border-color: #4b5563;\n  }\n  \n  .document-to-delete:hover {\n    background: linear-gradient(135deg, #4b5563 0%, #374151 100%);\n  }\n  \n  .document-to-delete .document-info strong {\n    color: #f9fafb;\n  }\n  \n  .document-to-delete .document-info small {\n    background: linear-gradient(135deg, #4b5563, #374151);\n    color: #d1d5db;\n    border-color: #6b7280;\n  }\n  \n  .bulk-delete-warning {\n    background: linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%);\n    border-color: #dc2626;\n    color: #fecaca;\n  }\n  \n  .bulk-delete-actions {\n    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);\n    border-color: #374151;\n  }\n  \n  .bulk-delete-cancel-btn {\n    background: #374151;\n    color: #d1d5db;\n    border-color: #4b5563;\n  }\n  \n  .bulk-delete-cancel-btn:hover {\n    background: #4b5563;\n    border-color: #6b7280;\n    color: #f9fafb;\n  }\n}\n\n/* Smooth document list animations */\n.document-to-delete {\n  animation: slideInFromLeft 0.4s cubic-bezier(0.4, 0, 0.2, 1) both;\n}\n\n.document-to-delete:nth-child(1) { animation-delay: 0.1s; }\n.document-to-delete:nth-child(2) { animation-delay: 0.15s; }\n.document-to-delete:nth-child(3) { animation-delay: 0.2s; }\n.document-to-delete:nth-child(4) { animation-delay: 0.25s; }\n.document-to-delete:nth-child(5) { animation-delay: 0.3s; }\n.document-to-delete:nth-child(6) { animation-delay: 0.35s; }\n.document-to-delete:nth-child(7) { animation-delay: 0.4s; }\n.document-to-delete:nth-child(8) { animation-delay: 0.45s; }\n.document-to-delete:nth-child(9) { animation-delay: 0.5s; }\n.document-to-delete:nth-child(10) { animation-delay: 0.55s; }\n\n@keyframes slideInFromLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Enhanced scrollbar for documents list */\n.documents-to-delete::-webkit-scrollbar {\n  width: 6px;\n}\n\n.documents-to-delete::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 3px;\n}\n\n.documents-to-delete::-webkit-scrollbar-thumb {\n  background: linear-gradient(180deg, #3b82f6, #8b5cf6);\n  border-radius: 3px;\n}\n\n.documents-to-delete::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(180deg, #2563eb, #7c3aed);\n}\n\n/* Smooth loading state for bulk delete */\n.bulk-delete-loading {\n  position: relative;\n  overflow: hidden;\n}\n\n.bulk-delete-loading::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\n  animation: shimmer 1.5s infinite;\n}\n\n@keyframes shimmer {\n  0% { left: -100%; }\n  100% { left: 100%; }\n}\n\n/* Clean & Minimal Bulk Delete Modal - Refined Design */\n.documents-to-delete {\n  max-height: 300px;\n  overflow-y: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 0;\n  margin: 20px 0;\n  background: #fafafa;\n  box-shadow: none;\n  position: relative;\n}\n\n.documents-to-delete::before {\n  display: none; /* Remove colorful accent bar */\n}\n\n.document-to-delete {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 20px;\n  border: none;\n  background: white;\n  border-radius: 0;\n  margin-bottom: 0;\n  box-shadow: none;\n  transition: all 0.2s ease;\n  position: relative;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.document-to-delete::before {\n  display: none; /* Remove red accent line */\n}\n\n.document-to-delete:last-child {\n  border-bottom: none;\n  border-radius: 0 0 12px 12px;\n}\n\n.document-to-delete:first-child {\n  border-radius: 12px 12px 0 0;\n}\n\n.document-to-delete:hover {\n  background: #f8fafc;\n  transform: none;\n  box-shadow: none;\n}\n\n.document-to-delete .document-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background: #f3f4f6;\n  border-radius: 8px;\n  color: #6b7280;\n  font-size: 16px;\n  box-shadow: none;\n  flex-shrink: 0;\n  border: 1px solid #e5e7eb;\n}\n\n.document-to-delete .document-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.document-to-delete .document-info strong {\n  display: block;\n  font-size: 14px;\n  color: #1f2937;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.4;\n}\n\n.document-to-delete .document-info small {\n  display: block;\n  font-size: 12px;\n  color: #9ca3af;\n  font-weight: 400;\n  text-transform: capitalize;\n  background: none;\n  padding: 0;\n  border-radius: 0;\n  width: auto;\n  border: none;\n}\n\n/* Clean warning text */\n.bulk-delete-warning {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 16px 20px;\n  color: #dc2626;\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 20px 0 0 0;\n  font-weight: 500;\n  position: relative;\n  overflow: hidden;\n  box-shadow: none;\n}\n\n.bulk-delete-warning::before {\n  content: '⚠️';\n  margin-right: 8px;\n  font-size: 16px;\n  display: inline-block;\n  animation: none; /* Remove pulse animation */\n}\n\n/* Clean modal actions */\n.bulk-delete-actions {\n  display: flex;\n  gap: 12px;\n  padding: 20px 28px 28px;\n  justify-content: center;\n  background: #fafafa;\n  border-top: 1px solid #e5e7eb;\n}\n\n.bulk-delete-cancel-btn {\n  background: white;\n  color: #6b7280;\n  border: 1px solid #d1d5db;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 120px;\n  position: relative;\n  overflow: hidden;\n  box-shadow: none;\n}\n\n.bulk-delete-cancel-btn::before {\n  display: none; /* Remove shimmer effect */\n}\n\n.bulk-delete-cancel-btn:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n  transform: none;\n  box-shadow: none;\n  color: #374151;\n}\n\n.bulk-delete-confirm-btn {\n  background: #dc2626;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 160px;\n  box-shadow: none;\n  position: relative;\n  overflow: hidden;\n}\n\n.bulk-delete-confirm-btn::before {\n  display: none; /* Remove shimmer effect */\n}\n\n.bulk-delete-confirm-btn:hover {\n  background: #b91c1c;\n  transform: none;\n  box-shadow: none;\n}\n\n.bulk-delete-confirm-btn:active {\n  transform: none;\n  box-shadow: none;\n}\n\n.bulk-delete-confirm-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Remove all animations for cleaner look */\n.document-to-delete {\n  animation: none;\n}\n\n.document-to-delete:nth-child(1),\n.document-to-delete:nth-child(2),\n.document-to-delete:nth-child(3),\n.document-to-delete:nth-child(4),\n.document-to-delete:nth-child(5),\n.document-to-delete:nth-child(6),\n.document-to-delete:nth-child(7),\n.document-to-delete:nth-child(8),\n.document-to-delete:nth-child(9),\n.document-to-delete:nth-child(10) {\n  animation-delay: 0s;\n}\n\n/* Clean scrollbar */\n.documents-to-delete::-webkit-scrollbar {\n  width: 6px;\n}\n\n.documents-to-delete::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.documents-to-delete::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.documents-to-delete::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n  .documents-to-delete {\n    max-height: 250px;\n    border-radius: 8px;\n  }\n  \n  .document-to-delete {\n    padding: 12px 16px;\n  }\n  \n  .document-to-delete .document-icon {\n    width: 32px;\n    height: 32px;\n    font-size: 14px;\n  }\n  \n  .document-to-delete .document-info strong {\n    font-size: 13px;\n  }\n  \n  .document-to-delete .document-info small {\n    font-size: 11px;\n  }\n  \n  .bulk-delete-actions {\n    flex-direction: column;\n    gap: 10px;\n    padding: 16px 20px 20px;\n  }\n  \n  .bulk-delete-cancel-btn,\n  .bulk-delete-confirm-btn {\n    width: 100%;\n    min-width: auto;\n    padding: 14px 20px;\n  }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  .documents-to-delete {\n    background: #1f2937;\n    border-color: #374151;\n  }\n  \n  .document-to-delete {\n    background: #374151;\n    border-color: #4b5563;\n  }\n  \n  .document-to-delete:hover {\n    background: #4b5563;\n  }\n  \n  .document-to-delete .document-icon {\n    background: #4b5563;\n    color: #9ca3af;\n    border-color: #6b7280;\n  }\n  \n  .document-to-delete .document-info strong {\n    color: #f9fafb;\n  }\n  \n  .document-to-delete .document-info small {\n    color: #9ca3af;\n  }\n  \n  .bulk-delete-warning {\n    background: #7f1d1d;\n    border-color: #dc2626;\n    color: #fecaca;\n  }\n  \n  .bulk-delete-actions {\n    background: #1f2937;\n    border-color: #374151;\n  }\n  \n  .bulk-delete-cancel-btn {\n    background: #374151;\n    color: #d1d5db;\n    border-color: #4b5563;\n  }\n  \n  .bulk-delete-cancel-btn:hover {\n    background: #4b5563;\n    border-color: #6b7280;\n    color: #f9fafb;\n  }\n}\n\n/* Compact Bulk Delete Modal - Space Efficient */\n.documents-to-delete {\n  max-height: 200px; /* Reduced from 300px */\n  overflow-y: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 0;\n  margin: 16px 0; /* Reduced margin */\n  background: #fafafa;\n  box-shadow: none;\n  position: relative;\n}\n\n.document-to-delete {\n  display: flex;\n  align-items: center;\n  gap: 12px; /* Reduced gap */\n  padding: 10px 16px; /* Reduced padding */\n  border: none;\n  background: white;\n  border-radius: 0;\n  margin-bottom: 0;\n  box-shadow: none;\n  transition: all 0.2s ease;\n  position: relative;\n  border-bottom: 1px solid #f3f4f6;\n  min-height: 48px; /* Fixed height for consistency */\n}\n\n.document-to-delete:last-child {\n  border-bottom: none;\n  border-radius: 0 0 8px 8px;\n}\n\n.document-to-delete:first-child {\n  border-radius: 8px 8px 0 0;\n}\n\n.document-to-delete:hover {\n  background: #f8fafc;\n  transform: none;\n  box-shadow: none;\n}\n\n.document-to-delete .document-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px; /* Reduced from 36px */\n  height: 28px; /* Reduced from 36px */\n  background: #f3f4f6;\n  border-radius: 6px; /* Reduced from 8px */\n  color: #6b7280;\n  font-size: 14px; /* Reduced from 16px */\n  box-shadow: none;\n  flex-shrink: 0;\n  border: 1px solid #e5e7eb;\n}\n\n.document-to-delete .document-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px; /* Reduced gap */\n  justify-content: center; /* Center content vertically */\n}\n\n.document-to-delete .document-info strong {\n  display: block;\n  font-size: 13px; /* Reduced from 14px */\n  color: #1f2937;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.3; /* Tighter line height */\n}\n\n.document-to-delete .document-info small {\n  display: block;\n  font-size: 11px; /* Reduced from 12px */\n  color: #9ca3af;\n  font-weight: 400;\n  text-transform: capitalize;\n  background: none;\n  padding: 0;\n  border-radius: 0;\n  width: auto;\n  border: none;\n  line-height: 1.2; /* Tighter line height */\n}\n\n/* Compact warning text */\n.bulk-delete-warning {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 6px; /* Reduced from 8px */\n  padding: 12px 16px; /* Reduced padding */\n  color: #dc2626;\n  font-size: 13px; /* Reduced from 14px */\n  line-height: 1.4; /* Tighter line height */\n  margin: 16px 0 0 0; /* Reduced margin */\n  font-weight: 500;\n  position: relative;\n  overflow: hidden;\n  box-shadow: none;\n}\n\n.bulk-delete-warning::before {\n  content: '⚠️';\n  margin-right: 6px; /* Reduced margin */\n  font-size: 14px; /* Reduced from 16px */\n  display: inline-block;\n  animation: none;\n}\n\n/* Compact modal actions */\n.bulk-delete-actions {\n  display: flex;\n  gap: 10px; /* Reduced gap */\n  padding: 16px 20px 20px; /* Reduced padding */\n  justify-content: center;\n  background: #fafafa;\n  border-top: 1px solid #e5e7eb;\n}\n\n.bulk-delete-cancel-btn {\n  background: white;\n  color: #6b7280;\n  border: 1px solid #d1d5db;\n  padding: 10px 20px; /* Reduced padding */\n  border-radius: 6px; /* Reduced from 8px */\n  font-size: 13px; /* Reduced from 14px */\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 100px; /* Reduced from 120px */\n  position: relative;\n  overflow: hidden;\n  box-shadow: none;\n}\n\n.bulk-delete-confirm-btn {\n  background: #dc2626;\n  color: white;\n  border: none;\n  padding: 10px 20px; /* Reduced padding */\n  border-radius: 6px; /* Reduced from 8px */\n  font-size: 13px; /* Reduced from 14px */\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 140px; /* Reduced from 160px */\n  box-shadow: none;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Alternative compact layout for many documents */\n.documents-to-delete.compact-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr; /* Two columns */\n  gap: 1px;\n  background: #e5e7eb;\n  padding: 1px;\n  border-radius: 8px;\n  max-height: 180px;\n}\n\n.documents-to-delete.compact-grid .document-to-delete {\n  background: white;\n  border: none;\n  border-radius: 0;\n  margin: 0;\n  min-height: 40px;\n  padding: 8px 12px;\n}\n\n.documents-to-delete.compact-grid .document-to-delete:nth-child(odd) {\n  border-radius: 0;\n}\n\n.documents-to-delete.compact-grid .document-to-delete:nth-child(even) {\n  border-radius: 0;\n}\n\n.documents-to-delete.compact-grid .document-to-delete .document-icon {\n  width: 24px;\n  height: 24px;\n  font-size: 12px;\n}\n\n.documents-to-delete.compact-grid .document-to-delete .document-info strong {\n  font-size: 12px;\n}\n\n.documents-to-delete.compact-grid .document-to-delete .document-info small {\n  font-size: 10px;\n}\n\n/* Mobile responsiveness for compact design */\n@media (max-width: 768px) {\n  .documents-to-delete {\n    max-height: 160px; /* Even more compact on mobile */\n    border-radius: 6px;\n  }\n  \n  .document-to-delete {\n    padding: 8px 12px;\n    min-height: 44px;\n  }\n  \n  .document-to-delete .document-icon {\n    width: 24px;\n    height: 24px;\n    font-size: 12px;\n  }\n  \n  .document-to-delete .document-info strong {\n    font-size: 12px;\n  }\n  \n  .document-to-delete .document-info small {\n    font-size: 10px;\n  }\n  \n  .bulk-delete-actions {\n    flex-direction: column;\n    gap: 8px;\n    padding: 12px 16px 16px;\n  }\n  \n  .bulk-delete-cancel-btn,\n  .bulk-delete-confirm-btn {\n    width: 100%;\n    min-width: auto;\n    padding: 12px 16px;\n  }\n  \n  /* Single column on mobile for grid layout */\n  .documents-to-delete.compact-grid {\n    grid-template-columns: 1fr;\n    max-height: 140px;\n  }\n}\n\n/* Dark mode support for compact design */\n@media (prefers-color-scheme: dark) {\n  .documents-to-delete {\n    background: #1f2937;\n    border-color: #374151;\n  }\n  \n  .document-to-delete {\n    background: #374151;\n    border-color: #4b5563;\n  }\n  \n  .document-to-delete:hover {\n    background: #4b5563;\n  }\n  \n  .document-to-delete .document-icon {\n    background: #4b5563;\n    color: #9ca3af;\n    border-color: #6b7280;\n  }\n  \n  .document-to-delete .document-info strong {\n    color: #f9fafb;\n  }\n  \n  .document-to-delete .document-info small {\n    color: #9ca3af;\n  }\n  \n  .bulk-delete-warning {\n    background: #7f1d1d;\n    border-color: #dc2626;\n    color: #fecaca;\n  }\n  \n  .bulk-delete-actions {\n    background: #1f2937;\n    border-color: #374151;\n  }\n  \n  .bulk-delete-cancel-btn {\n    background: #374151;\n    color: #d1d5db;\n    border-color: #4b5563;\n  }\n  \n  .bulk-delete-cancel-btn:hover {\n    background: #4b5563;\n    border-color: #6b7280;\n    color: #f9fafb;\n  }\n  \n  .documents-to-delete.compact-grid {\n    background: #374151;\n  }\n}\n/* Desktop / large screens */\n.create-account-container {\n  display: flex;\n  width: 100%;\n  height: 100vh; /* full viewport height */\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  overflow: auto;\n  border-radius: 0;\n}\n\n/* Left panel — take fixed width and full height */\n.create-account-left {\n  width: 40%;              /* adjust percentage as you like (e.g. 35%, 45%) */\n  background: #185adb;\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 48px;\n  box-sizing: border-box;\n  height: 100%;             /* full vertical stretch */\n  border-radius: 0;\n}\n\n/* Right panel — flexes to fill rest of screen */\n.create-account-right {\n  flex: 1;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  padding: 24px 32px;\n  box-sizing: border-box;\n  overflow: auto;     \n  border-radius: 0;\n  max-height: 100vh;\n}\n\n/* Scroll only form area */\n.create-account-right .form-scroll-area {\n  flex: 1;\n  overflow-y: auto;\n  width: 100%;\n  padding-right: 8px;\n  box-sizing: border-box;\n  max-height: 8vh;\n}\n\n/* Mobile view: stack panels vertically */\n@media (max-width: 950px) {\n  .create-account-container {\n    flex-direction: column;\n    height: 100vh;\n  }\n\n  .create-account-left {\n    width: 100%;\n    height: 40%; /* left section smaller on mobile */\n  }\n\n  .create-account-right {\n    width: 100%;\n    height: 60%; /* right section takes rest */\n    padding: 24px 16px;\n  }\n\n  .create-account-right .form-scroll-area {\n    padding-right: 0;\n  }\n}\n\n.nav-logo {\n  display: flex;\n  align-items: center; /* vertically centers the logo */\n  height: 125px; /* navbar height you want */\n}\n\n.logo-img {\n  max-height: 100%; /* fits the container's height */\n  width: auto;      /* maintains aspect ratio */\n  height: 170px;\n  object-fit: contain;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
